{
    "account": {
        "addSalesAccount": "+ Sales account",
        "create": {
            "additional": {
                "cocNumber": "KvK number",
                "subtitle": "We'll also fill in this information on your invoice template",
                "title": "Additional company details",
                "vatNumber": "VAT number"
            },
            "cancel": "Cancel",
            "company": {
                "address": "Address *",
                "city": "City *",
                "companyName": "Company name *",
                "email": "Email address * (for receiving customer emails)",
                "phone": "Phone number *",
                "subtitle": "We'll also fill in this information on your invoice template",
                "title": "Company details",
                "zipCode": "Zip code *"
            },
            "contentSub": "We'll use this information to serve you better",
            "contentTitle": "Let's get your account set up",
            "errors": {
                "address": "Enter your address",
                "city": "Enter your city",
                "companyAddress": "Enter the address",
                "companyCity": "Enter the city",
                "companyEmail": "Enter the email address",
                "companyName": "Enter the company name",
                "companyPhone": "Enter the phone number",
                "companyZipCode": "Enter the zip code",
                "email": "Enter your email address",
                "emailInvalid": "Enter a valid email address",
                "firstname": "Enter your first name",
                "invalidImage": "Only PNG, JPG, and JPEG images are allowed.",
                "invoicePrefix": "Enter the prefix",
                "invoiceStart": "Enter the starting number",
                "lastname": "Enter your last name",
                "phone": "Enter your phone number",
                "referralRequired": "This field is required",
                "setupFailed": "We couldn't set up your account.",
                "setupFailedTitle": "Setup failed",
                "subscriptionCheck": "We couldn't check whether you have an active subscription.",
                "zipCode": "Enter your zip code"
            },
            "finished": {
                "subtitle": "Your account is set up and ready to use.",
                "title": "Account set up"
            },
            "invoice": {
                "dropMessage": "Drag your logo here, or click to browse",
                "prefix": "Prefix *",
                "preview": "Preview:",
                "start": "Start at *",
                "subtitle": "We'll add these to the invoices",
                "supported": "Supported files: PNG, JPG, and JPEG",
                "title": "Company logo and invoice number"
            },
            "personal": {
                "address": "Address *",
                "city": "City *",
                "email": "Email address * (to log in with)",
                "firstname": "First name *",
                "firstnamePlaceholder": "Your first name",
                "lastname": "Last name *",
                "phone": "Phone number *",
                "subtitle": "So we can stay in touch",
                "title": "Personal details",
                "zipCode": "Zip code *"
            },
            "referral": {
                "bol": "Through Bol",
                "chooseOption": "Choose an option",
                "existingCustomer": "Word of mouth",
                "google": "Through Google",
                "googlePlaceholder": "Searched for keyword...",
                "other": "Other, namely...",
                "otherPlaceholder": "Found via...",
                "social": "Through social media (Facebook groups, X, Instagram, etc.)",
                "subtitle": "We'd love to know how you found us.",
                "title": "How did you find us?"
            },
            "step": {
                "back": "Back",
                "next": "Next",
                "skip": "Skip"
            },
            "welcome": {
                "start": "Get started",
                "text1": "Your account has been successfully created.",
                "text2": "Let's customize it to your liking.",
                "title": "Hi {{name}}, welcome to Bluemate!"
            }
        },
        "otherAccounts": "Other accounts",
        "ownAccounts": "Own accounts",
        "salesAccount": "Sales account:"
    },
    "accountSelect": {
        "back": "Back",
        "fetchFrom": "Fetch from:",
        "import": "Import"
    },
    "admin": {
        "account": {
            "back": "Back",
            "cancel": "Cancel",
            "close": "Close",
            "confirmTitle": "Confirm",
            "delete": "Delete",
            "deleteConfirmMsg": "Are you sure you want to delete this account?",
            "deleteFailedMsg": "Could not delete the account.",
            "deleteFailedTitle": "Delete failed",
            "deletedSnack": "The account has been deleted",
            "edit": "Edit",
            "field": {
                "address": "Address",
                "autoSend": "Auto-send emails",
                "city": "City",
                "cocNumber": "KvK number",
                "companyName": "Company name",
                "country": "Country",
                "email": "Email address",
                "iban": "IBAN",
                "invoicePrefix": "Invoice number",
                "invoiceStart": "Invoice number start",
                "participateKor": "KOR participant",
                "telNumber": "Phone number",
                "useBolText": "Use Bol text",
                "usePlatformText": "Use Bluemate text",
                "vatNumber": "VAT number",
                "zipCode": "Zip code"
            },
            "no": "No",
            "off": "Off",
            "on": "On",
            "save": "Save",
            "section": {
                "account": "Account",
                "settings": "Settings"
            },
            "title": "Account details",
            "updateFailedMsg": "Could not update the account.",
            "updateFailedTitle": "Update failed",
            "updatedSnack": "The account has been updated",
            "validation": {
                "address": "Address cannot be empty",
                "city": "City cannot be empty",
                "coc": "KvK number cannot be empty",
                "companyName": "Company name cannot be empty",
                "country": "Country cannot be empty",
                "emailEmpty": "Email address cannot be empty",
                "emailInvalid": "Email address is not valid",
                "telNumber": "Phone number cannot be empty",
                "zipCode": "Zip code cannot be empty"
            },
            "yes": "Yes"
        },
        "adminProcess": {
            "col": {
                "account": "ACCOUNT",
                "companyName": "COMPANY NAME",
                "email": "EMAIL ADDRESS",
                "id": "ID",
                "name": "NAME",
                "startedAt": "STARTED AT",
                "status": "STATUS",
                "subscription": "SUBSCRIPTION"
            },
            "deleteFailedMsg": "Could not delete the process.",
            "deletedSnack": "The process has been deleted",
            "filter": "Filter",
            "imports": "Imports",
            "linkedAccounts": "Connected accounts",
            "loadAccountsFailedMsg": "Could not load the accounts.",
            "loadAccountsFailedTitle": "Account not found",
            "loadUsersFailedMsg": "Could not load the users.",
            "loadUsersFailedTitle": "Loading failed",
            "noProcesses": "No processes found",
            "search": "Search",
            "selectUser": "Select a user",
            "users": "Users"
        },
        "bar": {
            "id": "ID",
            "name": "Name",
            "selectedAccount": "Selected account",
            "selectedUser": "Selected user"
        },
        "churn": {
            "calculate": "Calculate",
            "close": "Close",
            "col": {
                "active": "ACTIVE",
                "canceled": "CANCELED",
                "expired": "EXPIRED",
                "free": "FREE",
                "inactive": "INACTIVE",
                "period": "PERIOD",
                "registered": "REGISTERED",
                "trialing": "TRIALING"
            },
            "datePlaceholder": "mm-dd-yyyy",
            "display": "Display",
            "fromDate": "From date",
            "loadFailedMsg": "Could not calculate churn.",
            "loadFailedTitle": "Churn calculation failed",
            "split": {
                "day": "Per day",
                "hour": "Per hour",
                "month": "Per month",
                "quarter": "Per quarter",
                "week": "Per week",
                "year": "Per year"
            },
            "title": "Subscription churn",
            "toDate": "To date"
        },
        "connections": {
            "confirmTitle": "Confirm",
            "disable": "disable",
            "disabled": "disabled",
            "enable": "enable",
            "enabled": "enabled",
            "lastChanged": "Last changed",
            "maintenance": "Maintenance",
            "maintenanceModeIs": "Maintenance mode is",
            "na": "n/a",
            "no": "No",
            "pageReloading": "the page is reloading",
            "status": {
                "down": "Down",
                "unstable": "Unstable",
                "up": "Up"
            },
            "title": "Connections",
            "toggleConfirmPrefix": "Are you sure you want to",
            "toggleFailedMsg": "Could not change maintenance mode.",
            "yes": "Yes"
        },
        "copiedToClipboardSuffix": "copied to clipboard",
        "defaultEmails": {
            "disabled": "Disabled",
            "editor": {
                "changesSavedSnack": "Changes have been saved",
                "deleteConfirmMsg": "Are you sure you want to permanently delete this email template?",
                "deleteConfirmTitle": "Delete template",
                "deleteFailedMsg": "Could not delete the template.",
                "deleteFailedTitle": "Delete failed",
                "deleteTemplate": "Delete template",
                "deletedSnack": "The template has been deleted",
                "disabled": "Disabled",
                "enabled": "Enabled",
                "errorTitle": "Error",
                "flow": {
                    "creditInvoice": "Credit invoice",
                    "invoice": "Invoice",
                    "reviewInvoice": "Review + Invoice"
                },
                "flows": "Flows",
                "hide": "Hide",
                "loadFailedTitle": "Loading failed",
                "nameLabel": "Template name",
                "namePlaceholder": "Name of the template",
                "no": "No",
                "notFoundMsg": "The template could not be found.",
                "previewOptions": "Preview options",
                "save": "Save",
                "saveChangesFailedMsg": "Could not save the changes.",
                "saveFailedMsg": "Could not save the template.",
                "saveFailedTitle": "Save failed",
                "savedSnack": "The template has been saved",
                "sendTest": "Send test",
                "statusLabel": "Status",
                "subjectLabel": "Email subject",
                "subjectPlaceholder": "Default subject of the email",
                "testFailedMsg": "Could not send the test email.",
                "testFailedTitle": "Send failed",
                "testSentTo": "The test email has been sent to",
                "validation": {
                    "content": "The template has no content.",
                    "flow": "Select at least one flow.",
                    "name": "Give the template a name.",
                    "preview": "You cannot activate the template without a preview.",
                    "subject": "Enter the subject."
                },
                "yes": "Yes"
            },
            "empty": "No email templates found",
            "enabled": "Enabled",
            "flow": {
                "creditInvoice": "Credit invoice",
                "invoice": "Invoice",
                "reviewInvoice": "Review + Invoice"
            },
            "flowLabel": "Flow",
            "loadFailedMsg": "Loading failed.",
            "loadFailedTitle": "Loading failed",
            "newTemplate": "+ Create new template",
            "pagingOf": "of",
            "pagingTo": "to",
            "previewAlt": "Template preview",
            "searchLabel": "Search an email",
            "searchPlaceholder": "Email name",
            "status": "Status"
        },
        "emailSequence": {
            "after": "After",
            "datePlaceholder": "mm-dd-yyyy",
            "determiningCount": "Determining number of invoices...",
            "for": "for",
            "genericError": "Something went wrong.",
            "in": "in",
            "invoice": "invoice",
            "invoices": "invoices",
            "mailWithAttachment": "email with attachment",
            "noTemplate": "No template",
            "ordersFrom": "Orders from",
            "ordersTo": "Orders to",
            "selectEmails": "Select which emails should be sent",
            "selected": "selected",
            "send": "send",
            "settings": "Settings",
            "start": "Start",
            "startedSnack": "Processing has started",
            "to": "to",
            "via": "via"
        },
        "failedPayments": {
            "col": {
                "amountExcl": "AMOUNT EXCL.",
                "dateFailed": "DATE FAILED",
                "status": "STATUS",
                "stripeCustomerId": "STRIPE CUSTOMER ID",
                "user": "USER",
                "userId": "USER ID"
            },
            "copiedToClipboard": "copied to clipboard",
            "copyPaymentLink": "Copy payment link",
            "delete": "Delete",
            "deleteFailedMsg": "Could not delete the payment.",
            "deleteFailedTitle": "Delete failed",
            "deletedSnack": "The payment has been deleted",
            "emptyLabel": "- No payments found -",
            "generateFailedMsg": "Could not generate the invoice.",
            "generateFailedTitle": "Invoice generation failed",
            "generateNoSend": "Create new invoice (do not send)",
            "generatedSentSnack": "The invoice has been generated and sent",
            "hasOpenInvoices": "Already has open invoices",
            "invoicePaid": "Invoice paid",
            "loadFailedMsg": "Could not load the failed payments.",
            "loadFailedTitle": "Loading failed",
            "pagingOf": "of",
            "pagingTo": "to",
            "search": "Search",
            "searchPlaceholder": "Search a payment",
            "sendFailedMsg": "Could not send the invoice.",
            "sendFailedTitle": "Invoice send failed",
            "sendInvoice": "Send invoice",
            "sendNew": "Send new invoice",
            "sentSnack": "The invoice has been sent",
            "status": {
                "closed": "Invoice paid",
                "generated": "Invoice created",
                "new": "New",
                "sent": "Invoice sent"
            },
            "title": "Failed payments"
        },
        "historyImport": {
            "datePlaceholder": "mm-dd-yyyy",
            "firstPage": "First API page",
            "genericError": "Something went wrong.",
            "orderFrom": "(Optional) Import orders from",
            "prefix": "Invoice number prefix",
            "sendEmails": "Send emails",
            "settings": "Settings",
            "start": "Start",
            "startNumber": "Start invoice number",
            "startedSnack": "The import has started"
        },
        "platformUsage": {
            "accountsAdditional": "With additional users",
            "actions": "Actions",
            "active": "Paying owners",
            "additionalUsers": "Additional users",
            "adminImpersonation": "Admin impersonation",
            "admins": "Admins",
            "afterTrialPaying": "After trial (paying)",
            "aggregate": "Aggregate",
            "aggregatedWith": "Data is aggregated with",
            "aggregationDelay": "Aggregation delay (min 1 minute)",
            "aggregationDonePrefix": "Aggregation completed",
            "aggregationFailed": "Aggregation failed.",
            "all": "All",
            "allOf": "All",
            "analyticsSettings": "Analytics Settings",
            "autoMailOff": "Auto-send emails off",
            "autoMailOn": "Auto-send emails on",
            "back": "Back",
            "breakdown": {
                "featureGroup": "Feature group",
                "featureKey": "Feature"
            },
            "bucket": {
                "auto": "Auto",
                "day": "Day",
                "month": "Month",
                "week": "Week"
            },
            "cancel": "Cancel",
            "chart": {
                "platformActivity": "Platform activity over time",
                "totalUsers": "Total users on platform"
            },
            "clearAllData": "Clear all data",
            "clearData": "Clear data",
            "clearDataFailed": "Could not delete analytics data.",
            "clearFilter": "Clear filter",
            "clearModalTitle": "Clear analytics data",
            "clearWarn1": "This action will delete",
            "clearWarn2": "analytics records permanently. This includes:",
            "clickToAggregate": "Click the button below to aggregate collected events.",
            "confirmLabel": "I confirm that all analytics data should be permanently deleted and understand that this cannot be undone",
            "crumb": {
                "admin": "Admin",
                "platformUsage": "Platform usage"
            },
            "dailyAggregates": "daily aggregates",
            "dailyAggregatesRetention": "Daily aggregates retention (0 = unlimited)",
            "dataCleared": "All analytics data has been deleted.",
            "dataCollection": "Data collection",
            "days": "days",
            "detail": "Detail",
            "drillDown": "Drill-down",
            "emailSettingsTitle": "Email settings",
            "event": {
                "actionFailed": "Actions (failed)",
                "actionSuccess": "Actions (success)",
                "pageView": "Page views"
            },
            "eventType": "Event type",
            "events": "Events",
            "eventsAutoCollected": "Analytics events are automatically collected as soon as users use the platform.",
            "eventsNotStored": "Analytics events are NOT stored",
            "eventsProcessed": "events processed.",
            "eventsStored": "Analytics events are stored",
            "eventsWord": "events",
            "featureActivity": "Feature activity",
            "features": "features",
            "fetchError": "An error occurred while fetching the statistics.",
            "fetchFailed": "Could not fetch the statistics.",
            "filters": "Filters",
            "from": "From",
            "groupBy": "Group by",
            "groups": "groups",
            "inTrial": "In trial",
            "invalidRangeMsg1a": "The \"From\" date",
            "invalidRangeMsg1b": "is later than the \"To\" date",
            "invalidRangeMsg2": "Adjust the dates so that \"From\" is earlier than or equal to \"To\".",
            "invalidRangeTitle": "Invalid date range",
            "invoiceOnly": "Invoice email only",
            "invoiceReview": "Invoice + review request",
            "max31Days": "(max 31 days)",
            "metric": {
                "totalEvents": "Total events",
                "uniqueUsers": "Unique users"
            },
            "metricLabel": "Metric",
            "minutes": "minutes",
            "minutesDelay": "minutes delay",
            "noAnalyticsData": "No analytics data available.",
            "noDataPeriod": "No data available for the selected period.",
            "noDataToClear": "There is no data to clear",
            "noDrillDownData": "No drill-down data available.",
            "noFilterResults": "The current filter settings return no results for Feature activity.",
            "noFilterResultsExplanation": "The collected data may be for user types other than those selected in the \"User type\" section, or there are no events in the selected period.",
            "noGrowthData": "No user growth data available for the selected period.",
            "noReplyOff": "No-reply tracking off",
            "noReplyOn": "No-reply tracking on",
            "notificationsByType": "Notifications (by type)",
            "notificationsModule": "Notifications module (subscription)",
            "orderFree": "Order (free)",
            "pageTitle": "Platform usage",
            "pageViews": "Page views",
            "pending": "pending",
            "pendingReadyIn": "pending (ready in",
            "period": "Period",
            "rawEvents": "raw events",
            "rawRetention": "Raw events retention (max",
            "readyForAggregation": "ready for aggregation",
            "records": "records",
            "refresh": "Refresh",
            "regularUsers": "Regular users",
            "resetFilters": "Reset filters",
            "retention": "Data Retention & Aggregation",
            "runAggregation": "Run aggregation",
            "saveSettings": "Save settings",
            "searchPlaceholder": "Email, name, phone...",
            "searchUser": "Search user",
            "settingsConflict": "The settings have meanwhile been changed by another admin.",
            "settingsSaveFailed": "Could not save the settings.",
            "settingsSaved": "Settings saved.",
            "tbl": {
                "actionsTotal": "Actions (total)",
                "actionsUnique": "Actions (unique)",
                "conversion": "Conversion %",
                "group": "Group",
                "name": "Name",
                "viewsTotal": "Views (total)",
                "viewsUnique": "Views (unique)"
            },
            "timeout": "The request took too long. Please try again.",
            "to": "To",
            "topN": {
                "all": "All"
            },
            "topNLabel": "Top N",
            "topWord": "Top",
            "totalActive": "Total active",
            "totalAdditional": "Total additional users",
            "totalUsersSeriesName": "Total users",
            "tryOtherPeriod": "Try a different period, select different user types, or reset the filters.",
            "usageAnalytics": "Usage Analytics",
            "userDayRecords": "user-day records",
            "userDayRetention": "User-day retention (max",
            "userGrowth": "User growth",
            "userType": "User type",
            "wait": "Wait",
            "warning": "Warning",
            "additionalTooltipAccountsDesc": "Left: accounts with more than one user. Right: unique paying owners with at least one additional user in their owned stores.",
            "additionalTooltipIntro": "Additional users across all accounts and paying owners.",
            "additionalTooltipTotalDesc": "Left: sum of additional users per account. Right: unique additional people in paying owners’ stores, excluding owners of that store. Each person counts once across stores. This number may exceed the number of paying owners.",
            "aggregationDelayLabel": "Aggregation delay",
            "aggregationTooltipCooldownDesc": "After running, you must wait {{minutes}} minutes before you can aggregate again. This applies to all administrators.",
            "aggregationTooltipDelayDesc": "Events must be at least {{delay}} minutes old before they can be aggregated (to prevent race conditions).",
            "aggregationTooltipDelayLabel": "Delay",
            "aggregationTooltipDesc": "This button runs data aggregation immediately, without waiting for automatic processing (every {{delay}} minutes).",
            "aggregationTooltipTitle": "Manual aggregation",
            "chartTooltipActivityLabel": "Platform activity",
            "chartTooltipActivityTotal": "Shows total number of events in the selected period.",
            "chartTooltipActivityUnique": "Shows unique users who used features in the selected period.",
            "chartTooltipIntro": "These charts show feature usage based on the selected filters.",
            "chartTooltipTopFeatures": "Shows the most popular features.",
            "chartTooltipTopGroups": "Shows the most popular feature groups.",
            "chartTooltipTopLabel": "Top groups/features",
            "clearWarnIrreversible": "This action cannot be undone. All historical analytics data will be lost.",
            "columnActiveDesc": "Unique owners with subscription status active, past_due or unpaid, matching Active on Users; excluding the demo account. Users without an owned store count as off. Each owner counts once per category if at least one owned store qualifies. Off means enabled in none of their stores. Invoice categories are determined per store; an owner can appear in both categories.",
            "columnAllDesc": "All accounts.",
            "deliveryRate1h": "Confirmation rate (past hour)",
            "deliveryRate24h": "Confirmation rate (today)",
            "deliveryRate7d": "Confirmation rate (this week)",
            "emailTooltipAutoDesc": "Whether automatic email sending is enabled (at least one active email flow).",
            "emailTooltipAutoLabel": "Automatic mailing on/off",
            "emailTooltipIntro": "Overview of email settings per account.",
            "emailTooltipInvoiceDesc": "Accounts that only send invoice emails.",
            "emailTooltipReviewDesc": "Accounts that send both invoice and review emails.",
            "emailTooltipTrackingDesc": "Whether no-reply tracking (with read confirmations) is enabled.",
            "emailTooltipTrackingLabel": "No-reply tracking",
            "eventTooltipFailed": "Failed actions (e.g. validation errors).",
            "eventTooltipPageView": "Page visits — when a user opens a page.",
            "eventTooltipSuccess": "Successful actions such as saving, exporting, sending.",
            "groupByTooltipFeature": "Shows individual features (e.g. settings.api, invoices.list).",
            "groupByTooltipGroup": "Groups by category (e.g. Settings, Invoices, Emails).",
            "growthTooltip1": "This is the running total of registered users on the platform.",
            "growthTooltip2": "This chart shows the total number of accounts, not how many users used a specific feature (like in \"Feature activity\" above).",
            "growthTooltip3": "Only the From-To and Period filters apply to this chart.",
            "metricTooltipTotal": "Counts each page visit separately.",
            "metricTooltipUnique": "Counts how many different people visited the page.",
            "other": "Other",
            "notifModuleAfterTrialDesc": "Subscriptions paying for notifications (after trial period).",
            "notifModuleInTrialDesc": "Subscriptions with the notification module in trial.",
            "notifModuleTooltipIntro": "Status of the paid notification module per subscription.",
            "notifModuleTotalDesc": "Total number of active notification modules (paid + trial + free, excluding cancelled).",
            "notifTypeBuyBox": "Notifications about Buy Box changes.",
            "notifTypeOrder": "Free order notifications.",
            "notifTypeReviews": "Notifications about new reviews.",
            "notifTypeStock": "Notifications about stock changes.",
            "notifTypeTooltipIntro": "Number of accounts with active notifications per type.",
            "periodTooltipAuto": "Automatically chooses the best period based on the date range.",
            "periodTooltipDay": "Shows data per day (only available for a range of up to 31 days).",
            "periodTooltipMonth": "Groups data per month.",
            "periodTooltipWeek": "Groups data per week.",
            "pushActiveDevices": "Active devices",
            "pushActiveDevicesInfo": "Number of unique devices with an active web push subscription seen recently (within the configured retention window). Duplicate subscriptions of the same device count as one.",
            "pushCounterRetention": "Delivery statistics retention (max 365 days)",
            "pushCounters": "push delivery statistics",
            "pushDeliveryInfo1": "Overview of web push delivery statistics.",
            "pushDeliveryNote": "Actual delivery is higher than the confirmation rate: confirmations require an active session (cookie) and duplicate confirmations of the same push are not counted.",
            "pushDeliveryOfflineNote": "Offline devices: when a device is offline, the push message is queued by the push service for up to 24 hours. The confirmation is only counted when the device comes back online. This may cause the \"last hour\" rate to appear temporarily lower. The \"today\" and \"this week\" periods give a more accurate picture as they cover a wider time window.",
            "pushDeliveryRate": "Confirmation rate",
            "pushDeliveryRateInfo": "Percentage of sent pushes confirmed as received by the service worker. The count (confirmed/sent) is shown next to the percentage.",
            "pushDeliverySettings": "Web Push Cleanup",
            "pushDeliveryTitle": "Web Push Delivery",
            "pushDeliveryTooltipTitle": "Web Push Delivery",
            "pushInactiveDevices": "Inactive devices",
            "pwaInstallInfo": "Overview of unique push devices per platform (duplicate subscriptions of the same device count as one; only recently seen subscriptions count as active). This provides an indication of PWA usage, as push subscriptions require an installed app on mobile devices.",
            "pwaInstallTitle": "Push devices",
            "pushInactiveDevicesInfo": "Devices without a recently seen active subscription: deactivated by a failed delivery (410/404), not seen within the configured retention window, or superseded by a newer registration of the same device.",
            "pushStaleTokenDays": "Delete inactive devices after (max 365 days)",
            "pushUnconfirmedThreshold": "Delete device after unconfirmed pushes",
            "webPushCleanupEnabled": "Automatically delete inactive devices",
            "webPushCleanupEnabledDesc": "Devices whose 'last seen' is older than the configured number of days are deleted automatically",
            "webPushCleanupDisabledDesc": "Devices are NEVER automatically deleted for inactivity",
            "webPushUnconfirmedCleanupEnabled": "Delete device after unconfirmed pushes",
            "webPushUnconfirmedCleanupEnabledDesc": "A device is deleted once the configured number of pushes goes unconfirmed",
            "webPushUnconfirmedCleanupDisabledDesc": "Devices are never deleted for unconfirmed pushes",
            "pushTrayLimit": "Maximum visible notifications per device (1-20)",
            "notifications": "notifications",
            "pushes": "pushes",
            "deactivatedUnconfirmed7d": "Deactivated (unconfirmed, this week)",
            "searchTooltip": "Searches in: email address, first name, last name, phone number and company name of the account.",
            "settingsTooltipCollection": "When disabled, no new analytics events are stored.",
            "settingsTooltipDelay": "Time before events are aggregated (prevents race conditions).",
            "settingsTooltipIntro": "Manage analytics data collection and storage here.",
            "settingsTooltipRetention": "After the specified period, old records are automatically deleted.",
            "topNTooltipAll": "Shows all available items.",
            "topNTooltipIntro": "Determines how many items are displayed in the chart and table.",
            "topTableTooltip": "This table shows the most used features or groups based on the selected filters. Click \"Detail\" to zoom in on a specific feature. After clicking Detail, you can select a subgroup to further refine the view and see a detailed chart.",
            "total": "Total",
            "userTypeTooltipAdminDesc": "Admin/support accounts.",
            "userTypeTooltipImpersonateDesc": "Admin logged in as another user.",
            "userTypeTooltipNone": "No selection",
            "userTypeTooltipNoneDesc": "Shows all users.",
            "userTypeTooltipRegularDesc": "Regular users (non-admins).",
            "allAccounts": "All accounts"
        },
        "systemService": {
            "allServices": "All services",
            "allServicesAre": "All services are",
            "back": "Back",
            "changeFailedMsg": "Could not change the services.",
            "confirmTitle": "Confirm",
            "crumb": {
                "admin": "Admin",
                "services": "Services"
            },
            "disableAll": "Disable all",
            "disableVerb": "disable",
            "disabled": "disabled",
            "enableAll": "Enable all",
            "enableVerb": "enable",
            "enabled": "enabled",
            "failedSuffix": "failed",
            "no": "No",
            "ofServiceFailed": "of the service failed.",
            "off": "off",
            "on": "on",
            "onLabel": "on",
            "serviceIs": "The service is",
            "switchSuffix": "switch",
            "switchedSuffix": "switched",
            "theWord": "The",
            "toggleAllConfirm1": "Are you sure you want to",
            "toggleAllConfirm2": "all services?",
            "toggleServiceConfirm": "Are you sure you want to",
            "yes": "Yes"
        },
        "threads": {
            "activeThreads": "Active threads",
            "back": "Back",
            "col": {
                "account": "ACCOUNT",
                "processId": "PROCESS ID",
                "status": "STATUS",
                "statusChanged": "STATUS CHANGED",
                "type": "TYPE"
            },
            "crumb": {
                "admin": "Admin",
                "threads": "Threads"
            },
            "empty": "No threads found",
            "finish": "Finish",
            "finishFailedMsg": "Could not finish the thread.",
            "finishFailedTitle": "Finish failed",
            "finishedSnack": "The thread has been finished",
            "idCopied": "ID copied to clipboard",
            "lastUpdated": "Last updated",
            "na": "n/a",
            "no": "No",
            "pagingOf": "of",
            "pagingTo": "to",
            "stop": "Stop",
            "stopConfirm": "Are you sure you want to stop this thread?",
            "stopFailedMsg": "Could not stop the thread.",
            "stopFailedTitle": "Stop failed",
            "stopTitle": "Stop thread",
            "stoppingSnack": "The thread is being stopped",
            "yes": "Yes"
        },
        "userSelection": {
            "active": "Active",
            "all": "All",
            "col": {
                "email": "Email address",
                "id": "ID",
                "name": "Name",
                "paymentMethod": "Has payment method",
                "subStarted": "Subscription started",
                "subStatus": "Subscription status"
            },
            "copiedToClipboard": "copied to clipboard",
            "createdAfter": "Account created after",
            "createdBefore": "Account created before",
            "datePlaceholder": "mm-dd-yyyy",
            "empty": "- No users selected -",
            "exportFailedMsg": "Could not export the users.",
            "exportFailedTitle": "Export failed",
            "exportUsers": "Export users",
            "filters": "Filters",
            "inactive": "Inactive",
            "includeFree": "Include free",
            "includeTrial": "Include trial",
            "includeUnpaid": "Include unpaid",
            "no": "No",
            "noUsersSelected": "No users selected",
            "registrationDate": "Registration date",
            "selectFailedMsg": "Could not select the users.",
            "selectFailedTitle": "Selection failed",
            "selectUsers": "Select users",
            "status": "Status",
            "subscription": "Subscription",
            "yes": "Yes"
        },
        "users": {
            "back": "Back",
            "blocked": "Blocked",
            "churn": "Subscription churn",
            "clearFilters": "Clear filters",
            "col": {
                "createdAt": "CREATED AT",
                "email": "EMAIL ADDRESS",
                "lastLogin": "LAST LOGIN",
                "name": "NAME",
                "subscription": "SUBSCRIPTION"
            },
            "copyFailed": "Could not copy the ID.",
            "copyId": "Copy ID",
            "crumb": {
                "admin": "Admin",
                "users": "Users"
            },
            "details": {
                "accounts": "Accounts",
                "address": "Address",
                "back": "Back",
                "block": "Block",
                "blockVerb": "block",
                "canLoginWithCode": "The user can log in with the code",
                "cancel": "Cancel",
                "city": "City",
                "close": "Close",
                "codeGenerated": "Code generated",
                "col": {
                    "companyName": "COMPANY NAME",
                    "createdAt": "CREATED AT",
                    "status": "STATUS"
                },
                "confirmTitle": "Confirm",
                "country": "Country",
                "day": "day",
                "days": "days",
                "delete": "Delete",
                "deleteConfirm": "Are you sure you want to delete this user?",
                "deleteFailedMsg": "Could not delete the user.",
                "deleteFailedTitle": "Delete failed",
                "deletedSnack": "The user has been deleted",
                "edit": "Edit",
                "email": "Email address",
                "firstname": "First name",
                "generateAccessCode": "Generate access code",
                "lastname": "Last name",
                "loadAccountsFailedMsg": "Could not load the accounts.",
                "loadAccountsFailedTitle": "Account not found",
                "lockConfirm": "Are you sure you want to",
                "mailSent": "The email has been sent",
                "no": "No",
                "noSubscription": "No subscription",
                "off": "Off",
                "on": "On",
                "overrideEmail": "Override email policy",
                "overrideLimit": "Override limits",
                "resetTwoFactor": "Reset",
                "resetTwoFactorConfirm": "Are you sure two-factor authentication for this user should be reset?",
                "save": "Save",
                "status": "Status",
                "stripeId": "Stripe ID",
                "sub": {
                    "active": "Active",
                    "canceled": "Canceled",
                    "free": "Free",
                    "inactive": "Inactive",
                    "trial": "Trial",
                    "unpaid": "Unpaid"
                },
                "subStatus": "Subscription status",
                "subscription": "Subscription",
                "telNumber": "Phone number",
                "title": "User details",
                "tokenFailedMsg": "Could not generate the token.",
                "tokenFailedTitle": "Generation failed",
                "trialUntil": "Trial until",
                "twoFactor": "Two-factor authentication",
                "type": {
                    "admin": "Admin",
                    "premium": "Premium user",
                    "superAdmin": "Super admin",
                    "support": "Support",
                    "user": "User"
                },
                "typeLabel": "Type",
                "unblock": "Unblock",
                "unblockVerb": "unblock",
                "updateFailedMsg": "Could not update the user.",
                "updateFailedTitle": "Update failed",
                "updatedSnack": "The user has been updated",
                "validation": {
                    "address": "Address cannot be empty",
                    "city": "City cannot be empty",
                    "country": "Country cannot be empty",
                    "emailEmpty": "Email address cannot be empty",
                    "emailInvalid": "Email address is not valid",
                    "firstname": "First name cannot be empty",
                    "lastname": "Last name cannot be empty",
                    "telNumber": "Phone number cannot be empty",
                    "zipCode": "Zip code cannot be empty"
                },
                "yes": "Yes",
                "zipCode": "Zip code"
            },
            "detailsAction": "Details",
            "detailsLabel": "Details",
            "extraUser": "Extra user",
            "filter": {
                "accountId": "Account ID",
                "apply": "Apply",
                "cancel": "Cancel",
                "companyName": "Company name",
                "customerId": "Customer ID",
                "email": "Email address",
                "firstname": "First name",
                "lastname": "Last name",
                "title": "Filter customers",
                "userId": "User ID"
            },
            "filterAction": "Filter",
            "idCopied": "ID copied to clipboard",
            "loadFailedMsg": "Could not load the users.",
            "loadFailedTitle": "Loading failed",
            "login": "Log in",
            "loginFailedMsg": "Login failed.",
            "loginFailedTitle": "Login failed",
            "na": "n/a",
            "pagingOf": "of",
            "pagingTo": "to",
            "placeholder": {
                "companyName": "Company name",
                "createdAt": "Created at",
                "email": "Email address",
                "lastLogin": "Last login",
                "name": "Name",
                "status": "Status"
            },
            "search": "Search",
            "stats": {
                "active": "Active",
                "free": "Free",
                "inactive": "Inactive",
                "trial": "Trial"
            },
            "title": "Users"
        }
    },
    "adminNav": {
        "admin": "Admin",
        "cron": "Cron",
        "defaultTemplates": "Default templates",
        "failedPayments": "Failed payments",
        "platformUsage": "Platform usage",
        "sendEmails": "Send emails",
        "thirtyDayImport": "30-day import",
        "threads": "Threads log",
        "users": "Users"
    },
    "app": {
        "admin": {
            "account": "Account",
            "apiKey": "API key",
            "idCopied": "{{id}} copied",
            "user": "User"
        },
        "env": {
            "accept": "Acceptance environment",
            "dev": "Develop environment",
            "test": "Test environment"
        },
        "mobileReadyHint": "Pages that do work well on your phone are marked in the menu with this label:",
        "mobileWarning": "This page is not optimized for mobile devices yet. Use a laptop or desktop for it."
    },
    "auth": {
        "forgotPassword": {
            "back": "Back",
            "emailInvalid": "Enter a valid email address",
            "emailLabel": "Email address",
            "emailPlaceholder": "Your email address",
            "emailRequired": "Enter your email address",
            "submit": "Send",
            "subtitle": "Enter your email address to reset your password",
            "successMessage": "If the email address matches a user in our database, an email has been sent with instructions to reset your password. It can take a few minutes for this email to arrive. We recommend you also check your spam folder.",
            "successTitle": "Reset password",
            "title": "Reset password",
            "connectionError": "Connection failed — check your internet and try again.",
            "failedTitle": "Sending failed"
        },
        "login": {
            "accountBlockedTitle": "Account blocked",
            "checkEmailNote": "90% of the time users mistype their email address.",
            "checkEmailQuestion": "Are you sure this is the correct email address?",
            "emailInvalid": "Enter a valid email address",
            "emailLabel": "Email address *",
            "emailPlaceholder": "Email address",
            "emailRequired": "Enter your email address",
            "forgotPassword": "Forgot password?",
            "genericError": "Something went wrong",
            "googleAccountMessage": "This email address is registered with Google. You can sign in using the Google sign-in button.",
            "googleAccountTitle": "Google account",
            "googleErrorMessage": "Something went wrong while connecting with Google.",
            "invalidCredentials": "Invalid email and password combination.",
            "loginFailedTitle": "Login failed",
            "noAccount": "Don't have an account yet?",
            "passwordLabel": "Password *",
            "passwordPlaceholder": "Password",
            "passwordRequired": "Enter your password",
            "register": "Register",
            "submit": "Log in",
            "subtitle": "Welcome to Bluemate",
            "title": "Log in to your account",
            "connectionError": "Connection failed — check your internet and try again."
        },
        "register": {
            "acceptTerms": "Accept the terms to register an account",
            "and": "and",
            "companiesUsingBluemate": "More than {{total}}+ companies use Bluemate!",
            "companyNameLabel": "Company name *",
            "companyNamePlaceholder": "Company name",
            "companyNameRequired": "Company name cannot be empty",
            "createAccount": "Create an account",
            "createAccountFailed": "We couldn't create the account.",
            "emailInUse": "The provided email address is already in use.",
            "emailInvalid": "The email address is not valid",
            "emailLabel": "Email address *",
            "emailPlaceholder": "Email address",
            "emailRequired": "Email address cannot be empty",
            "firstnameLabel": "First name *",
            "firstnamePlaceholder": "First name",
            "firstnameRequired": "First name cannot be empty",
            "freeTrialSubtitle": "Stops automatically. Renewable. No payment method required.",
            "freeTrialTitle": "Try it free for 30 days!",
            "googleErrorMessage": "Something went wrong while registering with Google.",
            "googleErrorTitle": "Registration failed",
            "haveAccount": "Already have a Bluemate account?",
            "invitationFailedTitle": "Invitation failed",
            "invitationNotFound": "The invitation could not be found.",
            "lastnameLabel": "Last name *",
            "lastnamePlaceholder": "Last name",
            "lastnameRequired": "Last name cannot be empty",
            "login": "Log in",
            "okButton": "OK",
            "or": "- or -",
            "passwordLabel": "Password *",
            "passwordPlaceholder": "Password",
            "passwordRequired": "Password cannot be empty",
            "privacyStatement": "Privacy statement",
            "processingAgreement": "Data processing agreement",
            "registrationFailedTitle": "Registration failed",
            "signupWithEmail": "Sign up with email address",
            "termsAgreePrefix": "I agree to the",
            "termsConditions": "Terms and conditions",
            "connectionError": "Connection failed — check your internet and try again."
        },
        "resetPassword": {
            "confirmPasswordLabel": "Repeat password",
            "confirmPasswordPlaceholder": "Repeat password",
            "confirmRequired": "Repeat the password",
            "failedMessage": "We couldn't change your password.",
            "failedTitle": "Change failed",
            "newPasswordLabel": "New password",
            "newPasswordPlaceholder": "New password",
            "passwordRequired": "Choose a new password",
            "passwordsMismatch": "The passwords do not match",
            "save": "Save",
            "subtitle": "Choose a new password",
            "successMessage": "Your account password has been changed. You can now log in with your new password.",
            "successTitle": "Password changed",
            "title": "Reset password",
            "connectionError": "Connection failed — check your internet and try again."
        }
    },
    "beta": {
        "popup": {
            "maybe": "Maybe",
            "no": "No",
            "q1": "Would you like to help us optimize our platform?",
            "q2": "We're currently looking for beta testers for our new \"VAT return assistance\" feature.",
            "q3": "You'll get first access to this new feature on our platform. By giving feedback you can help us improve it.",
            "q4": "Are you interested in joining this beta program?",
            "registeredMessage": "You've been signed up for the beta program and will soon receive more information about how to access the \"VAT return assistance\".",
            "registeredTitle": "Thanks for signing up!",
            "saveFailed": "Save failed",
            "saveFailedMessage": "We couldn't save your choice.",
            "title": "Beta testers wanted",
            "yes": "Yes"
        }
    },
    "bol": {
        "returnReason": {
            "defective": "Product is defective",
            "other": "Other",
            "wrongOrder": "Ordered by mistake",
            "wrongProduct": "Received the wrong product",
            "doesNotWork": "Product does not work",
            "cheaper": "Cheaper elsewhere",
            "noReason": "No reason",
            "productComplaint": "Complaint about product",
            "deliveryComplaint": "Complaint about delivery",
            "wrongSize": "Wrong size or dimensions"
        }
    },
    "chromeExtension": {
        "bottomButton": "Download the free Chrome Extension",
        "crumb": "Chrome Extension",
        "eyebrow": "Chrome Extension",
        "introDiscover": "Spot opportunities with this product research tool on bol.com.",
        "shareButton": "Share the link",
        "shareCopied": "The link is copied",
        "shareFailed": "Copying did not work",
        "shareText": "This Chrome Extension is free and publicly available. Do you know someone who would like to see a revenue estimate on every product on bol? Share the link with your friends or colleagues.",
        "shareTitle": "Share it with others",
        "title": "The revenue of every product on bol.com",
        "intro": "An estimate of the revenue and orders of every product on bol.",
        "storeButton": "Download the Chrome Extension",
        "ctaNote": "Free and public — no Bluemate or bol account needed",
        "featuresTitle": "What does the extension do?",
        "featureSalesTitle": "Estimate",
        "featureSalesText": "Our model calculates the number of sales and the revenue per month for products on bol. It uses the public product metadata that bol provides.",
        "featureEverywhereTitle": "In the search results",
        "featureEverywhereText": "The estimate appears in the search results and on the product page of bol.com itself.",
        "featureFreeTitle": "Public and free",
        "featureFreeText": "Our Chrome Extension is free for everyone - you need neither a Bluemate nor a bol account. Share it with your friends!",
        "shotsTitle": "What it looks like",
        "shotListAlt": "Estimated sales under products in bol.com search results",
        "shotListCaption": "An estimate of sales and revenue per month, right under every product in the search results.",
        "shotBadgeAlt": "The Bluemate sales badge under a product on bol.com",
        "shotBadgeCaption": "The badge up close: estimated sales and revenue per month.",
        "bottomTitle": "Try the free Chrome extension",
        "bottomText": "Install the extension in your Chrome browser. See the revenue of every product on bol.com. Free and public for everyone."
    },
    "common": {
        "apply": "Apply",
        "cancel": "Cancel",
        "close": "Close",
        "copy": "Copy",
        "dialog": {
            "defaultTitle": "System message",
            "ok": "OK"
        },
        "no": "No",
        "yes": "Yes"
    },
    "connectionComplete": {
        "autoUpload": {
            "decideLater": "Decide later",
            "info1": "Since June 2023, invoices can be uploaded directly to the Bol platform. If a customer requests an invoice, you are required to upload it to Bol within 24 hours. With Bluemate, you can stay ahead of invoice requests by proactively uploading invoices. In addition, Bluemate can automatically respond to your invoice requests by uploading the invoice.",
            "info2": "You can change this choice at any time and configure your specific upload preferences under the Requests section in the menu.",
            "subtitle": "This way you stay ahead of invoice requests.",
            "title": "Automatically upload invoices to Bol?"
        },
        "autoUploadOld": {
            "heading": "Invoice requests for old orders",
            "info1": "Your customers can request an invoice for orders up to 2 years back. It's possible that we don't have this order in our system, because your Bluemate account didn't exist yet at that time.",
            "info2": "We can still automatically respond to this invoice request with an invoice upload, but because the Tax Authorities require your invoice numbering to be chronologically ascending, we can't use the standard invoice number for this.",
            "info3": "You can therefore choose a different invoice number series for the invoices for old orders, this way the numbers stay chronologically ascending.",
            "subtitle": "These will be processed with a different invoice number series.",
            "title": "Automatically process invoice requests for older orders?"
        },
        "back": "Back",
        "configured": "Configured:",
        "custom": "Custom",
        "customInfo": {
            "etc": "etc.",
            "example": "Example:",
            "line1": "You had 50 orders in the past 30 days.",
            "line2": "You set a different invoice numbering for these, namely",
            "line3": "Then the import gets the numbering",
            "line4": "in chronological order over time.",
            "line5": "The new orders you receive after that will follow the standard invoice numbering.",
            "line6": "So those will get the numbering",
            "until": "to"
        },
        "customNamely": "Namely...",
        "errors": {
            "importFailedTitle": "Import failed",
            "invalid": "Not valid",
            "startImportFailed": "Failed to start the import."
        },
        "importHistory": {
            "info1": "The invoices will only be available once the import is complete.",
            "info2": "In the meantime, you can use the rest of the platform.",
            "info3": "Estimated time it will take:",
            "subtitle": "This may take a while, depending on the number of orders.",
            "time1": "100 orders = 1 minute",
            "time2": "1000 orders = 1.5 minutes",
            "time3": "5000 orders = 2 minutes",
            "title": "Do you also want to import the orders from the past 30 days?"
        },
        "intro": {
            "subtitle": "From now on, we'll fetch all new orders from Bol",
            "title": "You're connected to Bol!"
        },
        "invoiceNumber": {
            "subtitle1": "Do you want to use the same or a different invoice numbering",
            "subtitle2": "for the import of orders from the past 30 days?",
            "title": "Which invoice numbering do you want to use for this?"
        },
        "next": "Next",
        "no": "No",
        "notifications": {
            "betaLabel": "Beta",
            "buyBox": {
                "description": "An email when the buy box changes",
                "title": "Buy box change"
            },
            "info1": "The notifications are created with default settings.",
            "info2": "You can always adjust these on the Notifications page.",
            "order": {
                "description": "Receive an email for new orders",
                "title": "New orders"
            },
            "productHijack": {
                "description": "Receive an email when a new seller appears on your product",
                "title": "Product hijack notification"
            },
            "reviews": {
                "description": "Receive an email for new reviews",
                "title": "New reviews"
            },
            "stock": {
                "description": "Get an email when your stock drops below 20",
                "title": "Low stock"
            },
            "subtitle1": "Select the events for which you want to receive an immediate notification by email.",
            "subtitle2": "I want to receive a notification for:",
            "title": "Which notifications do you want to receive?"
        },
        "prefix": "Prefix *",
        "preview": "Example:",
        "standard": "Standard",
        "standardInfo": {
            "etc": "etc.",
            "example": "Example:",
            "line1": "You had 50 orders in the past 30 days.",
            "line2": "These will get the numbering",
            "line3": "in chronological order over time.",
            "line4": "The new orders you receive will continue counting from this point.",
            "line5": "So those will get the numbering",
            "until": "to"
        },
        "start": "Starting at *",
        "summary": {
            "history1": "We're now going to import your orders.",
            "history2": "This may take a while, depending on the number of orders.",
            "history3": "In the meantime, you can use the rest of the platform as usual.",
            "history4": "From now on, invoices will be created automatically.",
            "history5": "You can now further configure Bluemate to your liking and start using it.",
            "start": "Start",
            "title": "Ready to go!"
        },
        "yes": "Yes"
    },
    "controls": {
        "countryField": {
            "all": "All",
            "country": "Country",
            "countries": "countries"
        },
        "countrySelect": {
            "all": "All",
            "available": "Available",
            "countries": "countries",
            "done": "Done",
            "selectCountries": "Select countries",
            "selected": "Selected"
        },
        "datePicker": {
            "close": "Close",
            "dayShort": {
                "mon": "Mo",
                "tue": "Tu",
                "wed": "We",
                "thu": "Th",
                "fri": "Fr",
                "sat": "Sa",
                "sun": "Su"
            },
            "today": "Today"
        },
        "dialog": {
            "cancel": "Cancel",
            "confirm": "Confirm"
        },
        "input": {
            "clear": "Clear"
        },
        "periodSelector": {
            "all": "All",
            "applyRange": "Apply range",
            "back": "Back",
            "custom": "Custom",
            "customEllipsis": "Custom...",
            "customRange": "Custom range",
            "datePlaceholder": "dd-mm-yyyy",
            "endDate": "End date",
            "labels": {
                "today": "Today",
                "yesterday": "Yesterday",
                "last7Days": "Last 7 days",
                "last30Days": "Last 30 days",
                "last90Days": "Last 90 days",
                "weekToDate": "This week",
                "monthToDate": "This month",
                "quarterToDate": "This quarter",
                "yearToDate": "This year",
                "lastWeek": "Last week",
                "lastMonth": "Last month",
                "lastQuarter": "Last quarter",
                "lastYear": "Last year",
                "all": "All",
                "custom": "Custom"
            },
            "selectPeriod": "Select period",
            "startDate": "Start date"
        },
        "platformLabelInput": {
            "recognizableName": "Recognizable name",
            "info": "Use this name to identify your accounts. For example, add BE to the name for a Belgian shop. This name is only used on the platform and will not be used in any communication to your customers."
        },
        "plot": {
            "items": "Items",
            "noDataMessage": "Select a series or adjust the filters to view data.",
            "noDataSeriesMessage": "No data available for this series."
        },
        "portalSelect": {
            "selectedCount_one": "{{count}} selected",
            "selectedCount_other": "{{count}} selected",
            "selectAll": "All",
            "clear": "Clear"
        },
        "productRow": {
            "readLess": "Read less",
            "readMore": "Read more"
        },
        "setupCard": {
            "emailSetup": {
                "subtitle": "To email automatically",
                "title": "Set up emails"
            },
            "invoiceDesign": {
                "subtitle": "Review and adjust if needed",
                "title": "Design invoice"
            },
            "invoiceUpload": {
                "subtitle": "Upload invoices to Bol",
                "title": "Auto-upload"
            },
            "markComplete": "Mark as completed",
            "vatSetup": {
                "subtitle": "Optionally deviate from 21%",
                "title": "VAT % products"
            }
        },
        "statCard": {
            "percentageView": "Percentage view",
            "previous": "Previous",
            "toggleView": "Switch view"
        },
        "statusTile": {
            "autoEmail": {
                "green": "Auto emailing",
                "gray": "Auto emailing off",
                "orange": "Auto emailing paused",
                "red": "Auto emailing off"
            },
            "autoUpload": {
                "green": "Auto upload",
                "gray": "Auto upload off",
                "orange": "Auto upload delayed",
                "red": "Auto upload off"
            },
            "bolConnection": {
                "green": "Connected to Bol",
                "greenCompact": "Connected",
                "gray": "Bol connection unknown",
                "grayCompact": "Bol unknown",
                "orange": "Bol connection: warning",
                "orangeCompact": "Bol warning",
                "red": "No connection with Bol",
                "redCompact": "Not connected"
            }
        },
        "stepper": {
            "stepOf": "Step {{step}} of {{total}}: {{subtitle}}",
            "back": "Previous step",
            "next": "Next",
            "cancel": "Cancel"
        }
    },
    "dashboard": {
        "advancedSearch": "Advanced search",
        "apiConnectionBar": {
            "connectWithBol": "Connect with Bol"
        },
        "assignNum": {
            "customerType": "Customer type",
            "egPlaceholder": "E.g.",
            "errorEmpty": "The invoice number cannot be empty",
            "errorInvalid": "The invoice number must be a valid number",
            "failed": "Setting the invoice number failed.",
            "failedTitle": "Setting failed",
            "invoiceData": "Invoice details",
            "invoiceNumberPh": "Invoice number",
            "invoiceNumberReq": "Invoice number *",
            "lastTimeFilled": "Last time you entered:",
            "latestNormalSeries": "Latest number in normal series:",
            "message": "Choose an invoice number for this invoice. The invoice number must not have been used before, and invoices must be numbered sequentially.",
            "orderDate": "Order date",
            "orderNumber": "Order number",
            "prefix": "Prefix",
            "reference": "Reference",
            "success": "The invoice number has been set",
            "title": "Choose invoice number"
        },
        "bulk": {
            "sendingHistory": "Bulk emails are being scheduled"
        },
        "cancelEmails": {
            "confirmBody": "Are you sure you no longer want to send automatic emails for this order?",
            "failed": "Canceling the emails failed",
            "failedTitle": "Canceling failed",
            "success": "Emails for this invoice will no longer be sent",
            "title": "Cancel emails"
        },
        "connectWithBol": "Connect with Bol",
        "connectionError": {
            "connectPrompt": "Connect Bluemate with Bol to automatically retrieve your orders.",
            "nothingSent": "We're not sending anything yet.",
            "welcome": "Welcome to Bluemate!",
            "willShow": "On this screen you'll soon see your retrieved orders."
        },
        "copied": "copied",
        "crumbs": {
            "invoiceRequests": "Invoice requests",
            "invoices": "Invoices"
        },
        "download": {
            "failedTitle": "Download failed",
            "invoiceFailed": "Downloading the invoice failed."
        },
        "empty": {
            "subtitle": "As soon as we receive the first order from Bol, it will be shown here. You can also look up older orders via the search bar, going back up to 2 years!",
            "title": "No orders received yet"
        },
        "filter": {
            "all": "All",
            "clearFilters": "Clear filters",
            "cocNumber": "KvK number",
            "companyName": "Company name",
            "country": "Country",
            "customerType": {
                "business": "Business",
                "private": "Private"
            },
            "customerTypeLabel": "Customer type",
            "datePlaceholder": "dd-mm-yyyy",
            "eanProduct": "EAN of ordered product",
            "firstName": "First name",
            "invoiceKind": "Invoice kind",
            "invoiceNumber": "Invoice number",
            "invoiceStatus": "Invoice status",
            "invoiceType": {
                "credit": "Credit invoices",
                "sales": "Sales invoices"
            },
            "lastName": "Last name",
            "orderNumber": "Order number",
            "orderPeriodLabel": "Period",
            "orderStatus": {
                "canceled": "Canceled",
                "placed": "Placed",
                "return": "Returned",
                "return_open": "Open Return",
                "sent": "Shipped",
                "credit": "Credit Invoice"
            },
            "orderStatusLabel": "Order status",
            "reference": "Reference",
            "search": "Search",
            "sectionCustomer": "Customer",
            "sectionInvoice": "Invoice",
            "sectionOrder": "Order",
            "status": {
                "error": "Error",
                "notSent": "Not sent",
                "sending": "Sending",
                "sent": "Sent",
                "warning": "Warning"
            },
            "vatNumber": "VAT number"
        },
        "filters": {
            "manyActive": "active filters",
            "oneActive": "1 active filter",
            "removeFilters": "Remove x",
            "searchPlaceholder": "Search by order number",
            "statusAll": "All statuses"
        },
        "firstImport": {
            "message": "We've looked up the older order for you and added it to your account. This order was placed before you set up a Bluemate account, so we cannot automatically determine the invoice number. Click on the order and choose the option \"Set invoice number\" to choose an invoice number yourself.",
            "understood": "Got it"
        },
        "importOverlay": {
            "line1": "We'll send you an email as soon as the import is complete.",
            "line2": "In the meantime, you can set up your account as you like.",
            "title": "The orders from the past 30 days are being imported"
        },
        "importStatus": {
            "error": "Problem checking for new orders",
            "importing": "Checking for new orders",
            "lastCheck": "last check",
            "notConnected": "Not connected to Bol",
            "searchTip": "Via the search bar you can also retrieve orders by order number from before you started using Bluemate, going back as far as 2 years.",
            "updated": "Updated"
        },
        "importing": {
            "checkStatus": "Check the status in the top right of the page.",
            "fetching": "Fetching orders",
            "firstTime": "The first time this can take a few minutes."
        },
        "introBanner": {
            "invoicesMessage": "Manage your orders and invoices in one place, so you always have a clear overview.",
            "invoicesTitle": "Invoices",
            "requestsMessage": "Upload invoices to bol automatically. Stay ahead of invoice requests.",
            "requestsTitle": "Invoice requests"
        },
        "invoiceCustomerBoth": "Business en Private",
        "invoiceCustomerBusiness": "Business",
        "invoiceCustomerPrivate": "Private",
        "notFound": {
            "tipBefore": "Tip: to search by last name, company, invoice number, etc., use",
            "title": "No orders found"
        },
        "orders": "Orders",
        "otherAccount": "This order is from a non-selected account",
        "orderNumberLabel": "Order number",
        "invoiceNumberLabel": "Invoice number",
        "profitLabel": "Profit",
        "quantityBadge": {
            "moreProducts": "This order contains {{count}} different products",
            "units": "This order contains {{count}} units of this product"
        },
        "period": {
            "from": "From",
            "label": "Period",
            "title": "Adjust period",
            "to": "Through"
        },
        "stats": {
            "last30Days": "PAST 30 DAYS"
        },
        "uploadStats": {
            "autoRespond": "Auto-respond to requests",
            "autoRespondFailedPrefix": "The",
            "autoRespondFailedSuffix": "of auto-responding failed.",
            "autoRespondFailedTitlePrefix": "Auto-respond",
            "autoRespondInfo": "If the invoice for an order has not yet been uploaded, a customer can request the invoice. With this option, these requests are automatically answered with the corresponding invoice. By also enabling proactive uploading, you ensure there are fewer and fewer of these requests, because the invoice will already be available and customers won't need to request it.",
            "autoRespondPrefix": "Auto-responding to requests is",
            "autoRespondTitle": "Automatically respond to requests",
            "disable": "disable",
            "disabled": "disabled",
            "enable": "enable",
            "enabled": "enabled",
            "failedSuffix": "failed",
            "openRequests": "OPEN INVOICE REQUESTS",
            "proactiveFailedPrefix": "The",
            "proactiveFailedSuffix": "of proactive uploading failed.",
            "proactiveFailedTitlePrefix": "Proactive upload",
            "proactiveInfo": "With proactive uploading you ensure that for every new order, the invoice is uploaded once the order is completed. Customers can then find and download the VAT invoice in their Bol customer portal. This way you prevent invoice requests.",
            "proactiveUpload": "Proactive uploading",
            "proactiveUploadPrefix": "Proactive uploading of invoices is",
            "recommended": "Recommended",
            "recommendedInfo": "We recommend enabling both proactive uploading and auto-responding.",
            "uploaded": "INVOICES UPLOADED"
        },
        "uploading": {
            "failed": "Uploading the invoice failed.",
            "failedTitle": "Upload failed",
            "success": "The invoice is being uploaded to Bol"
        }
    },
    "email": {
        "adminInfo": {
            "active": "Active",
            "activeSince": "Active since",
            "activity": "Activity",
            "all": "All",
            "createdAt": "Created on",
            "disabled": "Disabled",
            "enabled": "Enabled",
            "id": "ID",
            "inactive": "Inactive",
            "invoiceMail": "Invoice email",
            "loadFailed": "Loading failed",
            "mailType": "Email type",
            "name": "Name",
            "on": "on",
            "products": "Products",
            "remaining": "Remaining",
            "reviewInvoiceMail": "Review + invoice email",
            "showAll": "Show all",
            "showLess": "Show less",
            "status": "Status",
            "updatedAt": "Last updated"
        },
        "attachment": {
            "addInvoice": "+ Add order invoice as attachment",
            "attachmentLabel": "ATTACHMENT",
            "attachmentsLabel": "ATTACHMENTS",
            "confirm": "Confirm",
            "deleteConfirm": "Are you sure you want to delete this attachment? It will no longer be sent with the configured emails.",
            "deleteFailed": "Deleting the attachment failed.",
            "deleteFailedTitle": "Delete failed",
            "deleted": "The attachment has been deleted",
            "done": "Done",
            "emailUpdated": "The email has been updated",
            "invoiceOfOrder": "Order invoice (.pdf)",
            "loadFailed": "Loading the attachments failed.",
            "loadFailedTitle": "Loading failed",
            "name": "NAME",
            "no": "No",
            "search": "Search",
            "selectTitle": "Select attachment(s) for this email",
            "selected": "SELECTED",
            "size": "SIZE",
            "updateFailed": "Updating the email failed.",
            "updateFailedTitle": "Update failed",
            "upload": {
                "failed": "Upload (partially) failed",
                "manyUploaded": "The attachments have been uploaded",
                "oneUploaded": "The attachment has been uploaded",
                "upload": "Upload"
            },
            "yes": "Yes"
        },
        "cancelEmails": {
            "allCanceled": "All scheduled emails have been canceled",
            "body": {
                "all": "all",
                "keepOpen": "keep the Emails page open",
                "keepOpenPrefix": "Depending on the number of scheduled emails, canceling may take a while,",
                "keepOpenSuffix": "to make sure all emails are canceled.",
                "middle": "scheduled emails canceled, so they will no longer be sent. For example, when the scheduled emails contain an error. This action cannot be undone, and canceled emails cannot be rescheduled.",
                "prefix": "By canceling the emails, you will have"
            },
            "cancelBtn": "Cancel emails",
            "cancelFailed": "Canceling the emails failed.",
            "cancelFailedTitle": "Cancel failed",
            "close": "Close",
            "confirmCheckbox": "I confirm that all emails should be canceled and understand that this cannot be undone",
            "title": "Cancel emails"
        },
        "day": {
            "cancel": "Cancel",
            "confirm": "Confirm",
            "onlyWorkDays": "Workdays only",
            "title": "Custom number of days"
        },
        "flow": {
            "addEmail": "Add an email to the Email Sequence",
            "autoMailOff": "Automatic emailing off",
            "autoMailOn": "Automatic emailing on",
            "bulkMailing": "Bulk mailing for 30-day import...",
            "cancel": "Cancel",
            "cancelPlanned": "Canceling scheduled emails…",
            "choose": "Choose",
            "click": "Click",
            "copyFromAccount": "Copy from another account...",
            "createFailed": "Setting up the email failed.",
            "createFailedTitle": "Setup failed",
            "emailsTitle": "Emails",
            "expectation-1": "Your reviews need time to grow. On average 1 in 40 customers writes a review in e-commerce.\nMore reviews lead to more orders - give this flywheel time to build momentum.",
            "expectation-trial": "Need more than 30 days trial? Mail us.",
            "expectation-2": "With smart e-mail content you can increase your conversion ratio greatly up to 1 review per 7 customers.",
            "expectationLink": "Read how <1>here</1>.",
            "intro": "Automate emails to your customers so you can earn more reviews on bol and/or send invoices without manual work.",
            "label": {
                "creditInvoice": "Credit invoice email",
                "invoice": "Invoice email",
                "other": "Other email",
                "product": "Product-specific email",
                "review": "Review email",
                "reviewInvoice": "Review + invoice email"
            },
            "moreInfo": "More information",
            "noTrackingMessage": "Open and click counts are not tracked because no no-reply email address is used.",
            "off": "OFF",
            "on": "ON",
            "open": "Open",
            "policy": "This method complies with Bol's policy",
            "policyLink": "policy points",
            "policyWarnPrefix": "Your emails do not meet the",
            "policyWarnSuffix": "of Bol.",
            "search": "Search",
            "searchEmails": "Search emails",
            "searchPlaceholder": "Search for an email",
            "sent": "Sent",
            "status": "Status",
            "title": "What kind of email do you want to add?",
            "copied": "The emails have been copied",
            "copyFailedMsg": "Failed to copy the emails.",
            "copyFailedTitle": "Copy failed",
            "closeHistoryTitle": "Close one-time mail option",
            "closeHistoryIntro": "Here we also offer the option to send the emails <1>once</1> to orders from the last 30 days.",
            "closeHistoryQuestion": "Are you sure you don't want to use this option?",
            "closeHistoryConsequence": "The button will then disappear.",
            "closeHistoryHint": "For new orders you can schedule the emails by simply turning on the 'Automatic mailing' button at the top right.",
            "yesButton": "Yes",
            "noButton": "No",
            "policyFailBody1": "Your emails do not meet Bol's policy rules. Multiple emails are being sent to the same customers or the invoice is not set as an attachment. According to Bol policy, each customer may only receive one email and the invoice must be added as an attachment.",
            "policyFailBody2": "The one-time emails can only be sent if the policy rules are met.",
            "policyFailBody3": "Adjust your emails so that only one mail per customer is sent.",
            "policyFailTitle": "Policy rules",
            "enableMailingBody": "First turn automatic mailing ON so the emails will also be sent to new orders.",
            "enableMailingTitle": "Turn mailing on",
            "historyMailsIntro": "Here we offer the option to send the emails <1>once</1> to orders from the last 30 days.",
            "historyMailsThinkCarefully": "Think carefully whether the content of your email is correct. This action can only be performed once and after running it this button disappears forever.",
            "historyMailsNewOrders": "You can have the emails scheduled for <1>new orders</1> by simply turning on the 'Automatic mailing' button at the top right.",
            "historyMailsNowOn": "You already have this on, so these mails will be scheduled.",
            "historyMailsUnderstand": "I understand that...",
            "historyMailsBullet1": "This action will send the emails once for orders from the last 30 days.",
            "historyMailsBullet2": "This action cannot be reversed after confirmation.",
            "historyMailsBullet3": "For new orders the emails will be scheduled as configured when the automatic mailing at the top right is ON.",
            "historyMailsTitle": "Send emails for old orders",
            "historyMailsConfirm": "Yes, I understand & send",
            "scheduled": "The emails will be sent for orders from the last 30 days.",
            "scheduledTitle": "Emails are being scheduled",
            "sendHistoryFailed": "Sending the emails for orders from the last 30 days failed.",
            "sendHistoryFailedTitle": "Sending failed",
            "enableFailed": "Enabling the email failed.",
            "enableFailedTitle": "Enable failed",
            "disableFailed": "Disabling the email failed.",
            "disableFailedTitle": "Disable failed",
            "bolPolicyPrefix": "One or more steps do not comply with ",
            "bolPolicyLink": "Bol's policy",
            "bolPolicySuffix": ". Do you still want to activate automatic email sending?",
            "bolPolicyTitle": "Bol policy",
            "loadFailed": "Loading the emails failed.",
            "loadFailedTitle": "Loading failed",
            "loadTemplatesFailed": "Loading the email templates failed.",
            "pauseToChangeMsg": "First pause email sending <1>at the top right</1> to apply changes.",
            "pauseToChangeTitle": "Change step",
            "importTitle": "Import emails",
            "importAllFromAccount": "Fetch all emails from another account.",
            "importWarningLabel": "Note: ",
            "importWarningText": "all current emails will be overwritten!",
            "importEansOnly": "Only existing EANs will be included.",
            "pageChangeDeny": "Yes, enable sending",
            "pageChangeAllow": "No, leave the page",
            "pageChangeTitle": "Automatic email sending",
            "pageChangeBody": "Automatic sending of some emails is not enabled, so some emails will not be sent automatically. Do you want to enable automatic email sending before leaving the page?",
            "crumb": "Emails"
        },
        "flowErrors": {
            "enableFailedBody": "Enabling failed because the following issues were found:",
            "disableFailedBody": "Disabling failed because the following issues were found:"
        },
        "unsubscribe": {
            "failedMsg": "Unsubscribing from the monthly email failed.",
            "loading": "You are being unsubscribed from the monthly email...",
            "successMsg": "You have been successfully unsubscribed from the monthly email.",
            "title": "Unsubscribe from monthly email"
        },
        "importProducts": {
            "close": "Close",
            "descriptionPrefix": "You can connect all your products to the right emails at once with this option. Use our",
            "descriptionSuffix": "Note: any products already connected will be overwritten.",
            "errorsFound": "Errors were found in the import file during importing, the products were not connected. The following errors were found:",
            "importFile": "import file",
            "link": "Connect products",
            "linkFailed": "Connecting the products failed.",
            "linkFailedTitle": "Connecting failed",
            "linked": "The products have been connected successfully",
            "row": "Row",
            "title": "Bulk-connect products",
            "xlsxOnly": "Only Excel (XLSX) files can be imported."
        },
        "stats": {
            "adjustPeriod": "Adjust period",
            "avgCtrPrefix": "In 2021, the global average click rate was",
            "avgCtrSuffix": "% for marketing emails.",
            "display": "Display",
            "head": {
                "date": "Date",
                "month": "Month",
                "quarter": "Quarter",
                "week": "Week",
                "year": "Year"
            },
            "loadFailed": "Loading the statistics failed.",
            "loadFailedTitle": "Loading failed",
            "mailsOpened": "Emails opened",
            "mailsSent": "Emails sent",
            "reviewLinksClicked": "Review links clicked",
            "splitMethod": {
                "day": "Per day",
                "month": "Per month",
                "quarter": "Per quarter",
                "week": "Per week",
                "year": "Per year"
            },
            "title": "Email statistics"
        },
        "step": {
            "actionEnabled": "enabled",
            "actionPaused": "paused",
            "after": "After",
            "allCountries": "All countries",
            "countries": "countries",
            "delete": "Delete",
            "deleteConfirm": "Are you sure you want to delete this email?",
            "deleteFailed": "Deleting the step failed.",
            "deleteFailedTitle": "Delete failed",
            "deleteTitle": "Delete email",
            "deleted": "The email has been deleted",
            "editContent": "Edit content",
            "editName": "Edit name",
            "emailIs": "The email is",
            "emailUpdated": "The email has been updated",
            "enableSending": "Enable sending",
            "for": "for",
            "fulfilment": {
                "both": "All fulfillment",
                "fbb": "FBB",
                "fbr": "Own fulfillment"
            },
            "in": "in",
            "mailWithAttachment": "email with attachment",
            "moreInfo": "More information",
            "new": "New",
            "no": "No",
            "noTemplate": "You haven't chosen an email template yet.",
            "overlapError": "Another email is already being sent to these customers. Send a maximum of 1 email per order.",
            "pauseSending": "Pause sending",
            "pausedSuffix": "(paused)",
            "send": "send",
            "stat": {
                "click": "Click",
                "open": "Open",
                "sent": "Sent"
            },
            "statsFailed": "Loading the statistics failed.",
            "statsFailedTitle": "Loading failed",
            "statsOff": "Statistics are off...",
            "testMailFailed": "Sending the test email failed.",
            "testMailFailedTitle": "Send failed",
            "testMailSent": "The test email has been sent",
            "testSend": "Send test",
            "to": "to",
            "updateFailed": "Updating the email failed.",
            "updateFailedTitle": "Update failed",
            "updating": "updating",
            "via": "via",
            "yes": "Yes"
        },
        "template": {
            "editor": {
                "bccInfo": "Want to add email addresses in BCC? For security, please request this through our support team.",
                "bccInvalid": "The BCC address is not valid",
                "cancel": "Cancel",
                "leavePage": "No, leave page",
                "leavePageWarn": "Your changes will be lost if you leave the page. Would you like to save the changes first?",
                "logoPlaceholderWarn": "The email still contains placeholder images of the Bluemate logo. Replace them with your own logo or remove the image.",
                "personPlaceholderWarn": "The email still contains placeholder images of people. Replace them with your own photo or remove the image.",
                "policy": "Policy points:",
                "policyCheck": "Check whether your email complies with Bol's policy",
                "preview": "Preview",
                "productReview": "Product Review",
                "replyTo": "Reply-to address",
                "replyToPlaceholder": "Reply-to address",
                "reset": "Reset",
                "saveChanges": "Yes, save changes",
                "saveExit": "Save & Exit",
                "saveFailed": "Saving the email template failed.",
                "saveFailedTitle": "Save failed",
                "saved": "The email template has been saved",
                "shiftEnterTip": "Tip: use SHIFT + ENTER to add a new line without extra spacing.",
                "subject": "Subject",
                "templateName": "Template name",
                "testMailFailed": "Sending the test email failed.",
                "testMailFailedTitle": "Send failed",
                "testMailSent": "The test email has been sent",
                "testSend": "Send test",
                "tipsTitle": "Tips for an effective email:",
                "updateFailed": "Updating the email template failed.",
                "updateFailedTitle": "Update failed",
                "updated": "The email template has been updated",
                "var": {
                    "client": "Customer",
                    "company": "Company",
                    "invoice": "Invoice",
                    "leaveReview": "Leave your review here",
                    "productImage": "Product Image",
                    "productImageUrl": "Product Image URL",
                    "productReviewLink": "Product Review Link",
                    "productSubtitle": "Product Subtitle",
                    "productTitle": "Product Name",
                    "productUrl": "Product Review URL",
                    "reviewLinks": "Review Links"
                },
                "variables": "Variables"
            },
            "preview": {
                "bcc": "BCC",
                "done": "Done",
                "reviewLinks": "Review Links",
                "subject": "Subject",
                "title": "Preview"
            },
            "tips": {
                "bluemateLogo": "Make it your own: use your company logo instead of the Bluemate logo.",
                "companyEmail": "You are not allowed to include your company's email address in the mail.",
                "goldenStar": "Star emojis are no longer allowed by bol. Please remove them.",
                "honestReview": "You use a button to the review page, but do not literally ask for an \"honest review\".",
                "stockPhoto": "Replace the stock photo: Our research shows that personal photos of you\n or your team lead to a higher chance of reviews."
            }
        },
        "templateSelect": {
            "cancel": "Cancel",
            "choose": "Choose",
            "chooseAnyway": "Choose anyway",
            "chooseEdit": "Choose & Edit",
            "conversionTip": "Conversion tip: Add personal photos to highlight yourself as a small business owner; this increases the chance of getting reviews.",
            "copied": "The template has been copied",
            "copy": "Copy",
            "copyFailed": "Copying the template failed.",
            "copyFailedTitle": "Copy failed",
            "currentSuffix": "(current)",
            "delete": "Delete",
            "deleteConfirm": "Are you sure you want to delete this template?",
            "deleteFailed": "Deleting the Email Template failed.",
            "deleteFailedTitle": "Delete failed",
            "deleteTitle": "Delete template",
            "deleted": "The Email Template has been deleted",
            "description": "You can choose, edit, and preview a template.",
            "edit": "Edit",
            "emailTitle": "EMAIL TITLE",
            "emailUpdated": "The email has been updated",
            "inUseTitle": "Template already in use",
            "inUseWarning": "This template is already being used in other email flows. Changes you make here will also be applied to those flows. Don't want this? Then make a copy of the template.",
            "lastUpdated": "LAST UPDATED",
            "loadDefaultsFailed": "Loading the default templates failed.",
            "loadFailedTitle": "Loading failed",
            "loadTemplatesFailed": "Loading the email templates failed.",
            "newTemplate": "+ Create new Email Template",
            "newTemplateName": "New Email Template",
            "newTemplateSubject": "About your order {order_id} from {bedrijf_naam} via Bol",
            "no": "No",
            "preview": "Preview",
            "readMore": "Read more",
            "sharedBanner": "Please note: Changes to a saved template apply to all email flows that use this template. If you don't want this, duplicate the template or create a new one.",
            "showAll": "Show all templates",
            "showSpecific": "Show specific templates",
            "startEmpty": "Start empty",
            "tab": {
                "custom": "Saved Templates",
                "default": "Template Layouts"
            },
            "title": "Choose your Email Template",
            "updateFailed": "Updating the email failed.",
            "updateFailedTitle": "Update failed",
            "view": "View",
            "yes": "Yes"
        },
        "test": {
            "cancel": "Cancel",
            "cannotChange": "For security reasons, this email address cannot be changed.",
            "invalidEmail": "Enter a valid email address",
            "send": "Send",
            "sendTo": "The test email will be sent to:",
            "title": "Send test email",
            "emailSection": "Email",
            "pushSection": "Push notification",
            "pushSendTo": "Push notification will also be sent to:"
        }
    },
    "header": {
        "demoAccount": "This is a demo account",
        "demoButton": "Register now",
        "demoSub": "Try it for free for 30 days. No payment method required. Connect your own bol accounts now.",
        "logoutFailed": "Logout failed",
        "logoutFailedMessage": "We couldn't log you out.",
        "trialButton": "Start subscription...",
        "trialEnded": "Your trial period has ended",
        "trialSub_one": "{{count}} trial day remaining. If you start a subscription now, your remaining free days will be used up first.",
        "trialSub_other": "{{count}} trial days remaining. If you start a subscription now, your remaining free days will be used up first.",
        "trialTitle": "Start a subscription?",
        "salesAccount": "Sales account",
        "signOut": "Sign out"
    },
    "history": {
        "action": {
            "create": "Invoice created",
            "download": "Invoice downloaded",
            "orderPlaced": "Order placed",
            "orderSent": "Order shipped",
            "send": "Invoice sent",
            "sendOther": "Invoice-specific email sent",
            "sendProduct": "Product-specific email sent",
            "sendReview": "Review request sent",
            "update": "Invoice updated"
        },
        "actionBy": {
            "system": "System",
            "unknown": "Unknown"
        }
    },
    "invoice": {
        "credit": {
            "andToCreditInvoice": "and go to credit invoice",
            "col": {
                "ean": "EAN",
                "name": "NAME",
                "priceIncl": "PRICE INCL. VAT",
                "quantity": "QUANTITY",
                "subtotalIncl": "SUBTOTAL INCL. VAT",
                "vat": "VAT"
            },
            "create": "Create",
            "createFailed": "Failed to create the credit invoice.",
            "createFailedTitle": "Create failed",
            "createdSuccess": "The credit invoice has been created",
            "errorFillVatOrPrice": "Enter at least the VAT amount or the price in",
            "errorPriceTooHigh": "The price cannot be higher than the original price",
            "errorQuantityMin": "The quantity must be at least 1",
            "errorQuantityTooHigh": "The quantity cannot be higher than the original quantity",
            "itemsHeader": "Line Items to Credit",
            "loadFailed": "Failed to load the invoice.",
            "loadFailedTitle": "Loading failed",
            "percentage": "Percentage",
            "price": "Price",
            "quantity": "Quantity",
            "updateFailed": "Failed to update the credit invoice.",
            "updateFailedTitle": "Update failed",
            "updatedSuccess": "The credit invoice has been updated",
            "vat": "VAT"
        },
        "data": {
            "address": "Address",
            "city": "City",
            "cocNumber": "KvK number",
            "cocPh": "KvK number",
            "company": "Company",
            "email": "Email address",
            "emailDisabled": "Cannot be edited for security reasons. You can download the invoice and email it manually yourself.",
            "firstName": "First name",
            "houseNumber": "House number",
            "lastName": "Last name",
            "order": "order",
            "reference": "Reference",
            "suffix": "Suffix",
            "title": "Invoice details",
            "vatNumber": "VAT number",
            "vatPh": "VAT number",
            "zipCode": "Zip code"
        },
        "details": {
            "address": "Address",
            "back": "Back",
            "cocLabel": "KvK number",
            "col": {
                "name": "NAME",
                "priceExcl": "PRICE excl. VAT",
                "quantity": "QUANTITY",
                "totalExcl": "TOTAL excl. VAT",
                "vat": "VAT"
            },
            "company": "Company",
            "creditInvoice": "Credit invoice",
            "crumbs": {
                "invoices": "Invoices",
                "order": "Order"
            },
            "customer": "Customer",
            "download": "Download",
            "downloadFailed": "Failed to download the invoice.",
            "downloadFailedTitle": "Download failed",
            "edit": "Edit",
            "emailLabel": "Email address",
            "invoice": "Invoice",
            "invoiceDate": "Invoice date",
            "invoiceNo": "Invoice no.",
            "items": "Items",
            "name": "Name",
            "orderNo": "Order no.",
            "orderPlaced": "Order placed",
            "preview": "Preview",
            "products": "Products",
            "recentActivity": "Recent activity",
            "send": "Send",
            "sendFailed": "Something went wrong while sending the invoice.",
            "sendFailedTitle": "Send failed",
            "sendSuccess": "The invoice has been sent successfully",
            "sending": "Sending the invoice...",
            "showAll": "Show full history",
            "showLess": "Show less history",
            "status": "Status",
            "title": "Details",
            "total": "Total",
            "totalExcl": "Total excl. VAT",
            "totalIncl": "Total incl. VAT",
            "vatCombi": "Combi.",
            "vatLabel": "VAT number",
            "vatLine": "VAT",
            "vatMargin": "Margin",
            "vatReversed": "reverse charged",
            "vatReversedFull": "VAT reverse charged"
        },
        "edit": {
            "col": {
                "ean": "EAN",
                "name": "NAME",
                "price": "PRICE",
                "quantity": "QUANTITY",
                "reference": "REFERENCE",
                "vat": "VAT"
            },
            "itemLabel": {
                "reference": "Reference",
                "name": "Name",
                "price": "Price",
                "quantity": "Quantity",
                "vat": "VAT"
            },
            "crumbs": {
                "editInvoice": "Edit invoice",
                "invoices": "Invoices",
                "order": "Order"
            },
            "download": "download",
            "downloadFailed": "Failed to download the invoice.",
            "downloadFailedTitle": "Download failed",
            "downloadInvoice": "Download invoice",
            "emailNotAvailableAfter": "and send it to the customer via the Bol platform.",
            "emailNotAvailableBefore": "The customer's original email address is no longer available to Bluemate. We recommend that you",
            "errorPrice": "Enter the price",
            "errorQuantity": "Enter the quantity",
            "errorTitle": "Enter the name",
            "invoiceLines": "Invoice lines",
            "mailSendFailed": "Failed to send the email.",
            "save": "Save",
            "sendConfirmBody": "Do you want to send the updated invoice right away?",
            "sendConfirmTitle": "Send invoice",
            "sendFailedTitle": "Send failed",
            "sentSuccess": "The invoice has been sent",
            "unsavedBody": "The invoice has been changed, do you want to save the changes?",
            "unsavedTitle": "Invoice changed",
            "updateFailed": "Failed to update the invoice.",
            "updateFailedTitle": "Update failed",
            "updateSuccess": "The invoice has been updated",
            "yesSend": "Yes, send"
        },
        "peppol": {
            "col": {
                "actions": "ACTIONS",
                "amount": "AMOUNT",
                "date": "DATE",
                "invoiceNumber": "INVOICE NUMBER",
                "name": "NAME",
                "orderNumber": "ORDER NUMBER",
                "status": "STATUS"
            },
            "copied": "copied",
            "costsPer": "COSTS €0.20 PER E-INVOICE",
            "disable": "disable",
            "downloadFailed": "Failed to download the invoice.",
            "downloadFailedTitle": "Download failed",
            "enable": "enable",
            "failedSuffix": "failed",
            "info": {
                "afterRegistration": "Once your Peppol registration is successful, you can enable the Peppol integration. We automatically retrieve your registered Peppol ID and use it to send your e-invoices.",
                "costsBody": "Sending e-invoices via the Peppol network costs €0.20 per e-invoice. Only invoices for Belgian business customers (with a VAT number) are sent via Peppol; this is on average 0-1% of orders.",
                "costsTitle": "Costs",
                "from": "From",
                "haveRegistrationAfter": ") for sending e-invoices via the Peppol network.",
                "haveRegistrationBefore": "You already have a Peppol registration for your VAT number. We use your Peppol ID (",
                "integration": "You can use our Peppol integration for this, which lets you send your business e-invoices via the Peppol network fully automatically.",
                "mandatoryDate": "As of January 1, 2026, Belgian retailers are required to send invoices for Belgian business orders via the Peppol network.",
                "needRegistration": "The only thing you need to arrange yourself is the Peppol registration of your VAT/KBO number. You can do this through a Peppol provider.",
                "registrationTitle": "Peppol registration",
                "since": "Since",
                "title": "Send e-invoices via Peppol"
            },
            "last30Days": "LAST 30 DAYS",
            "listTitle": "Peppol e-invoices (for Belgian business customers)",
            "loadFailed": "Failed to load the invoices.",
            "loadFailedTitle": "Failed to load invoices",
            "searchLabel": "Search invoice",
            "searchPlaceholder": "Search by order number",
            "sendFailed": "Failed to send the invoice via Peppol.",
            "sendFailedTitle": "Send failed",
            "sendSuccess": "The invoice has been sent to the customer",
            "stat": {
                "delivered": "Peppol e-invoices delivered",
                "failed": "Peppol e-invoices failed"
            },
            "state": {
                "all": "All",
                "error": "Error during sending",
                "failed": "Send failed",
                "notSent": "Not yet sent",
                "notSentInfo": "The e-invoice has not yet been sent to the customer",
                "sent": "Delivered",
                "transit": "Sent",
                "transitInfo": "The e-invoice is on its way to the customer"
            },
            "status": {
                "linked": "Connected to Peppol",
                "notLinked": "Not connected to Peppol",
                "notSending": "Peppol B2B e-invoices are not being sent",
                "sending": "Peppol B2B e-invoices are being sent"
            },
            "toggleFailedPrefix": "Failed to",
            "toggleFailedSuffix": "Peppol.",
            "totalCosts": "TOTAL COSTS",
            "usePeppol": "Use Peppol"
        },
        "request": {
            "allSelected": "All requests selected",
            "archive": "Archive",
            "archiveConfirm": "Are you sure you want to archive this request? The request will no longer be shown. This action cannot be undone.",
            "archiveFailed": "Failed to archive the request.",
            "archiveFailedTitle": "Archive failed",
            "archiveTitle": "Archive request",
            "archivedSuccess": "The request has been archived",
            "bulkUploadFailed": "Failed to upload one or more invoices.",
            "bulkUploading": "The invoices are being uploaded to Bol",
            "col": {
                "orderNumber": "ORDER NUMBER",
                "requestDate": "REQUEST DATE",
                "status": "STATUS",
                "type": "TYPE",
                "uploadedOn": "UPLOADED ON"
            },
            "confirmTitle": "Confirm",
            "copiedToClipboard": "copied to clipboard",
            "createInvoice": "Create invoice...",
            "customerType": {
                "business": "Business",
                "private": "Private"
            },
            "data": {
                "city": "City",
                "cocNumber": "KvK number",
                "companyName": "Company name",
                "country": "Country",
                "createAndUpload": "Create & upload invoice",
                "createInvoice": "Create invoice",
                "errAddress": "Enter the address",
                "errCity": "Enter the city",
                "errFirstName": "Enter the first name",
                "errHouseNumber": "Enter the house number",
                "errInvoiceNumber": "Enter the invoice number",
                "errLastName": "Enter the last name",
                "errPrefix": "Enter the prefix",
                "errZipCode": "Enter the zip code",
                "firstName": "First name",
                "houseNumber": "House number",
                "invoiceNumber": "Invoice number",
                "lastFilled": "Last time you entered:",
                "lastName": "Last name",
                "optional": "optional",
                "popupTitle": "Manually create invoice for order",
                "prefix": "Prefix",
                "prefixPh": "{jaar}old-",
                "saveFailed": "Failed to save the invoice details.",
                "saveFailedTitle": "Save failed",
                "savedSuccess": "The invoice details have been saved",
                "setNumFailed": "Failed to set the invoice number.",
                "setNumFailedTitle": "Failed to set invoice number",
                "step1Body": "Choose an invoice number for this invoice. The invoice number must not have been used before, and invoices must be numbered sequentially. See above for why.",
                "step1Title": "1) Choose invoice number",
                "step2Body": "These details were entered with the invoice request and will be used on the invoice. You can still edit them before the invoice is created.",
                "step2Title": "2) Review invoice details and complete",
                "street": "Street",
                "vatNumber": "VAT number",
                "whyManualBody": "This invoice is most likely from before you used Bluemate. As a result (due to the GDPR), we probably do not receive all customer details. You will therefore need to fill in the rest manually. Because the Tax Authorities require your invoice numbering to increase chronologically, we cannot use the standard invoice number for this.",
                "whyManualTitle": "Why do I have to do this manually?",
                "zipCode": "Zip code"
            },
            "download": "Download",
            "downloadFailed": "Failed to download the invoice.",
            "downloadFailedTitle": "Download failed",
            "edit": "Edit...",
            "empty": "- No invoice requests found -",
            "fetchOrderFailed": "Something went wrong while fetching the order.",
            "fetchOrderFailedTitle": "Failed to fetch order",
            "loadFailed": "Failed to load the invoice requests.",
            "loadFailedTitle": "Loading failed",
            "orderNotFoundBody": "We could not find an order for this request. This most likely means that this is an order older than two years. Because Bol does not provide data for orders older than two years, we cannot process this request for you.",
            "orderNotFoundTitle": "Order not found",
            "orderNumber": "Order number",
            "paginationOf": "of",
            "paginationTo": "to",
            "preview": "Preview",
            "requestPlural": "requests",
            "requestSingular": "request",
            "searchLabel": "Search request",
            "searchPlaceholder": "Order number, shipment number, or customer number",
            "selected": "selected",
            "somethingWrong": "Something went wrong.",
            "status": {
                "closed": "Closed",
                "failed": "Failed",
                "open": "Open"
            },
            "tab": {
                "requests": "Requests",
                "settings": "Settings"
            },
            "title": "Invoice requests",
            "upload": "Upload",
            "uploadAllConfirm": "This will upload the invoices for all open invoice requests. Are you sure you want to continue?",
            "uploadFailed": "Failed to upload the invoice.",
            "uploadFailedTitle": "Upload failed",
            "uploadingSuccess": "The invoice is being uploaded to Bol"
        },
        "send": {
            "attachment": "Attachment:",
            "customer": "Customer:",
            "disclaimer": "The settings from the Emails page are not used for this email.",
            "download": "download",
            "emailNotAvailableAfter": "and send it to the customer via the Bol platform.",
            "emailNotAvailableBefore": "The customer's original email address is no longer available to Bluemate. We recommend that you",
            "errorSubject": "Enter the subject",
            "errorText": "Enter the body of the email",
            "failedTitle": "Send failed",
            "invoiceDate": "Invoice date:",
            "invoiceNumNotSet": "This invoice does not yet have an invoice number and therefore cannot be sent. The system cannot determine an invoice number for orders older than your Bluemate account. For these orders you must set the invoice number yourself.",
            "invoiceNumNotSetPlural": "do not yet have an invoice number and therefore cannot be sent. The system cannot determine an invoice number for orders older than your Bluemate account. For these orders you must set the invoice number yourself.",
            "invoiceNumber": "Invoice number:",
            "orderNumber": "Order number:",
            "orderPrefix": "Order",
            "send": "Send",
            "sendFailed": "Failed to send the invoice.",
            "sentSuccess": "The invoice has been sent",
            "setInvoiceNumTitle": "Set invoice number",
            "subjectPlaceholder": "Subject of the email",
            "subjectPrefix": "Invoice for order",
            "subjectRequired": "Subject *",
            "title": "Send invoice"
        },
        "status": {
            "uploaded": "Invoice uploaded",
            "placed": "Order placed",
            "canceled": "Order cancelled",
            "orderSent": "Order sent",
            "error": "Error",
            "scheduled": "Not sent yet",
            "notSent": "Not sent",
            "sent": "Invoice sent",
            "warning": "Warning",
            "transport": "Invoice being sent"
        }
    },
    "invoiceUploadSettings": {
        "autoRespond": "Auto-respond to requests",
        "autoRespondInfo": "If the invoice for an order has not yet been uploaded, a customer can request the invoice. With this option, these requests are answered automatically with the matching invoice. By also enabling proactive uploading, you ensure that there are fewer and fewer of these requests, because the invoice is already available and customers no longer need to request it.",
        "autoRespondTitle": "Automatically respond to requests",
        "autoUpload": "Automatic uploading",
        "deleteRuleConfirm": "Are you sure you want to delete this rule?",
        "deleteRuleTitle": "Delete rule",
        "notify": {
            "desc1": "Send me an email notification when a new invoice request cannot be answered automatically.",
            "desc2": "For example because the invoice is not in the Bluemate database, if the order is from before you started using Bluemate.",
            "emailLabel": "Notification email address",
            "title": "Notification email when manual action is required",
            "toggle": "Send me an email notification"
        },
        "oldOrders": {
            "infoLine1": "Your customers can request an invoice for orders up to 2 years back. It is possible that we do not have this order in the system, because your Bluemate account did not yet exist at that time.",
            "infoLine2": "We can still answer this invoice request automatically with an invoice upload, but because the Tax Authorities require your invoice numbering to increase chronologically, we cannot use the standard invoice number for this.",
            "infoLine3": "You can therefore choose a different invoice numbering series for invoices for old orders, this way the numbers will continue to increase chronologically.",
            "infoTitle": "Invoice requests for old orders",
            "invoiceNumTitle": "Invoice number for old orders",
            "prefix": "Prefix",
            "startWith": "Start with",
            "toggleLabel": "Auto-respond to requests for old orders"
        },
        "proactiveInfo": "With proactive uploading you ensure that for every new order, the invoice is uploaded after the order is completed. Customers can then find and download the VAT invoice in their Bol customer portal. This prevents invoice requests.",
        "proactiveUpload": "Proactive uploading",
        "recommended": "Recommended",
        "recommendedInfo": "We recommend enabling both proactive uploading and auto-responding.",
        "rule": {
            "allCountries": "All countries",
            "autoUploadFor": "automatically upload for",
            "countries": "countries",
            "in": "in"
        },
        "ruleType": {
            "not": "Do not",
            "only": "Only"
        },
        "rules": {
            "addRule": "Add rule",
            "description": "Invoices are only uploaded automatically when this condition is met.",
            "title": "Only upload when certain condition applies"
        },
        "sameAsTopRight": "Same settings as top right",
        "save": "Save",
        "saveFailed": "Failed to save the settings.",
        "saveFailedTitle": "Failed to save settings",
        "savedSuccess": "The settings have been saved"
    },
    "maintenance": {
        "backToWebsite": "Back to the website",
        "invalidPassword": "Invalid password",
        "message": "Bluemate is currently being updated to the latest version, so you can't use Bluemate temporarily. We're doing our best to complete the update as quickly as possible. Sorry for the inconvenience.",
        "password": "Password",
        "title": "Maintenance"
    },
    "mcpServer": {
        "crumb": "Agent MCP",
        "eyebrow": "MCP Server",
        "title": "Connect your own AI to bol and Bluemate data",
        "intro": "Give your AI assistant, such as ChatGPT or Claude, access to Bluemate and bol.",
        "introDiscover": "Ask questions and get answers through this MCP connection.",
        "installButton": "Read how to install",
        "featuresTitle": "What can you do with it?",
        "featureAskTitle": "Just ask",
        "featureAskText": "Ask your question in plain language. Your AI assistant uses the tools in the MCP to find the answer.",
        "featureSafeTitle": "Access & security",
        "featureSafeText": "You decide which rights the agent gets. Read-only, for example, so the agent cannot make any changes.",
        "featureClientsTitle": "Works with every AI",
        "featureClientsText": "Claude, ChatGPT, Gemini, Cursor and every other AI assistant that supports MCP.",
        "examplesTitle": "Example questions",
        "chat": {
            "monthQuestion": "How did last month go?",
            "monthIntro": "September was a good month. Your revenue rose by <0>12%</0> compared to August.",
            "monthColCurrent": "September",
            "monthColPrevious": "August",
            "monthColDiff": "Difference",
            "monthRowRevenue": "Revenue (incl. VAT)",
            "monthRowOrders": "Orders",
            "monthRowAverage": "Avg. order value",
            "monthRowAds": "Ad spend",
            "monthRowReturns": "Returns",
            "monthFollowUp": "Shall I look into the return reasons for the casserole?",
            "returnsQuestion": "Which products are returned most often?",
            "returnsIntro": "These are your most returned products of the past 12 months:",
            "returnsColProduct": "Product",
            "returnsColReturns": "Returns",
            "returnsFollowUp": "The casserole is sent back most often. Do you want to see the return reasons?",
            "seoQuestion": "How can I improve my product for SEO?",
            "seoIntro": "Your title for the <0>casserole</0> is English and misses the keywords customers search for on bol.com.",
            "seoCurrent": "<0>Now:</0> Enamel Cast Iron Casserole 4.2L - Red",
            "seoBetter": "<0>Better:</0> Gietijzeren braadpan 4,2 L – Dutch oven – Inductie – Rood",
            "seoColKeyword": "Top keywords",
            "seoColVolume": "Search volume / mo",
            "seoColInTitle": "In title now",
            "seoFollowUp": "The new title contains the 3 biggest keywords, with \"braadpan\" up front. Shall I improve the description as well?",
            "yes": "Yes",
            "no": "No"
        },
        "chatDisclaimer": "Example conversations with anonymized demo data.",
        "bottomTitle": "Connect your AI assistant to Bluemate",
        "bottomText": "Open the MCP page for installation instructions per assistant and an overview of all available tools.",
        "bottomButton": "Open the MCP page"
    },
    "menu": {
        "admin": "Admin",
        "apiConnection": "Connection",
        "chromeExtension": "Chrome Extension",
        "common": "General",
        "cron": "Cron",
        "defaultTemplates": "Default templates",
        "emails": "Emails",
        "export": "Export",
        "failedPayments": "Failed payments",
        "home": "Overview",
        "invoices": "Invoices",
        "layout": "Layout",
        "login": "Log in",
        "mcpServer": "Agent MCP",
        "mobileApp": "Mobile app",
        "new": "New",
        "notifications": "Notifications",
        "orders": "Orders",
        "peppol": "Peppol",
        "platformUsage": "Platform usage",
        "products": "Products",
        "referAFriend": "Refer a friend",
        "requests": "Requests",
        "returns": "Returns",
        "reviewAnalytics": "Review Insights",
        "salesDashboard": "Sales Dashboard",
        "searchRankings": "Search Rankings",
        "searchVolume": "Search volume",
        "security": "Security",
        "sendEmails": "Send emails",
        "settings": "Settings",
        "subscription": "Subscription",
        "thirtyDayImport": "30-day import",
        "threads": "Threads",
        "title": "Menu",
        "users": "Users",
        "vatDeclaration": "VAT Return"
    },
    "misc": {
        "infoBanner": {
            "close": "Close"
        },
        "pageChangePermission": {
            "allow": "Yes",
            "body": "Your changes have not been saved yet. Are you sure you want to continue?",
            "deny": "No",
            "title": "Unsaved changes"
        },
        "urlActions": {
            "activateFailed": "Activation failed",
            "activateFailedMessage": "We couldn't activate the Notifications module.",
            "addFailed": "Add failed",
            "addFailedMessage": "We couldn't add the notification.",
            "moduleAdded": "The Notifications module has been added to the subscription.",
            "moduleAddedTitle": "Module added",
            "notificationAdded": "The order notification has been added.",
            "notificationAddedTitle": "Notification added"
        },
        "validationErrors": {
            "title": "The following errors occurred:"
        }
    },
    "model": {
        "bolInvoiceRequest": {
            "oldOrder": "Old order, invoice not in Bluemate, manual action required",
            "open": "Open",
            "uploadFailedApiError": "Upload failed. Bol API error. Issue is known and reported.",
            "uploadFailedTimeout": "Upload failed. Bol API timeout. Please try again.",
            "uploaded": "Uploaded",
            "uploading": "Uploading",
            "viaAutoRespond": "via auto-reply",
            "viaManual": "via manual",
            "viaProactive": "via proactive"
        }
    },
    "notifications": {
        "add": {
            "betaBadge": "Beta",
            "buyBoxDescription": "Get an email when the buy box changes",
            "buyBoxLabel": "Buy box notification",
            "headerTitle": "Add a notification",
            "typeStepSubtitle": "Choose a trigger type",
            "channelsStepTitle": "Select channels & destinations",
            "channelsStepSubtitle": "Delivery settings",
            "channelsTitle": "How do you want to receive the notifications?",
            "channelsText": "Choose one or more channels below. If you select e-mail, you can also configure the email address.",
            "emailChannelTitle": "Email notification",
            "emailChannelText": "Receive notifications by email",
            "emailRequiredHint": "Enter an e-mail address to receive this notification.",
            "pushChannelTitle": "Push notification",
            "pushChannelDevicesText": "Receive push notifications on the selected devices",
            "devicesNone": "Select devices",
            "devicesRequiredHint": "Select at least one device to receive push notifications.",
            "pushOtherDevicesHint": "This device can only enable them in the Bluemate app — your other devices still receive the notifications.",
            "successStepTitle": "Notification added",
            "successStepSubtitle": "Confirmation",
            "successTitle": "Notification added successfully",
            "successTextMail": "You will now receive e-mail notifications for the configured triggers.",
            "successTextPush": "You will now receive push notifications on the selected devices for the configured triggers.",
            "successTextBoth": "You will now receive e-mail and push notifications for the configured triggers.",
            "successTestTitleMail": "Verify immediately if the e-mail arrives correctly:",
            "successTestTitlePush": "Verify immediately if push messages arrive correctly:",
            "successTestTitleBoth": "Verify immediately if the e-mail and push messages arrive correctly:",
            "successTestBoth": "Send test e-mail + push notification",
            "successTestPush": "Send test push notification",
            "successTestMail": "Send test e-mail",
            "successClose": "Close",
            "finishLabelShort": "Add",
            "backShort": "Back",
            "duplicateTitle": "Notification already exists",
            "duplicateText": "There is already an active notification of this type for one or more of the selected channels. Are you sure you want to add this extra notification? This may lead to duplicate messages.",
            "duplicateAdjust": "Adjust channels",
            "duplicateConfirm": "Yes, add",
            "finishLabel": "Add notification",
            "orderDescription": "Get an email when there are new orders",
            "orderLabel": "Order notification",
            "premiumBadge": "Premium notification",
            "productHijackDescription": "Get an email when a competitor also appears as a seller on your product.",
            "productHijackLabel": "Product hijack notification",
            "addPremium": "Add premium...",
            "reviewDescription": "Get an email when there are new reviews",
            "reviewLabel": "Review notification",
            "stockDescription": "Get an email when stock is running low",
            "stockLabel": "Stock notification",
            "pushTargetUnresolved": "The push notification could not be linked to this device. Enable push on the notification card."
        },
        "buyBox": {
            "atLabel": "At",
            "eventChange": "Buy box change",
            "minOneEvent": "Choose at least one event",
            "eventGot": "Buy box won",
            "eventLost": "Buy box lost",
            "tipLabel": "Tip",
            "tipLine1": "Getting a lot of buy box notifications?",
            "tipLine2": "This often happens due to high competition, automated repricers, and changing delivery promises on weekends.",
            "tipLine3": "Want to keep these alerts out of your main inbox?",
            "tipLinkText": "👉 Read here how to automatically receive them in a separate folder in Gmail or Outlook.",
            "title": "Buy box notification"
        },
        "components": {
            "betaBadge": "Beta",
            "cancel": "Cancel",
            "confirm": "Confirm",
            "deleteNotification": "Delete notification",
            "intervalDay": "day",
            "intervalInstant": "instant",
            "intervalMonth": "month",
            "intervalPerLabel": "per",
            "intervalWeek": "week",
            "intervalWhen": "When",
            "notificationUpdateErrorMessage": "Updating the notification failed.",
            "notificationUpdateErrorTitle": "Update failed",
            "notificationUpdatedSnackbar": "The notification has been updated",
            "productsSavedSnackbar": "Products saved",
            "premiumBadge": "Premium",
            "premiumInfo": "This notification is a premium notification and is available via the Notifications module.",
            "premiumTrialInfo": "Free to use during your trial period.",
            "productsForLabel": "for",
            "selectRemainingInfo": "With this option, all products not covered by another notification of this type are automatically selected.",
            "sendEmailToLabel": "Send email to",
            "sendNotificationToShort": "to",
            "emailSavedSnackbar": "Email address saved",
            "sendNotificationVia": "send a notification via",
            "sendTestNotification": "Send test notification",
            "channelEmail": "e-mail",
            "channelsEmail": "E-mail",
            "channelsPush": "Push notification",
            "channelsEmailPush": "E-mail and push notification",
            "channelsNone": "no channels",
            "deviceSingular": "device",
            "devicePlural": "devices",
            "thisDeviceAppOnly": "{{device}} (in the app only)",
            "minOneChannel": "Choose at least one delivery channel"
        },
        "feedback": {
            "cancel": "Cancel",
            "headerTitle": "Let us know what else you'd like notifications for",
            "placeholder": "What else would you like to receive notifications for?",
            "sendErrorMessage": "Sending the feedback failed.",
            "sendErrorTitle": "Send failed",
            "submit": "Send feedback",
            "thanksSnackbar": "Thanks for the feedback!"
        },
        "list": {
            "addEmailNotification": "Add notification",
            "breadcrumb": "Notifications",
            "deleteConfirmMessage": "Are you sure you want to delete this notification?",
            "deleteConfirmNo": "No",
            "deleteConfirmTitle": "Delete notification",
            "deleteConfirmYes": "Yes",
            "infoBannerText": "Receive email notifications for important events, so you stay informed and can take action if needed.",
            "loadErrorMessage": "No notifications found.",
            "loadErrorTitle": "Notifications not found",
            "notificationAddErrorMessage": "Adding the notification failed.",
            "notificationAddErrorTitle": "Add failed",
            "notificationDeleteErrorMessage": "Deleting the notification failed.",
            "notificationDeleteErrorTitle": "Delete failed",
            "notificationDeletedSnackbar": "The notification has been deleted",
            "notificationSendErrorMessage": "Sending the notification failed.",
            "notificationSendErrorTitle": "Send failed",
            "notificationSentSnackbar": "The notification has been sent",
            "notificationAddedSnackbar": "The notification has been added",
            "notificationChannelsNotSavedSnackbar": "The notification has been added, but its delivery channels could not be saved. Adjust them on the card.",
            "subtitle": "Receive a notification by email or on mobile for the triggers below:",
            "title": "Notifications"
        },
        "order": {
            "productsText": "For new orders for",
            "title": "Order notification"
        },
        "productHijack": {
            "productsText": "For a new seller on",
            "title": "Product hijack notification"
        },
        "reviews": {
            "allScores": "All scores",
            "minOneScore": "Choose at least one score",
            "newReviewsWith": "For new reviews with",
            "scoresSuffix": "scores",
            "starPlural": "stars",
            "starSingular": "star",
            "title": "Review notification"
        },
        "stock": {
            "thresholdInputLabel": "Stock less than",
            "thresholdLabel": "When stock is less than",
            "title": "Stock notification"
        },
        "swUnavailable": "Service Worker is unavailable — push notifications will not work in this session. Reload the page or use an up-to-date browser.",
        "errors": {
            "NO_ACTIVE_CONNECTION": "You have no active connection with Bol.",
            "NO_PRODUCTS_FOUND": "No products found to send the test notification with.",
            "EMAIL_SEND_FAILED": "Failed to send the email.",
            "NO_EVENTS_SELECTED": "No events have been selected for this notification.",
            "ACCOUNT_NOT_FOUND": "The sales account could not be found.",
            "NOTIFICATION_NOT_FOUND": "The notification could not be found."
        }
    },
    "oauth": {
        "authorize": {
            "cancelAction": "Go back",
            "cancelQuestion": "Don't want to connect your AI assistant?",
            "continue": "Continue with the signed-in account",
            "continueAs": "Continue as {{account}}",
            "doneProse": "The connection was set up successfully. You will be returned to your AI assistant automatically.",
            "failed": "Connecting the external application failed. Please try again.",
            "invalidRequest": "This connection request is incomplete. Start the connection again from your AI assistant.",
            "resolving": "One moment...",
            "retry": "Try again",
            "returnToApp": "Return to your AI assistant",
            "signInIntro": "Sign in with your Bluemate account to finish connecting.",
            "signInTitle": "Sign in to connect",
            "signedInAs": "You are signed in as {{account}}. Continue with this account or sign in with another account.",
            "signedInUnnamed": "You are signed in. Continue with this account or sign in with another account.",
            "statusCancelling": "Cancelling...",
            "statusConnecting": "Connecting to Bluemate MCP...",
            "statusError": "Connection failed",
            "statusSuccess": "Connected!",
            "step1": "Access",
            "step2": "Account",
            "step3": "Done",
            "switchAccount": "Sign in with another account",
            "title": "Connection with Bluemate MCP Server"
        },
        "bol": {
            "continue": "Continue",
            "retry": "Try again",
            "statusError": "Authorization failed",
            "statusSuccess": "Connection complete",
            "statusValidating": "Testing connection...",
            "testing": "One moment — we're testing the connection.",
            "title": "Connection with Bol"
        },
        "connectionFailed": "Connecting with Bol failed.",
        "codeNotFound": "We did not receive a authorisation code from Bol."
    },
    "pdfTemplate": {
        "allowLeave": "Yes, leave page",
        "copied": "The layout has been copied",
        "crumb": "Invoice Layout",
        "denyLeave": "No, stay on page",
        "editor": {
            "bannerText": "Design your invoice layout so that every invoice is sent in your own brand style.",
            "bannerTitle": "Invoice layout",
            "importFrom": "Import from...",
            "price": "Price",
            "productName": "Product name",
            "quantity": "Quantity",
            "subtotal": "Subtotal excl. VAT",
            "vat": "VAT"
        },
        "errors": {
            "copy": "Failed to copy the layout.",
            "copyTitle": "Copy failed",
            "preview": "Failed to create a preview invoice.",
            "previewTitle": "Preview failed",
            "save": "Failed to save the PDF template",
            "saveTitle": "Save failed"
        },
        "importDescription": "Import an invoice template from another account.",
        "importTitle": "Import template",
        "saved": "The PDF template has been saved",
        "unsavedChanges": "Any changes will be lost if you leave the page without saving. Are you sure you want to leave?",
        "warningLabel": "Note: ",
        "warningText": "the current template will be overwritten!"
    },
    "productCosts": {
        "add": "add",
        "addCosts": "+ Add costs",
        "addMiscPer": "+ Costs per",
        "backToList": "Back to list",
        "choosePackageSize": "Choose package size",
        "close": "Close",
        "columns": {
            "costPrice": "COST PRICE",
            "endDate": "END DATE",
            "fulfilmentCosts": "FULFILLMENT COSTS",
            "fulfilmentType": "FULFILLMENT TYPE",
            "miscPerOrder": "MISC PER ORDER",
            "miscPerProduct": "MISC PER PRODUCT",
            "sendCosts": "SHIPPING COSTS",
            "startDate": "START DATE"
        },
        "costPrice": "Cost price",
        "delete": "Delete",
        "deleteFailed": "Delete failed",
        "deleteFailedMessage": "Deleting the costs failed.",
        "deleted": "The costs have been deleted",
        "edit": "Edit",
        "editCosts": "Edit costs",
        "endDate": "End date",
        "fbbPackageSize": "FBB package size",
        "fulfilment": {
            "fbb": "FBB",
            "fbr": "Own fulfillment"
        },
        "fulfilmentCosts": "Fulfillment costs",
        "fulfilmentType": "Fulfillment type",
        "loadFailed": "Loading failed",
        "loadFailedMessage": "Loading the costs failed.",
        "miscCostsLabel": "Other costs",
        "miscPer": "Other costs per",
        "noCosts": "You have not set up any costs yet",
        "noEndDate": "No end date",
        "of": "of",
        "pageChange": {
            "allow": "No, close",
            "body": "Your changes will be lost if you continue. Do you want to save the changes first?",
            "deny": "Yes, save changes"
        },
        "priceLow": "Price below €16,-",
        "priceNormal": "Price from €16,-",
        "productCosts": "Product costs",
        "salePrice": "Sale price",
        "saveChanges": "Save changes",
        "saveFailed": "Save failed",
        "saveFailedMessage": "Saving the costs failed.",
        "saved": "The costs have been saved",
        "sendCostType": {
            "order": "Order",
            "product": "Product"
        },
        "sendCosts": "Shipping costs",
        "sendCostsPer": "Shipping costs per",
        "startDate": "Start date",
        "tabs": {
            "all": "All",
            "fbb": "FBB",
            "ownShipping": "Own shipping"
        }
    },
    "productSelection": {
        "availableProducts": "Available products",
        "deselectAll": "Deselect all",
        "done": "Done",
        "ean": "EAN",
        "importFailed": "Import failed",
        "importFailedMessage": "Importing your products failed.",
        "importSnackbar": "The products are being imported",
        "loadFailed": "Loading products failed",
        "loadFailedMessage": "Failed to load the products.",
        "loadingProduct": "Loading product...",
        "next": "Next",
        "productName": "Product name",
        "remainingSelected": "Remaining products selected",
        "remainingSelectedInfo": "Top-left, the box \"Select remaining products\" lets you select remaining/no products",
        "searchPlaceholder": "EAN or product name",
        "searchProduct": "Search for a product",
        "searchedFor": "Searched for",
        "selectAll": "Select all",
        "selectRemaining": "Select remaining products",
        "selectRemainingInfo": "With this option, all products for which no other email is set up are automatically selected.",
        "selectedProducts": "Selected products",
        "sync": "Sync with Bol",
        "title": "Select products",
        "withSearchTerm": "with search term"
    },
    "products": {
        "bolNameFailed": "Could not fetch the name from bol.",
        "bolWarning": "Every change you make here applies to Bluemate only, not to bol itself.",
        "costs": {
            "label": "Costs",
            "notSet": "Not set"
        },
        "crumb": "Products",
        "defaultVat": {
            "cancel": "Cancel",
            "optionsTitle": "Set default VAT rates",
            "save": "Save",
            "title": "Default VAT"
        },
        "download": {
            "failed": "Downloading the QR code failed.",
            "failedTitle": "Download failed",
            "onlyVisible": "QR codes are only available for visible products. Show this product again, or wait until it is active on bol.",
            "tooltip": "Download the QR code that links to writing a review. Add it to your packaging to get more product reviews on bol.",
            "unavailable": "No QR code available: this product does not have a product page on bol yet."
        },
        "downloadAll": {
            "label": "All QR"
        },
        "editCosts": {
            "add": "Add",
            "addNewRecord": "Add new costs",
            "advanced": "Advanced options",
            "cancel": "Cancel",
            "confirmDelete": "Are you sure you want to delete these product costs?",
            "costPrice": "Cost price per unit",
            "costPriceHint": "What one unit costs you to buy. Bluemate subtracts this amount per sold unit from your revenue to calculate profit.",
            "costPriceShort": "Total costs",
            "created": "The product costs have been saved",
            "datePlaceholder": "dd-mm-yyyy",
            "delete": "Delete",
            "deleteFailed": "Deleting the product costs failed.",
            "deleteFailedTitle": "Delete failed",
            "deleted": "The product costs have been deleted",
            "descriptionPlaceholder": "Description for myself",
            "duplicateDate": "Costs with this start date and quantity already exist.",
            "editingRecord": "You are editing the costs valid from {{date}}",
            "from": "From",
            "fulfilmentBol": "Fulfilment by bol (LVB)",
            "fulfilmentOwn": "Own fulfilment",
            "history": "History",
            "historyEmpty": "No product costs entered yet.",
            "historyHint": "Every change starting on a new date shows up here as its own row. Click the pencil to edit that period. Older orders keep the costs of their own period.",
            "invalidAmount": "Enter a valid amount",
            "loadFailed": "Loading the product costs failed.",
            "loadFailedTitle": "Loading failed",
            "lvbSize": "LVB size",
            "lvbSizeHint": "The bol size that determines the LVB fulfilment costs. Bluemate determines it automatically from the product's dimensions at bol.",
            "lvbUnknown": "Unknown",
            "minQuantity": "From quantity of products",
            "minQuantityHint": "The number of units in one order line from which these costs apply. Leave it at 1 unless you use quantity tiers. With several tiers Bluemate uses the highest one that fits.",
            "minQuantityShort": "From quantity",
            "miscCosts": "Other costs",
            "miscCostsDesc": "Description of other costs",
            "miscCostsDescHint": "A note for yourself about where these other costs come from. It does not affect the calculation.",
            "miscCostsHint": "Other costs per unit that are not covered by the fields above, for example packaging or a licence. They count towards the profit calculation.",
            "negative": "The amount cannot be negative",
            "no": "No",
            "overwrite": "Overwrite",
            "pickCosts": "Pick & pack costs (own shipping)",
            "pickCostsHint": "What it costs you to get one order ready for shipping. Only counted for your own shipping. For LVB, Bluemate uses bol’s tariffs.",
            "returnCosts": "Return costs",
            "returnCostsDesc": "Description of return costs",
            "returnCostsDescHint": "A note for yourself about where these return costs come from. It does not affect the calculation.",
            "returnCostsHint": "What one return costs you on average, for example the return label, checking and repacking. Bluemate deducts this as soon as an order is returned.",
            "saveFailed": "Saving the product costs failed.",
            "saveFailedTitle": "Save failed",
            "sectionFulfilment": "Fulfilment costs",
            "sectionFulfilmentHint": "LVB size and the costs of your own shipping",
            "sectionMisc": "Other costs",
            "sectionMiscHint": "Per-unit costs that are not covered anywhere else",
            "sectionQuantity": "Quantity",
            "sectionQuantityHint": "From how many units these costs apply",
            "sectionReturns": "Return costs",
            "sectionReturnsHint": "What one return costs you on average",
            "sendCosts": "Shipping costs (own shipping)",
            "sendCostsHint": "The carrier costs per order when you ship yourself, for example the parcel label. Not counted for LVB.",
            "stopEditing": "Stop editing",
            "titleFor": "Edit costs for {{name}}",
            "until": "Until",
            "untilNow": "now",
            "updated": "The product costs have been updated",
            "yes": "Yes",
            "always": "Forever",
            "fromToday": "From today",
            "pickFromDate": "Pick from date"
        },
        "editName": {
            "cancel": "Cancel",
            "failed": "Saving the product name failed.",
            "failedTitle": "Save failed",
            "info": "This name change applies to the product name shown on Bluemate and on invoices. For example, you can make a product name on Bluemate invoices shorter and more recognizable.",
            "label": "Product name",
            "save": "Save",
            "saved": "The product name has been saved",
            "title": "Edit product name"
        },
        "empty": {
            "connect": "First connect with bol to see your products.",
            "subtitle": "As soon as your products have been synced with bol, they will appear here.",
            "title": "No products available yet"
        },
        "filter": {
            "all": "All",
            "hidden": "Hidden"
        },
        "group": {
            "all": "All products",
            "hidden": "Hidden products",
            "visible": "Visible products"
        },
        "hide": {
            "done": "The product has been hidden",
            "failed": "Failed to hide the product.",
            "failedTitle": "Hide failed"
        },
        "hideDialog": {
            "ackChannels": "I understand that this product will no longer be included in e-mails and notifications. If it is currently included, it will be excluded.",
            "ackLists": "I understand that I will no longer see this product in lists and overviews.",
            "body": "The product will no longer be shown in the lists and overviews of Bluemate and will no longer be used in e-mails, notifications, etc. This option is meant for products you no longer sell or no longer want to see. You can always show the product again here. This change only applies to Bluemate and not to bol itself.",
            "cancel": "Cancel",
            "confirm": "Hide",
            "dontShowAgain": "Don't show again",
            "title": "Hide product?"
        },
        "importExport": {
            "chooseLabel": "Choose what you want to import or export:",
            "close": "Close",
            "dropzoneHint": "Or drag the file here (.xlsx)",
            "dropzoneLabel": "Click to choose an .xlsx file",
            "exportFailed": "Exporting the data failed.",
            "exportFailedTitle": "Export failed",
            "importDoneWithErrors": "Import completed, with errors",
            "importFailedMsg": "Importing the data failed.",
            "importFailedTitle": "Import failed",
            "importSuccess": "Successfully updated {{num}} {{label}}",
            "label": "Import & Export...",
            "modeCost": "Cost",
            "modeVat": "VAT",
            "onlyXlsxAccepted": "We only accept .xlsx files, please use the example file.",
            "partialImportError": "{{imported}} rows were imported, but {{errors}} could{{suffix}} not be imported. See the file below for details.",
            "row": "row",
            "rows": "rows",
            "templateLink": "Download the example file",
            "title": "Import & Export",
            "upload": "Upload",
            "vat": {
                "vat": "VAT",
                "exportTitle": "Export",
                "exportDescription": "Download an Excel overview of all your products with their current VAT rates.",
                "exportButton": "Export VAT (.xlsx)",
                "importTitle": "Import",
                "importDescription": "Upload an Excel file to update the VAT rates in bulk.",
                "formatNote": "format: EAN, VAT % per country",
                "applyToExisting": "Also apply VAT to existing invoices",
                "downloadErrorFile": "Download import-fouten.xlsx"
            },
            "costs": {
                "productCosts": "Product costs",
                "subtitle": "You can also update product costs individually by clicking the product costs cell in the table.",
                "exportTitle": "Export",
                "exportDescription": "Download an Excel overview of all your product costs.",
                "exportButton": "Export product costs (.xlsx)",
                "importTitle": "Import",
                "importDescription": "Upload an Excel file to update the product costs in bulk.",
                "formatNote": "format: EAN, Start date, Cost price, From quantity, Fulfilment costs, Shipping costs, Return label costs, Other return costs, Description other return costs, Other costs, Description other costs"
            }
        },
        "intro": {
            "qrInfoTooltip": "How the QR codes work",
            "title": "Physical QR codes for more reviews",
            "body2": "Use physical QR codes for more product reviews. Download and print the unique QR for each product and include it in your packaging. Scanning takes customers straight to the product's review page on bol, making it easy to leave a review. We track the number of scans.",
            "gotIt": "Got it",
            "imageAlt": "QR card in a package"
        },
        "load": {
            "failed": "Loading the products failed.",
            "failedTitle": "Loading failed"
        },
        "menu": {
            "editCosts": "Edit costs…",
            "editName": "Edit name…",
            "editVat": "Edit VAT…",
            "hide": "Hide…",
            "show": "Show"
        },
        "notFound": {
            "subtitle": "Try a different search term or another filter.",
            "title": "No products found"
        },
        "scansLabel": "QR scans",
        "scansTooltip": "The number of times this QR code has been scanned",
        "scansUnavailable": "Scans are not shown here for hidden products or products that are inactive on bol. Scans of printed QR codes keep being registered.",
        "searchPlaceholder": "Search by EAN or title",
        "show": {
            "done": "The product is now visible again",
            "failed": "Failed to show the product again.",
            "failedTitle": "Show failed"
        },
        "status": {
            "hidden": "Hidden",
            "hiddenTooltip": "You hid this product yourself. It is no longer shown in lists and overviews and is not used in emails or notifications. This change only applies within Bluemate, not on bol itself — you can show it again here.",
            "inactive": "Inactive on bol",
            "inactiveTooltip": "This product is no longer active on bol. It does not count towards e-mails and notifications. That status comes from bol and does not change when you hide or show the product here.",
            "visible": "Visible"
        },
        "subtitle": "Manage your products here: name, VAT, costs, visibility and QR codes.",
        "subtitleReviews": "Want to collect more reviews?<0/>Add physical QR codes to your packaging.<0/>They take a customer straight to the review page of the product on bol. See an <1>example</1>.",
        "sync": {
            "button": "Sync with Bol",
            "failed": "Failed to fetch the products.",
            "failedTitle": "Fetch failed",
            "fetching": "Fetching products",
            "fetchingCount": "Fetching {{count}} products",
            "started": "Products are being fetched"
        },
        "title": "Products",
        "vat": {
            "default": "Default",
            "label": "VAT"
        }
    },
    "referAFriend": {
        "crumb": "Refer a friend",
        "disclaimer": "The credit comes off your invoices, so you pay less or nothing. Referrals can't be combined with other promotions. Self-referrals are not allowed. Bluemate reserves the right to change or end the program at any time. Bluemate reserves the right to refuse referrals. Bluemate reserves the right to change the terms of this program at any time.",
        "emailPlaceholder": "Email address",
        "friendEmail": "Friend's Bluemate email address",
        "howItWorks": "How does it work?",
        "intro": "We've recently started asking users at registration how they found us. A full 26% hear about us through a friend. We'd like to share in this success together. Both of you receive €50 credit in Bluemate.",
        "myEmail": "My Bluemate email address",
        "snackbar": "Thanks! The request has been submitted, we'll get in touch with you as soon as possible.",
        "step1": "You're already a paying user at Bluemate. Have your friend start a paid subscription at Bluemate.",
        "step2": "Enter the email address they registered with below and send the email.",
        "step3": "Once your friend has paid the first invoice, you'll both receive €50 credit in Bluemate.",
        "step4": "Repeat this as many times as you want with more friends!",
        "submit": "Submit",
        "submitFailed": "Submit failed",
        "submitFailedMessage": "We couldn't submit the request.",
        "terms": {
            "existingAccount": "My friend has an existing Bluemate account with this email address.",
            "firstPayment": "I understand that the credits are awarded after my friend has paid the first invoice.",
            "paidSub": "I understand that both my friend and I must have started the subscription."
        },
        "title": "Refer a friend and you both get €50"
    },
    "returns": {
        "banner": {
            "body": "View return statuses from bol. Create credit invoices and view reasons.",
            "title": "Returns"
        },
        "count": {
            "accepted": "processed",
            "canceled": "canceled",
            "open": "open",
            "rejected": "rejected"
        },
        "creditInvoiceCreated": "Credit invoice created",
        "creditInvoiceSent": "Credit invoice sent",
        "crumb": "Returns",
        "details": {
            "close": "Close",
            "credit": "Credit",
            "creditInvoice": "Credit invoice",
            "creditInvoiceSent": "Credit invoice sent",
            "customer": "Customer",
            "description": "Description",
            "handling": "Processing",
            "na": "n/a",
            "notCredited": "Not credited",
            "notFound": "Not found",
            "options": "Options",
            "orderNumber": "Order number",
            "originalInvoice": "Original invoice",
            "processedAt": "Processed on",
            "reason": "Reason",
            "registeredAt": "Registered on",
            "returnPrefix": "Return",
            "rmaId": "RMA ID",
            "sendCreditInvoice": "Send credit invoice",
            "showOnBol": "Show on Bol",
            "status": "Status",
            "toCreditInvoice": "To credit invoice",
            "toInvoice": "To invoice"
        },
        "dialog": {
            "createCreditTitle": "Create credit invoice",
            "creditCreatedMessage": "The credit invoice has been created. Would you like to send it directly to the customers?",
            "creditCreatedTitle": "Credit invoice created",
            "creditOrderTitle": "Credit the order",
            "creditsCreatedMessage": "The credit invoices have been created. Would you like to send them directly to the customers?",
            "creditsCreatedTitle": "Credit invoices created",
            "multipleItemsMessage": "Multiple items were found for this return order. Would you like to add all items to the credit invoice?",
            "notProcessedMessage": "The return has not yet been processed and can therefore still be canceled or rejected. Do you still want to credit the order?"
        },
        "error": {
            "createCreditFailed": "Creating the credit invoice failed.",
            "createCreditFailedTitle": "Creating credit invoice failed",
            "loadFailed": "Loading the returns failed.",
            "loadFailedTitle": "Loading failed",
            "sendCreditFailed": "Sending the credit invoice failed.",
            "sendCreditInvoiceFailed": "Sending the credit invoice failed.",
            "sendCreditInvoicesFailed": "Sending the credit invoices failed.",
            "sendFailedTitle": "Send failed"
        },
        "filter": {
            "statusLabel": "Return status"
        },
        "header": {
            "date": "DATE",
            "orderId": "ORDER ID",
            "returnId": "RETURN ID",
            "rmaId": "RMA ID",
            "status": "STATUS"
        },
        "notFound": {
            "and": "and",
            "searchTerm": "the search term '{{search}}'",
            "statusTerm": "the status {{status}}",
            "subtitle": "No returns{{term}}can be found.",
            "title": "No returns found",
            "with": "with"
        },
        "pager": {
            "of": "of"
        },
        "search": {
            "label": "Search return",
            "placeholder": "Search..."
        },
        "snackbar": {
            "creditCreated": "The credit invoice has been created.",
            "creditSent": "The credit invoice has been sent",
            "invoiceSent": "The invoice has been sent",
            "invoicesSent": "The invoices have been sent"
        },
        "status": {
            "accepted": "Processed",
            "all": "All",
            "canceled": "Canceled",
            "open": "Open",
            "rejected": "Rejected"
        }
    },
    "feedback": {
        "tooltip": "Feedback or report a problem",
        "title": "Feedback or report a problem",
        "subtitle": "Let us know what could be better or what isn't working. Please give us clear details.",
        "placeholder": "Example A: \"Since Tuesday morning, uploading invoices to Bol no longer works. For order number 1234567890 I get 'Invoice not accepted'.\"\n\nExample B: \"It would be nice if I could automatically receive an e-mail when a return comes in.\"",
        "submit": "Send",
        "cancel": "Cancel",
        "thanksSnackbar": "Thanks for your feedback!",
        "sendErrorTitle": "Sending failed",
        "sendErrorMessage": "We couldn't send your feedback."
    },
    "reverseCharge": {
        "cancel": "Cancel",
        "createFailed": "VAT reverse charge failed",
        "createFailedMessage": "Creating the reverse-charged VAT invoice failed.",
        "createdMessage": "The current invoice has been credited and a new (reverse-charged) invoice has been created. Would you like to send the credit invoice and new invoice to the customer?",
        "createdSnackbar": "The reverse-charged VAT invoice has been created",
        "createdTitle": "Invoice created",
        "description": "To reverse-charge the VAT, a correct VAT number of the customer must be placed on the invoice. Check the VAT number and the country of the customer below before the VAT is reverse-charged. The current invoice will be credited and a new (reverse-charged) invoice will be created.",
        "error": "Error",
        "errors": {
            "countryRequired": "Choose the country",
            "vatPrefix": "The VAT number must start with the country code",
            "vatRequired": "Enter the VAT number"
        },
        "no": "No",
        "sendFailed": "Send failed",
        "sendFailedMessage": "Sending the invoices failed.",
        "sentSnackbar": "The invoices have been sent",
        "submit": "Reverse-charge VAT",
        "title": "Reverse-charge VAT",
        "validationFailed": "Validation failed",
        "validationTimeoutMessage": "We cannot validate the VAT number because the VIES service is temporarily unavailable. As a result, we cannot guarantee that the VAT number is correct. Do you still want to proceed (at your own risk)?",
        "vatNumber": "VAT number *",
        "yes": "Yes"
    },
    "reviewAnalytics": {
        "banner": {
            "body": "View all reviews on your products in one overview. Discover trends with BluemateAI.",
            "title": "Review insights",
            "hideProducts": "Hide products you no longer sell? Now you can. Choose which products to hide on the “Products” page. Products that have been inactive on bol for 2 weeks will be hidden automatically."
        },
        "chart": {
            "negative": "Negative",
            "positive": "Positive"
        },
        "crumb": "Review Insights",
        "export": {
            "all": "All",
            "allScores": "All scores",
            "cancel": "Cancel",
            "confirmDeleteMessage": "Are you sure you want to delete this export?",
            "createNewExport": "Create new export",
            "createdAt": "CREATED ON",
            "deleteExport": "Delete export",
            "deleteFailed": "Delete failed",
            "deleteFailedMessage": "Deleting the export failed.",
            "deselect": "deselect",
            "downloadExport": "download export",
            "downloadFailed": "Download failed",
            "downloadFailedMessage": "Downloading the export failed.",
            "export": "Export",
            "exportDeleted": "The export has been deleted",
            "exportFailed": "Export failed",
            "exportFileNotFound": "The export file cannot be found.",
            "exportForAccounts": "Export reviews for accounts",
            "exportReviews": "Export reviews",
            "exportReviewsFor": "Export reviews for",
            "filterByScore": "Filter by score",
            "fromDate": "From date",
            "fromDateHeader": "FROM DATE",
            "loadExportsFailed": "Loading the exports failed.",
            "loadFailed": "Loading failed",
            "no": "No",
            "noExports": "You have not created any exports yet",
            "ok": "OK",
            "optional": "Optional",
            "processInfo": "The reviews export has started. Depending on the number of reviews this can take a while; you can leave the page in the meantime.",
            "ready": "Ready",
            "reviewsExporting": "Reviews are being exported...",
            "select": "select",
            "selectedScores": "SELECTED SCORES",
            "startExportFailedMessage": "Starting the export failed.",
            "status": "STATUS",
            "toDate": "Through date",
            "toDateHeader": "TO DATE",
            "yes": "Yes"
        },
        "feedProductSelect": {
            "analyseWithAI": "Analyze with BluemateAI...",
            "chooseProduct": "Choose a product",
            "emptyMessage": "Collecting data — come back tomorrow...",
            "loadFailed": "Loading failed",
            "loadProductsFailed": "Loading the products failed.",
            "nameOrEan": "Name or EAN"
        },
        "nps": {
            "info": "The NPS (net promoter score) indicates how likely your customers are to recommend the product they bought to others. This score is calculated by subtracting the percentage of negative reviews (1, 2, or 3 stars) from the percentage of positive reviews (5 stars). This score ranges from -100 to 100, where -100 indicates that there are only negative reviews and 100 indicates that there are only positive reviews.",
            "title": "Net Promoter Score"
        },
        "period": {
            "last30Days": "Last 30 days"
        },
        "periodLabel": {
            "day": "day",
            "days": "days",
            "last": "LAST"
        },
        "productReviews": {
            "analyse": {
                "analyseWithAI": "Analyze with BluemateAI",
                "customers": "Customer persona",
                "failed": "AI analysis failed",
                "improvements": "Improvement points",
                "negative": "Negative points",
                "positive": "Positive points",
                "target": "Typical target audience"
            },
            "leastStars": "Fewest stars",
            "loadCountsFailed": "Loading the review counts failed.",
            "loadFailed": "Loading failed",
            "loadProductsFailed": "Loading the products failed.",
            "mostHelpful": "Most helpful",
            "mostStars": "Most stars",
            "newest": "Newest",
            "noReviews": "This product has no reviews yet",
            "noReviewsFound": "No reviews can be found.",
            "productLoadFailed": "Product could not be loaded",
            "productLoading": "Product is loading...",
            "sortBy": "Sort by",
            "viewInSellerAccount": "View product in your sales account",
            "viewOnBol": "View product on bol"
        },
        "reviewComponent": {
            "daysAgo": "days ago",
            "new": "New",
            "today": "Today",
            "viewAllReviews": "View and analyze all reviews of this product",
            "viewOnBol": "View product on bol",
            "yesterday": "Yesterday"
        },
        "reviewFeed": {
            "title": "Reviews",
            "clearFilter": "Clear filter",
            "emptyCollecting": "Collecting data — come back tomorrow.",
            "emptyIntro": "Here you will soon see all your product reviews in one handy overview.",
            "filterStars": "Filter number of stars",
            "loadFailed": "Loading failed",
            "loadFeedFailed": "Loading the feed failed.",
            "loadMore": "Load more",
            "viewAllReviews": "View and analyze all reviews of this product",
            "viewInSellerAccount": "View product in your sales account",
            "viewOnBol": "View product on bol",
            "countTooltip": "The total number of reviews in the list below"
        },
        "reviewsTable": {
            "emptyMessage": "Collecting data — come back tomorrow...",
            "loadFailed": "Loading failed",
            "loadProductsFailed": "Loading the products failed.",
            "name": "Name",
            "negative": "Negative",
            "period": "Period",
            "periodReviews": "Period reviews",
            "positive": "Positive",
            "rating": "Rating",
            "score": "Score",
            "search": "Search",
            "total": "Total",
            "totalReviews": "Total reviews",
            "until": "through"
        },
        "stats": {
            "negativeReviews": "NEGATIVE REVIEWS",
            "positiveReviews": "POSITIVE REVIEWS",
            "totalReviews": "TOTAL REVIEWS",
            "view": "view"
        },
        "statsDisplay": {
            "hideChart": "Hide chart",
            "showChart": "Show chart"
        },
        "tabs": {
            "export": "Export",
            "feed": "Feed",
            "products": "Products",
            "settings": "Settings"
        }
    },
    "salesDashboard": {
        "bannerBody": "Analyze your sales, profit and revenue per product and period in one overview.",
        "bannerTitle": "Sales Dashboard",
        "chart": {
            "revenueLabel": "Revenue"
        },
        "infoMessage": "We calculate these figures based on the incoming orders and returns from Bol.\nThese figures are not always the same as the ones bol uses in its own portal.\nUse these figures only as an indication.\nFor help with the VAT return, we have the VAT return tool.",
        "chooseAccounts": "Choose account(s)",
        "combineSales": "Combine sales",
        "crumb": "Sales Dashboard",
        "customPeriod": {
            "apply": "Apply",
            "cancel": "Cancel",
            "datePlaceholder": "dd-mm-yyyy",
            "from": "From",
            "title": "Custom period",
            "until": "Through"
        },
        "emptyMessage": "No sales found",
        "exportFailedMsg": "Exporting the data failed.",
        "exportFailedTitle": "Export failed",
        "exportToExcel": "Export to Excel",
        "period": {
            "currentMonth": "This month",
            "custom": "Custom...",
            "lastMonth": "Last month",
            "sevenDays": "Last 7 days",
            "thirtyDays": "Last 30 days",
            "today": "Today",
            "total": "Last 90 days",
            "yesterday": "Yesterday"
        },
        "productCostsUpload": {
            "cancel": "Cancel",
            "chooseFile": "Choose a .xlsx file to upload...",
            "downloadAllCosts": "all product costs you have already set.",
            "downloadHere": "Download here",
            "exportFailedMsg": "Exporting the data failed.",
            "exportFailedTitle": "Export failed",
            "importFailedMsg": "Importing the product costs failed.",
            "importFailedTitle": "Import failed",
            "importedSnackbar": "The product costs have been imported",
            "intro": "You can bulk upload product costs (<0>excl. VAT</0>) here.",
            "partialSuccess": "Importing the product costs partially succeeded, but the following errors were found:",
            "partialSuccessTitle": "Import partially succeeded",
            "rowLabel": "Row",
            "templateInfo": "the example of the correct format.",
            "title": "Import product costs",
            "upload": "Upload",
            "uploadImportFile": "Upload import file",
            "uploadOnlyXlsx": "Upload only a .xlsx file (Excel standard) in the format from the example.",
            "viewDownloadHere": "View and download here"
        },
        "recalculate": "Recalculate",
        "search": "Search",
        "stats": {
            "calculatedWithCosts": "is only calculated with products for which the costs have been set.",
            "margin": "PROFIT MARGIN",
            "marginInfoTitle": "The profit margin",
            "previousPeriod": "PREVIOUS PERIOD",
            "profit": "PROFIT",
            "profitInfoTitle": "The profit",
            "quantity": "UNITS SOLD",
            "revenue": "REVENUE"
        },
        "totalPeriodRevenue": "TOTAL PERIOD REVENUE",
        "uploadProductCosts": "Import product costs"
    },
    "salesDashboardV2": {
        "allShops": "All shops",
        "breadcrumb": "Sales Dashboard",
        "columns": "Columns",
        "comparison": "Comparison",
        "editCosts": {
            "loadFailed": "Loading the product failed.",
            "loadFailedTitle": "Loading failed"
        },
        "errorLoadProducts": "Loading the products failed.",
        "errorLoadTotals": "Loading the totals failed.",
        "export": "Export",
        "uploadProductCosts": "Import product costs",
        "filters": {
            "addFilter": "Add filter",
            "and": "and",
            "apply": "Apply",
            "between": "Between",
            "deleteFilter": "Delete filter",
            "equals": "Equals",
            "gt": "Greater than",
            "gte": "Greater than or equal to",
            "lt": "Less than",
            "lte": "Less than or equal to",
            "matchAll": "Match all rules",
            "matchAny": "Match any of the rules",
            "notEquals": "Not equal to",
            "value": "Value"
        },
        "loadFailed": "Loading failed",
        "margin": "Margin",
        "nColumns": "{{count}} columns",
        "nShops": "{{count}} shops",
        "numOrders": "Number of orders",
        "oneColumn": "1 column",
        "oneShop": "1 shop",
        "period": "Period",
        "productDetails": {
            "salesProductStats": {
                "adRevenue": "Ad revenue",
                "avgMargin": "Margin (average)",
                "costs": "Costs",
                "costsCum": "Costs (running total)",
                "cumulative": "Running total",
                "allProductsCumulative": "All products (running total)",
                "errorLoadProduct": "Loading the product failed.",
                "loadFailed": "Loading failed",
                "organicRevenue": "Organic revenue",
                "profit": "Profit",
                "profitCum": "Profit (running total)",
                "profitExcl": "Profit (excl. VAT)",
                "quantitySold": "Units sold",
                "quantitySoldCum": "Units sold (running total)",
                "returnQuantity": "Units returned",
                "returnQuantityCum": "Units returned (running total)",
                "returnRevenue": "Return revenue",
                "returnRevenueCum": "Return revenue (running total)",
                "returnRevenueExcl": "Return revenue (excl. VAT)",
                "revenue": "Revenue",
                "revenueCum": "Revenue (running total)",
                "revenueExcl": "Revenue (excl. VAT)",
                "revenueIncl": "Revenue (incl. VAT)",
                "viewOnBol": "View on bol.com",
                "globalPerformance": "Global Performance",
                "barGraph": "Bar chart",
                "lineGraph": "Line chart"
            }
        },
        "profitExcl": "Profit excl. VAT",
        "returnRevenueAlt": "Return revenue",
        "revenueExcl": "Revenue excl. VAT",
        "revenueIncl": "Revenue incl. VAT",
        "salesFrom": "Sales from",
        "searchPlaceholder": "Search product title or EAN...",
        "shops": "Shops",
        "table": {
            "adCosts": "Ad costs",
            "adRevenue": "Ad revenue",
            "advertising": "Advertising",
            "commission": "Commission",
            "costs": "Costs",
            "marginPct": "Margin %",
            "noProducts": "No products found",
            "noProductsHint": "Adjust your filters or add search terms.",
            "noResults": "0 results",
            "organicRevenue": "Organic revenue",
            "organicSold": "Organic sold",
            "paginationRange": "{{firstRow}}–{{lastRow}} of {{total}}",
            "previous": "Previous",
            "product": "Product",
            "productCosts": "Product costs",
            "productPlural": "products",
            "productSingular": "product",
            "profit": "Profit",
            "quantitySold": "Units sold",
            "returnCommission": "Return commission",
            "returnCosts": "Return costs",
            "returnQuantity": "Units returned",
            "returnRevenue": "Return revenue",
            "returns": "Returns",
            "revenue": "Revenue",
            "rowsPerPage": "Rows per page",
            "sales": "Sales",
            "vat": "VAT",
            "stock": "Stock",
            "stockInfo": "Current stock for this product, independant of the selected period."
        },
        "importExport": {
            "title": "Product Costs Import & Export"
        }
    },
    "searchRankings": {
        "addKeywords": {
            "add": "Add",
            "bulkHint": "Add in bulk?",
            "busy": "Busy...",
            "clickHere": "Click here",
            "keyword": "Keyword",
            "placeholder": "Enter a keyword",
            "snackbarAdded": "Keyword added",
            "snackbarError": "Something went wrong",
            "title": "Add keyword"
        },
        "allStores": "All stores",
        "noStores": "Nothing selected",
        "apiBannerTitle": "Welcome to Search Rankings!",
        "apiBanner": "See how high your products appear in the search results.\nTrack the keywords from Bol and add your most important keywords yourself.\n\nFirst refresh your connection with Bol:",
        "banner": {
            "text": "Track the positions of your products in the bol search results here weekly.\nWe show the most important search terms according to bol per product.\nYou can also add extra search terms you want to track yourself.\n\nThe rankings can be different from the shown positions on bol, because bol executes A/B tests regularly."
        },
        "columns": {
            "buyboxPercent": "Buy box %",
            "categories": "Categories",
            "keywords": "Keywords",
            "month": "Month",
            "monthly": "Monthly",
            "nps": "NPS",
            "quarter": "Quarter",
            "review": "Review",
            "reviews": "Reviews",
            "searchVolume": "Search volume",
            "tooltipBuyboxPercent": "Percentage of time with the buy box",
            "tooltipMonth": "Data available after 30 days of tracking",
            "tooltipNps": "Customer satisfaction based on reviews. Loaded automatically as soon as reviews are available",
            "tooltipQuarter": "Data available after 90 days of tracking",
            "tooltipRankMonth": "Average ranking over the last 30 days based on keywords",
            "tooltipRankQuarter": "Average ranking over the last 90 days based on keywords",
            "tooltipRankWeek": "Average ranking over the last 7 days based on keywords",
            "tooltipReview": "Review data is loaded automatically as soon as reviews are available",
            "week": "Week"
        },
        "controlBar": {
            "allStores": "All stores",
            "noStores": "Nothing selected",
            "avg": "Avg.",
            "best": "Best",
            "columns": "Columns",
            "columnsCount": "{{count}} columns",
            "comingSoon": "Coming soon",
            "country": "Country",
            "export": "Export",
            "import": "Import",
            "oneColumn": "1 column",
            "oneStore": "1 store",
            "period": "Period",
            "searchProducts": "Search products...",
            "stores": "Stores",
            "storesCount": "{{count}} stores"
        },
        "crumb": "Search Rankings",
        "dialog": {
            "addKeywordFailedMessage": "Adding the keyword failed.",
            "addKeywordFailedTitle": "Add failed"
        },
        "importKeywords": {
            "busy": "Busy...",
            "csvFile": "CSV file",
            "csvFormat": "CSV format (column EAN ; column keyword)",
            "dropZoneHint": "Format: EAN;keyword per line",
            "dropZoneText": "Click to select a file or drag it here",
            "howItWorks": "How does it work?",
            "import": "Import",
            "importLabel": "Import keywords:",
            "moreProducts": "...and {{count}} other product(s)",
            "paste": "Paste",
            "previewLabel": "{{keywordCount}} keyword(s) for {{eanCount}} product(s)",
            "progressText": "Importing...",
            "snackbarFailed": "{{total}} keywords failed",
            "snackbarFailedAll": "Import failed",
            "snackbarImported": "{{total}} keywords imported",
            "title": "Import keywords",
            "uploadCsvTxt": "Upload a CSV or TXT file with semicolon-separated columns:",
            "uploadFile": "Upload file",
            "useThisFormat": "Use the following format:",
            "withSemicolon": "With semicolon"
        },
        "kpi": {
            "avgRank": "Avg. search position",
            "bestRank": "Best search position",
            "keywordsTop10": "Keywords in Top 10",
            "keywordsTop3": "Keywords in Top 3",
            "totalCategories": "Total categories",
            "totalKeywords": "Total keywords",
            "totalSearchVolume": "Total search volume",
            "visibility": "Visibility",
            "visibilityTooltip": "Percentage of products visible in the top 10"
        },
        "positionFilter": {
            "all": "All",
            "bottom100": ">100",
            "label": "Position filters:",
            "top1": "Top 1",
            "top10": "Top 10",
            "top3": "Top 3",
            "top30": "Top 30",
            "top5": "Top 5"
        },
        "snackbar": {
            "exportDone": "Excel export complete.",
            "keywordAdded": "Keyword \"{{keyword}}\" added; first data is available tomorrow",
            "preferencesSaved": "Preferences saved"
        },
        "upgradeForHigherLimit": "Upgrade for higher limit",
        "upgradeLimit": {
            "confirm": "Go to subscription",
            "errorMessage": "Adding the module failed.",
            "errorTitle": "Add failed",
            "message": "Upgrade to be able to track additional keywords.\n\nAdd Bluemate Premium to your subscription to upgrade the keyword limit from 100 to 10.000.",
            "snackbarAdded": "The module has been added to your subscription",
            "title": "Bluemate Premium"
        },
        "table": {
            "eanCopied": "EAN copied",
            "emptyText": "Adjust your filters or add keywords.",
            "emptyTitle": "No products found",
            "firstPage": "First page",
            "lastPage": "Last page",
            "nextPage": "Next page",
            "noResults": "0 results",
            "paginationInfo": "{{first}}–{{last}} of {{total}}",
            "prevPage": "Previous page",
            "productPortfolio": "Product",
            "rankInclusiveSponsored": "Including sponsored",
            "rankSponsoredPosition": "Sponsored position",
            "rowsPerPage": "Rows per page",
            "viewOnBol": "View on bol.com",
            "noDataAddKeyword": "No data from bol. Add keywords."
        },
        "productDetails": {
            "monthlySearchVolume": "Search volume past month",
            "showKeyword": "Show Keyword",
            "hideKeyword": "Hide Keyword",
            "autoCreatedKeyword": "Via Bol API",
            "manualCreatedKeyword": "Manually added",
            "winningBid": "Winning offer for advertisements",
            "openSearchVolume": "Open keyword in Search Volume",
            "loadingSuggestions": "Loading suggestions...",
            "suggestion": "Suggestion",
            "addKeyword": "Add Keyword",
            "ignoreSuggestion": "Ignore suggestion",
            "showCategory": "Show Category",
            "hideCategory": "Hide Category",
            "errorLoadingKeywords": "Something went wrong whilst loading the keywords",
            "errorLoadingCategories": "Something went wrong whilst loading the categories.",
            "keywordRestored": "Keyword restored",
            "keywordArchived": "Keyword archived",
            "keywordArchiveError": "Something went wrong whilst archiving the keyword.",
            "categoryArchived": "Category archived",
            "categoryRestored": "Category restored",
            "categoryArchiveError": "Something went wrong whilst archiving the category.",
            "hideArchived": "Hide archived",
            "showArchived": "Archived ({archivedKeywordsCount})",
            "noKeywords": "No keywords found for this product. Add a keyword to track rankings.",
            "noCategories": "No categories found for this product.",
            "loadNewSuggestions": "Load new suggestions",
            "noDataFromBol": "No data received from bol"
        },
        "buyBox": "Buy box",
        "searchVol": "Search Vol.",
        "keywordsLimitReached": "Keywords limit reached",
        "addAKeyword": "Add a keyword...."
    },
    "searchVolume": {
        "aiAnalysis": "Market trend analysis with BluemateAI",
        "analyzeBtn": "Analyze with BluemateAI",
        "analyzeFailedMessage": "Analyzing the data failed.",
        "analyzeFailedTitle": "Analysis failed",
        "averageMonthly": "Average search volume per month",
        "banner": {
            "body": "View the search volumes on bol. Compare terms to find opportunities.",
            "title": "Search volume"
        },
        "chooseSearchTerm": "Choose a search term",
        "combineTerms": "Combine multiple keywords",
        "combinedSuffix": " - Combined",
        "country": {
            "be": "Belgium",
            "nl": "Netherlands"
        },
        "crumb": "Search volume",
        "keyword": "Keyword",
        "keywordPlaceholder": "Enter a keyword here",
        "loadFailedMessage": "Loading the search volume failed.",
        "loadFailedTitle": "Loading failed",
        "nlVsBePeriod": "Netherlands vs Belgium per period",
        "nlVsBeTotal": "Netherlands vs Belgium total",
        "period": {
            "label": "Period",
            "last14Days": "Last 14 days",
            "last2Years": "Last 2 years",
            "last3Months": "Last 3 months",
            "last6Months": "Last 6 months",
            "lastMonth": "Last month",
            "lastWeek": "Last week",
            "lastYear": "Last year"
        },
        "periodLabel": {
            "12months": "12 months",
            "14days": "14 days",
            "24months": "24 months",
            "31days": "31 days",
            "3months": "3 months",
            "6months": "6 months",
            "7days": "7 days"
        },
        "relatedTerms": "Related keywords",
        "removeAll": "Remove all",
        "search": "Search",
        "seasonal": "Seasonal (4 years of historical data)",
        "title": "Find search volume and related keywords",
        "totalVolume": "Total search volume",
        "totalVolumePrevious": "Total search volume (previous",
        "volume": "Search volume"
    },
    "sidebarMenu": {
        "comingSoon": "(coming soon)",
        "mobileFriendly": "This page works well on mobile"
    },
    "settings": {
        "accountUsers": {
            "accessRevoked": "Access to the account has been revoked",
            "addUserForPrice": "Add user for +€5/month",
            "addUserTitle": "Add user",
            "bannerBody": "Add new users to the Bluemate account here.",
            "bannerTitle": "Users",
            "chooseRole": "Choose role...",
            "colAccessSince": "ACCESS SINCE",
            "colEmail": "EMAIL",
            "colInvitedBy": "INVITED BY",
            "colInvitedOn": "INVITED ON",
            "colLastLogin": "LAST LOGIN",
            "colLastModified": "LAST MODIFIED",
            "colLastSent": "LAST SENT",
            "colName": "NAME",
            "colType": "TYPE",
            "crumbAccountUsers": "User management",
            "deleteFailedMsg": "Failed to delete the user.",
            "deleteFailedTitle": "Delete failed",
            "deleteInvitationConfirm": "Are you sure you want to revoke this invitation?",
            "deleteInvitationTitle": "Revoke invitation",
            "detailed": "Detailed",
            "editInvitationTitle": "Edit invitation",
            "email": "Email address",
            "invitationResent": "The invitation has been resent",
            "invitationRevoked": "The invitation has been revoked",
            "invitationSent": "The invitation has been sent",
            "invitationUpdated": "The invitation has been updated",
            "invitationsTitle": "Invitations",
            "inviteFailedMsg": "Failed to invite the user.",
            "inviteFailedTitle": "Invite failed",
            "inviteUser": "+ Invite user",
            "loadFailedTitle": "Loading failed",
            "loadInvitationsFailedMsg": "Failed to load invitations.",
            "loadUsersFailedMsg": "Failed to load users.",
            "no": "No",
            "noInvitations": "- No invitations found -",
            "noUsers": "- No users found -",
            "resend": "Resend",
            "revoke": "Revoke",
            "revokeConfirm": "Are you sure you want to remove this user's access to your account?",
            "revokeFailedTitle": "Revoke failed",
            "revokeInvitationFailedMsg": "Failed to revoke the invitation.",
            "revokeTitle": "Remove access",
            "rightsUpdated": "Permissions have been updated",
            "role": "Role",
            "roleAccountantInfo": "Has read-only permissions. Can view, download, and export, but cannot make changes.",
            "roleAdminInfo": "Has all permissions, including adding and removing users.",
            "roleCustomerServiceInfo": "Has no access to areas with financial figures (sales dashboard, VAT return tool, exports, etc.). Can only perform invoice actions.",
            "roleEmployeeInfo": "Can do everything except adding/removing users, canceling the subscription, or deleting the sales account",
            "save": "Save",
            "sendFailedMsg": "Failed to send the invitation",
            "sendFailedTitle": "Sending invitation failed",
            "setRightsTitle": "Set permissions",
            "updateFailedTitle": "Update failed",
            "updateInvitationFailedMsg": "Failed to update the invitation.",
            "updateRightsFailedMsg": "Failed to update permissions.",
            "userAlreadyHasAccess": "This user already has access to the account.",
            "usersTitle": "Users",
            "yes": "Yes"
        },
        "api": {
            "activate": "Activate",
            "activateFailedMsg": "Failed to activate the API key.",
            "activateFailedTitle": "Activation failed",
            "activated": "The API connection has been activated",
            "bannerBody": "Manage your connection between Bol and Bluemate.",
            "bannerTitle": "Connection with Bol",
            "colActiveUntil": "ACTIVE UNTIL",
            "colName": "NAME",
            "colSellerNumber": "BOL SELLER NUMBER",
            "colStatus": "STATUS",
            "crumbApi": "API",
            "crumbSettings": "Settings",
            "deactivateFailedMsg": "Failed to deactivate the API connection.",
            "deactivateFailedTitle": "Deactivation failed",
            "demoNotAllowedMsg": "This action is not allowed in the demo account.",
            "demoNotAllowedTitle": "Action not allowed",
            "disconnect": "Disconnect",
            "disconnectConfirm": "Are you sure you want to disconnect this API connection?",
            "disconnectTitle": "Disconnect API connection",
            "disconnected": "The API connection has been disconnected",
            "emptyLabel": "You have no API connection",
            "expiredMsg": "The API connection has expired and can no longer be used. You can create new API keys in your Bol account and set up the API connection with them via the Edit option of the API connection.",
            "expiredTitle": "Connection expired",
            "listTitle": "Connection with Bol (Retailer API)",
            "loadFailedMsg": "Failed to load your API keys.",
            "loadFailedTitle": "Loading failed",
            "modify": "Edit",
            "no": "No",
            "reconnect": "Reconnect",
            "setupApi": "Set up API connection",
            "yes": "Yes"
        },
        "common": {
            "accountDeleted": "Your account has been deleted",
            "accountUpdateFailed": "Failed to update your company information.",
            "additionalCompanyInfo": "Additional company information",
            "additionalCompanyInfoSub": "We use this information on the invoice for your customers",
            "address": "Address *",
            "bannerBody": "Manage your personal and company information here. We use this information for communication, invoicing, and payment. Make sure it is correct!",
            "bannerTitle": "Settings & company information",
            "changesSaved": "Changes have been saved",
            "city": "City *",
            "cocNumber": "KvK number",
            "companyEmail": "Email address * (for receiving customer emails)",
            "companyInfo": "Company information",
            "companyInfoSub": "We use this information when communicating with your customers",
            "companyName": "Company name *",
            "createAccount": "Create account",
            "crumbCommon": "General",
            "crumbSettings": "Settings",
            "deleteAccountConfirm": "Are you sure you want to delete your account? All data will be permanently lost.",
            "deleteAccountFailed": "Failed to delete your account.",
            "deleteAccountTitle": "Delete account",
            "deleteFailedTitle": "Delete failed",
            "deleteLogin": "Delete login",
            "deleteLoginFailed": "Failed to delete your login.",
            "deleteSalesAccount": "Delete this sales account ({{label}})",
            "deleteWholeAccount": "Delete entire Bluemate account",
            "deleteWholeAccountConfirm": "Are you sure you want to delete your entire account?",
            "deleteWholeAccountTitle": "Delete entire Bluemate account",
            "errAddress": "Enter the address",
            "errCity": "Enter the city",
            "errCompanyEmail": "Enter the email address",
            "errCompanyName": "Enter the company name",
            "errEmail": "Enter your email address",
            "errEmailInvalid": "Enter a valid email address",
            "errFirstname": "Enter your first name",
            "errLastname": "Enter your last name",
            "errPhone": "Enter the phone number",
            "errZipCode": "Enter the zip code",
            "firstname": "First name *",
            "here": "here",
            "iban": "IBAN",
            "lastAccountDeletedMsg": "You no longer have any accounts on the platform. Would you like to create a new account?",
            "lastAccountDeletedTitle": "Account deleted",
            "lastname": "Last name *",
            "leavePage": "No, leave page",
            "loginDeleted": "Your login has been deleted",
            "no": "No",
            "personalInfo": "Personal information",
            "personalInfoSub": "We use this to stay in touch with you",
            "save": "Save",
            "saveChanges": "Yes, save changes",
            "subscriptionInvoiceNotice": "Note: want to change your own Bluemate subscription invoice details? You can do that",
            "telNumber": "Phone number *",
            "unsavedChanges": "Your changes will be lost if you leave the page. Do you want to save the changes first?",
            "updateFailedTitle": "Update failed",
            "userEmail": "Account email * (for logging in)",
            "userEmailDisabled": "Want to change the main account email address you log in with? Please contact our support.",
            "userUpdateFailed": "Failed to update your personal information.",
            "vatNumberDefault": "Default VAT number",
            "vatNumberOptional": "VAT number (if applicable)",
            "vatNumberPerCountry": "Different VAT number per country",
            "yes": "Yes",
            "zipCode": "Zip code *"
        },
        "demoAccount": "Demo account",
        "email": {
            "attention": "Note:",
            "bannerBody": "Manage how emails are sent, tracked, and composed here. These settings affect statistics and the exact content of emails.",
            "bannerTitle": "Email settings",
            "close": "Close",
            "do": "YES",
            "dont": "NO",
            "example": "Example:",
            "leavePage": "No, leave page",
            "maxProductNameChars": "Maximum number of characters in product name",
            "maxProductNameInfo": "With this setting you can configure the maximum number of characters used for the product name in emails. Products with a longer name than this number of characters will be truncated with \"...\".",
            "moreInfo": "More information",
            "noReplyInfo1": "In April 2022, Bol made an update to its email system whereby external links (all links that do not lead directly to Bol) are added as text in the email. Bol indicates this was done for security reasons, so customers can see where they will be directed before clicking on a link / button.",
            "noReplyInfo2": "Due to this update, the layout of the emails sent through our platform may have been disrupted, which is why we temporarily disabled our email statistics.",
            "noReplyInfo3": "After discussions with Bol, we have found a solution that allows us to show email statistics again. With this solution, the emails are sent from a \"noreply\" address, so the Bol platform processes the email differently and does not place the links as text in the emails. The customer will receive the email from the address noreply@verkopen.Bol. As a result, the customer will no longer be able to reply to the email, since it comes from Bol's \"noreply\" address.",
            "noReplyKeywords": "onderweg, verstuurd, verzonden, shipped, is geleverd, factuur, bevestiging, track & trace, track and trace, nieuwsbrief, wil je ons helpen, bedankt, thank, dankjewel, dankuwel, pakbon, wat vindt u van, levering, ingepakt, bezorgd, ingepland, aangemeld, afgeleverd, verzending, ontvangen, nota, invoice, pending, planned, received",
            "noReplyKeywordsInfo": "when using certain keywords in the subject of the email, the email will be sent from Bol's \"noreply\" address regardless of your choice. Bol indicates the following keywords are involved:",
            "noReplyStatus": "\"noreply\" sender {{label}} be used, email statistics {{statsLabel}} be collected, customers {{replyLabel}} be able to reply directly to the emails",
            "none": "NONE",
            "productNameSub": "Limit the number of characters used for the product name in emails.",
            "productNameTitle": "Product name",
            "save": "Save",
            "saveChanges": "Yes, save changes",
            "saveFailedMsg": "Failed to save the settings.",
            "saveFailedTitle": "Save failed",
            "sendToCanceledStatus": "Emails for canceled orders {{label}} be sent",
            "sendToCanceledSub": "This setting determines whether emails should be sent for orders that have been canceled.",
            "sendToCanceledTitle": "Send emails for canceled orders",
            "settingsSaved": "Settings have been saved",
            "statsSub": "Use the \"noreply\" sender to be able to collect statistics about your emails.",
            "statsTitle": "Email statistics",
            "ublStatus": "UBL attachment {{label}} be added to emails",
            "ublSub": "In addition to the PDF invoice, also add a UBL file to the emails. UBL files are often used for automatic processing in accounting.",
            "ublTitle": "UBL attachment",
            "unlimited": "Unlimited",
            "unsavedChanges": "Your changes will be lost if you leave the page. Do you want to save the changes first?"
        },
        "export": {
            "apply": "Apply",
            "bannerBody": "Export your invoices and invoice data.",
            "bannerTitle": "Export invoices",
            "cancel": "Cancel",
            "chooseFields": "Choose fields",
            "colAction": "ACTION",
            "colFileType": "FILE TYPE",
            "colPeriod": "PERIOD",
            "colRequestDate": "REQUEST DATE",
            "combinedInfo": "All invoice and VAT totals are added together and placed on a single invoice.",
            "country": "Country",
            "create": "Create",
            "createFailedMsg": "Failed to create the export.",
            "createFailedTitle": "Create failed",
            "crumbExport": "Export",
            "crumbSettings": "Settings",
            "customerAll": "All customers",
            "customerBusiness": "Business customers",
            "customerPrivate": "Private customers",
            "customerType": "Customer type",
            "datePlaceholder": "dd/mm/yyyy",
            "disclaimer1": "Creating the file may take a moment. Once it is ready, the download will be available below. You can leave this page in the meantime.",
            "disclaimer2": "Use of data is at your own risk.",
            "download": "Download",
            "downloadFailedMsg": "Failed to download the file.",
            "downloadFailedTitle": "Download failed",
            "downloads": "Downloads",
            "downloadsSub": "Download the created export below.",
            "errFromDate": "Choose the date from which the invoices should be exported.",
            "errToBeforeFrom": "The Through date cannot be before the From date.",
            "errToDate": "Choose the date through which the invoices should be exported.",
            "error": "Error",
            "errorTitle": "Error",
            "exportCreating": "The export is being created",
            "exportSub": "Export invoices or data for a specific period.",
            "exportTitle": "Export",
            "exporting": "Exporting...",
            "field": "field",
            "fields": "fields",
            "fieldsSelected": "{{count}} {{label}} selected",
            "fileType": "File type",
            "filenameBase": "Base filename on",
            "filters": "Filters",
            "from": "From",
            "fulfilmentBoth": "Any fulfillment",
            "fulfilmentFbb": "FBB",
            "fulfilmentFbr": "Own fulfillment",
            "fulfilmentType": "Shipping type",
            "invoice": "invoice",
            "invoiceCount": "{{count}} {{label}} selected",
            "invoiceFields": "Invoice fields",
            "invoices": "invoices",
            "loadCountFailedMsg": "Failed to load the number of invoices.",
            "loadExportsFailedMsg": "Failed to load exports.",
            "loadFailedTitle": "Loading failed",
            "nameInvoiceNumber": "Invoice number",
            "nameOrderId": "Order number (Bol)",
            "noFiles": "- no files created yet -",
            "orderFields": "Invoice line fields",
            "period": "Period",
            "ready": "Ready",
            "reverseChargeOnly": "Reverse charged VAT only",
            "selectFieldsTitle": "Select export fields",
            "to": "Through",
            "typeCombinedPdf": "Combined PDF",
            "typeCsv": "CSV (Excel)",
            "typeCsvCustom": "CSV (custom)",
            "typePdf": "PDF",
            "typeUbl": "UBL (accounting standard)"
        },
        "invoice": {
            "autoCreateCredit": "Automatically create credit invoices",
            "autoCreditInfo1": "Bluemate periodically and automatically imports all your returns from the past 3 months. When a return has been processed by you as the retailer and Bol has refunded the return amount to your customer, we can automatically create a credit invoice based on the return. We can also send this credit invoice to your customer immediately or with a delay.",
            "autoCreditInfo2": "The credit invoice can only be created automatically when the return has been fully processed and Bol has refunded the amount to your customer.",
            "autoCreditTitle": "Automatic credit invoices",
            "autoSendCredit": "Automatically send credit invoices",
            "automate": "Automate",
            "bannerBody": "Manage the details of your invoices. Automate credit invoices.",
            "bannerTitle": "Invoice settings",
            "creditNumberInfo": "By default, credit invoices follow the same numbering sequence as regular invoices. With this option, credit invoices follow a separate numbering sequence. For example, {{year}}-credit-0001",
            "creditSettings": "Credit invoice settings",
            "crumbInvoices": "Invoices",
            "crumbSettings": "Settings",
            "day1": "1 day after processing",
            "day14": "14 days after processing",
            "day3": "3 days after processing",
            "day7": "7 days after processing",
            "dayCustom": "Custom",
            "dayCustomInput": "{{days}} days after processing",
            "dayReturnProcessed": "Return processed",
            "differNumbers": "Use a separate invoice numbering sequence for credit invoices",
            "emailForCredit": "Email for credit invoices",
            "emailForCreditSub": "This email is used for sending credit invoices (automatic & manual)",
            "errInvalid": "Not valid",
            "example": "Example",
            "filenameBase": "Base filename on",
            "invoiceNumber": "Invoice number",
            "leavePage": "No, leave page",
            "loadFailedMsg": "Failed to load the settings.",
            "loadFailedTitle": "Loading failed",
            "moreInfo": "More information",
            "numbering": "Invoice numbering",
            "ok": "OK",
            "orderNumber": "Order number",
            "prefix": "Prefix",
            "save": "Save",
            "saveChanges": "Yes, save changes",
            "saveFailedMsg": "Failed to save the invoice settings.",
            "saveFailedTitle": "Save failed",
            "settingsSaved": "Settings have been saved",
            "startWith": "Start with",
            "unsavedChanges": "Your changes will be lost if you leave the page. Do you want to save the changes first?",
            "updateFailedMsg": "Failed to update the settings.",
            "updateFailedTitle": "Update failed",
            "yearCodeInfo": "We automatically fill in the correct year using the text code {jaar}."
        },
        "language": {
            "en": "English",
            "label": "Language",
            "nl": "Dutch"
        },
        "password": {
            "bannerBody": "We recommend enabling two-factor authentication. You then no longer need to verify your email either.",
            "bannerTitle": "Security",
            "changeFailedMsg": "Failed to change your password.",
            "changeFailedTitle": "Change failed",
            "changeSub": "We strongly recommend changing your password every 60 days",
            "changeTitle": "Change password",
            "changed": "Your password has been changed",
            "confirmPassword": "Confirm password *",
            "confirmPasswordPlaceholder": "Confirm password",
            "crumbSecurity": "Security",
            "crumbSettings": "Settings",
            "currentPassword": "Current password *",
            "currentPasswordPlaceholder": "Current password",
            "dataUsageSub": "Here you can allow us to use your data to improve our Product Research estimates. Your exact sales will never be shown to others.",
            "dataUsageTitle": "Using data for improvements",
            "dataUsageToggleTitle": "Allow improvements",
            "disableFailedTitle": "Disable failed",
            "errConfirm": "Confirm the new password",
            "errCurrent": "Enter your current password",
            "errMismatch": "The passwords do not match",
            "errNew": "Enter a new password",
            "leavePage": "No, leave page",
            "newPassword": "New password *",
            "newPasswordPlaceholder": "New password",
            "off": "OFF",
            "on": "ON",
            "save": "Save",
            "saveChanges": "Yes, save changes",
            "twoFactorDisableExplanation": "Enter the two-factor authentication code to disable it.",
            "twoFactorDisableFailedMsg": "Failed to disable two-factor authentication.",
            "twoFactorDisabled": "Two-factor authentication has been disabled",
            "twoFactorSub": "With two-factor authentication, you add an extra layer of security to your account.",
            "twoFactorTitle": "Two-factor authentication",
            "unsavedChanges": "Your changes will be lost if you leave the page. Do you want to save the changes first?"
        },
        "subscription": {
            "accountNumberLabel": "Account number:",
            "activateFailedTitle": "Activation failed",
            "activeNotificationsHeader": "The following notifications are still on:",
            "activeNotificationsTitle": "Active notifications",
            "activeUsers": "active users",
            "addBtn": "+ Add",
            "addNewVat": "Add new VAT number",
            "addition": "Addition",
            "address": "Address",
            "allPrices": "All prices",
            "apply": "Apply",
            "applyCoupon": "Apply coupon",
            "applyCouponTitle": "Apply coupon",
            "applyDiscountBtn": "Apply 50% off for 6 months",
            "attention": "Note,",
            "bluemateSubscription": "Bluemate - Subscription",
            "cancel": "Cancel",
            "cancelFailedMsg": "Failed to cancel the subscription.",
            "cancelFailedTitle": "Cancellation failed",
            "cancelMessage1": "We are sorry to see you {{action}}.",
            "cancelMessage2": "If you click the button below, the subscription will stop immediately.",
            "cancelMessage3": "You only pay for the number of orders we have processed up to now.",
            "cancelMessage4Bold": "1 final direct debit",
            "cancelMessage4Post": "for the past month.",
            "cancelMessage4Pre": "So you can still expect",
            "cancelMessage5": "Please share below why you are leaving. It always helps us :)",
            "cancelSignature": "Best, Dave and Levi.",
            "cancelSubscriptionAction": "want to cancel your subscription",
            "cancelSubscriptionBtn": "I understand, cancel subscription",
            "cancelSubscriptionTitle": "Cancel subscription",
            "changePaymentMethod": "Change payment method",
            "choosePaymentMethod": "Which payment method would you like to link to your account?",
            "city": "City",
            "close": "Close",
            "companyName": "Company name",
            "continue": "Continue",
            "country": "Country",
            "coupon": "Coupon",
            "couponApplied": "The coupon has been applied to your subscription",
            "couponFailedMsg": "Failed to apply the coupon.",
            "couponFailedTitle": "Apply failed",
            "couponInfo": "Enter a coupon below to apply to your subscription.",
            "creditcard": "Credit card",
            "crumbSettings": "Settings",
            "crumbSubscription": "Subscription",
            "currentSubscription": "Current subscription",
            "currentSubscriptionSub": "current subscription",
            "customerDetailsDisclaimer": "Note: this information is only used for the invoices you receive from us. This information is not used on the invoices we send to your customers.",
            "deactivateFailedTitle": "Deactivation failed",
            "deleteAccountAction": "want to delete your account",
            "deleteAccountBtn": "I understand, delete account",
            "deleteAccountTitle": "Delete account",
            "detailsUpdateFailedMsg": "Failed to update the information.",
            "detailsUpdateFailedTitle": "Update failed",
            "detailsUpdated": "The information has been updated",
            "disclaimer1": "Never overpay.",
            "disclaimer2": "Price is determined monthly by the number of orders.",
            "disclaimer3": "Prices excl. 21% VAT.",
            "discountAmount": "€{{amount}} off",
            "discountApplied": "The discount has been applied to your subscription",
            "discountApplyFailedMsg": "Failed to apply the discount.",
            "discountApplyFailedTitle": "Apply discount failed",
            "discountOffer1": "Sorry to see you go.",
            "discountOffer2": "Bluemate proves itself over time.",
            "discountOffer3": "Try it a bit longer with 50% off for 6 months.",
            "discountOffer4": "After that, we can take another look together.",
            "discountOfferTitle": "50% off for 6 months",
            "discountPercent": "{{discount}}% off",
            "discountValidUntil": "Discount valid until {{date}}",
            "editDetails": "Edit details",
            "editSubscription": "Edit subscription",
            "email": "Email address",
            "errFeedbackRequired": "Please leave some feedback about why you are leaving.",
            "extraAccounts": "{{count}} extra sales{{suffix}}",
            "failedTitle": "Failed",
            "feedbackPlaceholder": "Feedback is always welcome here :)",
            "ideal": "iDeal",
            "invoiceDetailsTitle": "Invoice details",
            "invoiceEmail": "Email for invoicing",
            "last30Days": "last 30 days",
            "loadFailedMsg": "Failed to load your subscription.",
            "loadFailedTitle": "Loading failed",
            "millions": "Millions",
            "moduleInfo1": "With the Notifications module, you keep an eye on your products 24/7.",
            "moduleInfo2": "Due to server costs, there is a small additional contribution.",
            "modulePriceInfo": "Total price including all sales accounts.",
            "modulePro1": "Receive important notifications directly in your inbox.",
            "modulePro2": "For example, when you lose the buy box or have low stock.",
            "modulePro3": "This way you are always up to date so you can take action and avoid lost revenue.",
            "moreThan": "More than",
            "mostPicked": "Most picked",
            "noNewInvoiceMsg": "No new invoice has been created yet for the failed payment, contact us to resume the subscription.",
            "notificationsActivateFailedMsg": "Failed to activate the Notifications module.",
            "notificationsActivated": "The Notifications module has been activated",
            "notificationsDeactivateFailedMsg": "Failed to deactivate the Notifications module.",
            "notificationsDeactivated": "The Notifications module has been deactivated",
            "notificationsDescription": "Get notified 24/7 about buy box loss, new reviews, and more",
            "notificationsModule": "Notifications module",
            "numOrders": "Number of orders",
            "ok": "OK",
            "openInvoiceTitle": "Outstanding invoice",
            "payOpenInvoice": "Pay outstanding invoice",
            "paymentDisclaimer": "Payment is always processed via direct debit",
            "paymentMethodLabel": "Payment method:",
            "perMonth": "per month",
            "previousPeriods": "previous periods",
            "priceForOrders": "Price at {{count}} orders per month",
            "proMoreThan": "More than {{count}} active users",
            "proPartner": "Official partner of Bol",
            "proStars": "4.9 out of 5 stars on Google",
            "proceedCancel": "No, I still want to cancel",
            "removeNotificationsHint": "Remove these. Then the Notifications module can be deactivated.",
            "save": "Save",
            "sepa": "SEPA",
            "showLess": "Show less",
            "showMore": "Show more",
            "sinceUntilToday": "From {{date}} to today",
            "somethingWrong": "Something went wrong.",
            "starsReviews": "out of 5 stars on Google reviews",
            "start": "start",
            "startSubscription": "Start subscription",
            "startSubscriptionAction": "Start subscription",
            "statusActive": "Active",
            "statusInactive": "Inactive",
            "statusFailure": "Failure",
            "statusTrial": "Trial",
            "statusCanceled": "Canceled",
            "statusFree": "Free",
            "statusUnpaid": "Unpaid",
            "statusTitle": "Status",
            "stop": "cancel",
            "streetNumber": "Street + number",
            "subscriptionAction": "{{action}} subscription",
            "subscriptionCanceled": "The subscription has been canceled",
            "successInvoices": "successful invoices sent!",
            "thanksFeedback": "Thanks for your feedback!",
            "thanksTitle": "Thanks",
            "thisPeriod": "This period",
            "trialUntilThenPaid": "Trial until {{date}}, paid after that",
            "until": "until {{date}}",
            "usageThisPeriod": "Usage this period",
            "vatAdded": "The VAT number has been added",
            "vatDeleteFailedMsg": "Failed to delete the VAT number.",
            "vatDeleteFailedTitle": "Delete failed",
            "vatDeleted": "The VAT number has been deleted",
            "vatInvalid": "The VAT number is not valid",
            "vatNumber": "VAT number",
            "vatNumberFailed": "Failed to set the VAT number",
            "vatNumberInfo": "To start the subscription, we need your VAT number. Enter it below to continue.",
            "vatNumberRequired": "Enter the VAT number",
            "vatNumberSaved": "The VAT number has been saved",
            "vatNumberTitle": "Set VAT number",
            "vatNumbers": "VAT numbers",
            "vatPending": "VAT number is being validated",
            "vatUnavailable": "The VAT number cannot be validated",
            "vatVerified": "VAT number validated",
            "verifiedPartner": "VERIFIED PARTNER",
            "viewInvoices": "View invoices",
            "zipCode": "Zip code"
        },
        "productsMoved": {
            "body": "You will now find your product settings (name, VAT, costs, QR codes and visibility) on the Products page.",
            "button": "Go to Products",
            "title": "Product settings have moved"
        },
        "subscriptionDemoBlocked": "Subscription settings are not available in the demo account.",
        "tabs": {
            "accountUsers": "Users",
            "common": "General",
            "connection": "Bol connection",
            "email": "Emails",
            "export": "Export",
            "invoices": "Invoice settings",
            "password": "Security",
            "subscription": "Subscription",
            "vat": "Products & VAT"
        },
        "vat": {
            "addCustomFor": "Add different VAT rate for:",
            "addDefaultFor": "Add a default VAT rate for:",
            "applyChanges": "Apply changes",
            "cancel": "Cancel",
            "changesSaved": "Changes have been saved",
            "choose": "Choose...",
            "chooseCountry": "Choose a country",
            "crumbProducts": "Products & VAT",
            "crumbSettings": "Settings",
            "customRate": "Custom rate",
            "defaultsSaved": "The default VAT rates have been saved",
            "editDefaults": "Set default VAT rates",
            "errMaxPercent": "The percentage cannot be more than 100%",
            "errNegativeAmount": "The VAT amount cannot be negative",
            "errNegativePercent": "The percentage cannot be negative",
            "noCustomRate": "No different VAT rate set. Uses default rate.",
            "noNewInvoicesOnly": "No, only for new invoices",
            "productRetroactiveMsg": "Do you want to apply the changed VAT percentages retroactively? This will update all invoices with this product.",
            "retroactiveMsg": "Do you want to apply the changed VAT percentages retroactively? This will update all invoices that include the changed products.",
            "save": "Save",
            "saveDefaultsFailedMsg": "Failed to save the default VAT rates.",
            "saveDefaultsFailedTitle": "Save failed",
            "saveFailedMsg": "Failed to save the changes.",
            "saveFailedTitle": "Save failed",
            "setCustomRatesFor": "Set custom VAT rates for {{name}}",
            "useBolName": "Use Bol name",
            "vatAmountPerUnit": "VAT amount per unit",
            "vatPercent": "VAT percentage",
            "yesRetroactive": "Yes, retroactively"
        }
    },
    "subscription": {
        "existingUser": {
            "address": "Address",
            "addressPlaceholder": "Street name + house number",
            "cancel": "Cancel",
            "city": "City",
            "dataMessage": "To start the trial period, we need the following information:",
            "errors": {
                "address": "Enter the address",
                "city": "Enter the city",
                "okay": "OK",
                "startFailed": "Failed to start the trial period.",
                "startFailedTitle": "Failed to start trial period",
                "zipCode": "Enter the zip code"
            },
            "messageLine1": "To add a sales account, you need your own subscription.",
            "messageLine2": "By continuing, we'll start a free 30-day trial period that ends automatically.",
            "messageLine3": "A subscription will only start afterwards if you choose to.",
            "messageLine4": "You can cancel the trial period at any time.",
            "startTrial": "Start trial period",
            "title": "Subscription required",
            "zipCode": "Zip code"
        },
        "ideal": {
            "confirm": {
                "error": "Failed to confirm the payment.",
                "errorTitle": "Confirmation failed",
                "waitingText": "The payment is being confirmed, this may take a few minutes."
            },
            "errors": {
                "email": "Enter the email address",
                "emailInvalid": "Enter a valid email address",
                "name": "Enter the account holder's name"
            },
            "form": {
                "accept": "Accept",
                "accountHolder": "Account holder name *",
                "bank": "Bank *",
                "disclaimer": "By signing this form, you authorize Bluemate B.V. and Stripe to send standard European direct debit instructions to your bank to debit an amount from your account, and you authorize your bank to debit an amount from your account in accordance with these instructions. If you disagree with this debit, you can have it reversed. Such a request must be submitted within eight weeks of the debit date. Ask your bank about the conditions.",
                "email": "Email address *",
                "explanation": "A charge of €0.01 will be debited from your account for confirmation. As soon as your bank account is confirmed, this will be refunded immediately.",
                "title": "Pay automatically with iDeal"
            },
            "setup": {
                "error": "Failed to set up iDeal.",
                "errorTitle": "Setup failed"
            }
        },
        "stats": {
            "active": "Active",
            "canceled": "Canceled",
            "day": "Day",
            "display": "Display",
            "errors": {
                "load": "Failed to load the statistics.",
                "loadTitle": "Loading failed"
            },
            "expired": "Trial expired",
            "free": "Free",
            "inactive": "Inactive",
            "month": "Month",
            "page": "Page",
            "perDay": "Per day",
            "perMonth": "Per month",
            "perQuarter": "Per quarter",
            "perWeek": "Per week",
            "perYear": "Per year",
            "quarter": "Quarter",
            "title": "Subscription status",
            "trial": "Trial period",
            "week": "Week",
            "year": "Year"
        }
    },
    "survey": {
        "choices": {
            "majorityWins": "The most votes win.",
            "maxTwo": "Maximum two choices",
            "title": "Which feature(s) would you like to see in Bluemate?",
            "want": "Yes, I want this"
        },
        "close": "Close",
        "confirmation": {
            "line1": "We'll take a look.",
            "line3": "Development is a lot of work, and there are only two of us, so don't expect results too quickly :)",
            "line4": "Together to an even better product!",
            "signoff": "Cheers, Davey & Levi",
            "title": "Thanks for your response!"
        },
        "diffValue": {
            "label": "Other..."
        },
        "feature": "Feature",
        "header": {
            "choices": "Features",
            "intro": "Question",
            "thanks": "Thanks!",
            "values": "Value"
        },
        "intro": {
            "greeting": "Greetings from Dave and Levi, team Bluemate.",
            "subtitle": "Vote on which feature(s) we should build next!",
            "title": "Hey! - What should we build next? 🛠️",
            "vote": "Yes, I'll vote!"
        },
        "notNow": "Not right now",
        "questions": {
            "advertisingCosts": {
                "description": "The costs and results of your Bol sponsored products now also in the sales dashboard.",
                "title": "Bol Advertising costs in the Sales Dashboard"
            },
            "diff": {
                "title": "Other, namely..."
            },
            "hijack": {
                "description": "Get a notification as soon as the title, text or images of a product you offer have been changed by someone.",
                "title": "Product hijack notification"
            },
            "notifications": {
                "description": "Receive notifications by SMS or email for things like low stock, losing the buy box or a negative review.",
                "title": "Notifications"
            },
            "prodResearch": {
                "description": "View all products on Bol and see how much revenue (estimated) they generate.",
                "title": "Product Research Tool"
            },
            "productListGen": {
                "description": "Going to sell a new product? Provide a short description and get an SEO-optimized product title and description created with AI.",
                "title": "Product listing AI generator"
            },
            "profitCalc": {
                "description": "What do you actually have left at the bottom line? Calculate your profit and margin after entering all your costs for a new product.",
                "title": "Profit calculator"
            },
            "searchTermRanking": {
                "description": "See how high your products rank in Bol's search results for the most important keywords, including trends over time.",
                "title": "Search results ranking"
            },
            "stock": {
                "description": "Get a notification when new stock needs to be purchased per product based on your delivery times and planned sales forecast.",
                "title": "Stock purchase notification"
            }
        },
        "saveFailed": "Save failed",
        "saveFailedMessage": "Failed to save your choice.",
        "values": {
            "back": "Back",
            "comment": "Other feedback",
            "commentPlaceholder": "Any other suggestions to share? You can leave them here.",
            "submit": "Submit response",
            "title": "How happy are you with these features?"
        }
    },
    "systemMessage": {
        "apiExpiry": {
            "prefix": "The connection with your Bol account",
            "renew": "Renew now",
            "suffix": "To prevent orders from no longer being processed, we ask you to renew the connection."
        },
        "close": "Close",
        "dismissDialog": {
            "body1": "You can disable the warning about this connection expiring. We will then no longer show a notification for this connection. You will still receive automated emails about your connection expiring.",
            "body2": "Are you sure you no longer want to show this notification for this connection?"
        },
        "expired": "has expired",
        "expiresInDays": "expires in {{days}} days",
        "hideNotification": "Hide notification",
        "no": "No",
        "notificationHidden": "The notification will no longer be shown",
        "yes": "Yes"
    },
    "tracking": {
        "close": "Close",
        "decideLater": "Decide later",
        "detailedExplanation": "detailed explanation",
        "emailStats": "Email statistics",
        "info": {
            "keywords": "on the way, sent, shipped, delivered, invoice, confirmation, track & trace, track and trace, newsletter, will you help us, thanks, thank, thank you, packing slip, what do you think of, delivery, packed, delivered, scheduled, registered, dropped off, shipping, received, note, invoice, pending, planned, received",
            "noteLabel": "Note:",
            "noteText": "when using certain keywords in the email subject, the email will be sent through Bol's \"noreply\" address regardless of your choice. Bol indicates these are the relevant keywords:",
            "paragraph1": "In April 2022, Bol implemented an update to its email system that causes external links (any links that don't go directly to Bol) to be added as text in the email. Bol indicates this was done for security reasons, so customers can see where they're being sent before clicking on a link/button.",
            "paragraph2": "Due to this update, the layout of emails sent through our platform could be disrupted, so we temporarily disabled our email statistics.",
            "paragraph3": "We've now found a solution in discussion with Bol that lets us show email statistics again. With this solution, the emails are sent from a \"noreply\" address, so Bol's platform processes the email differently and doesn't place the links as text in the emails. The customer will receive the email from the address noreply@verkopen.bol.com. The result is that customers will no longer be able to reply to the email, because it comes from Bol's \"noreply\" address."
        },
        "mainBody": "The emails can be sent from a \"noreply\" address, so the emails are processed by a different mail system at Bol. Our links will then not be added as text in the email. The result is that customers will no longer be able to reply to the email.",
        "mainIntroPrefix": "Due to an update in Bol's mail systems (",
        "mainIntroSuffix": ") we had to temporarily disable our email statistics. We've now found a solution together with Bol that lets us collect statistics again:",
        "mainQuestion": "Do you want to use the \"noreply\" sender or do you want to use your own sender?",
        "saveFailed": "Save failed",
        "saveFailedMessage": "We couldn't save your choice.",
        "saved": "Your choice has been saved",
        "useNoreply": "Use no-reply sender",
        "useOwn": "Use my own sender"
    },
    "trialEnd": {
        "afterPayment": "After payment, reload the page and we'll pick it up automatically!",
        "checkPriceResume": "Check your price, connect a payment method, and resume your usage.",
        "continueWithBluemate": "Continue with Bluemate",
        "debitFailedFor": "The automatic debit for",
        "emailsPaused": "No emails are temporarily being sent to your customers and no invoices are being uploaded.",
        "failed": "has failed.",
        "featureUnavailable": "This feature is not available without a subscription.",
        "generateInvoiceFailed": "We couldn't generate a new invoice.",
        "generateNewInvoice": "You can generate a new invoice using the button below.",
        "goToSettings": "Go to settings",
        "goToSettingsToStart": "Go to the settings to start your subscription.",
        "invoiceFailed": "Invoice failed",
        "newInvoiceCreated": "We've created a new invoice,",
        "noProblem": "No problem, it happens :)",
        "paused": "Subscription is paused",
        "periodPrefix": "the period",
        "periodSeparator": "through",
        "periodSuffix": "of your subscription",
        "premiumFeature": "Premium Feature",
        "redirectedToPayment": "You'll be automatically redirected to the payment page.",
        "resumeSubscription": "Resume subscription",
        "subscriptionEnded": "Your subscription has ended.",
        "viewAndPay": "you can view and pay it using the button below.",
        "viewAndPayInvoice": "View and pay invoice",
        "yourSubscription": "your subscription"
    },
    "twoFactor": {
        "enable": {
            "enabledSnackbar": "Two-factor authentication is enabled",
            "generateFailedMessage": "We couldn't generate your personal code.",
            "generateFailedTitle": "Code generation failed",
            "okButton": "OK",
            "validateFailedMessage": "We couldn't validate the code.",
            "validateFailedTitle": "Validation failed"
        },
        "reset": {
            "failedMessage": "We couldn't disable two-factor authentication.",
            "failedTitle": "Disable failed",
            "okButton": "OK",
            "successMessage": "Two-factor authentication has been successfully disabled. You can now log in with your email address and password.",
            "successTitle": "Two-factor authentication disabled"
        }
    },
    "util": {
        "access": {
            "rights": {
                "accountUsers": "User management",
                "apiTab": "Bol connection tab",
                "archiveRequests": "Archive requests",
                "bolConnection": "Bol connection",
                "bulkDownload": "Bulk download",
                "bulkUploadPercentages": "Bulk upload percentages",
                "cancelEmails": "Cancel emails",
                "copyEmail": "Copy email from another account",
                "createCreditInvoice": "Create credit invoice",
                "createExport": "Create export",
                "credit": "Credit",
                "dashboardPage": "Home page",
                "deleteAccount": "Delete account",
                "deleteNotifications": "Delete notifications",
                "disconnectApi": "Disconnect",
                "downloadExport": "Download export",
                "downloadExports": "Download exports",
                "downloadInvoiceSpec": "Download invoice specifications",
                "downloadPreview": "Download/Preview",
                "editAutoEmail": "Edit automatic emailing",
                "editCompany": "Edit company details",
                "editCustomer": "Edit customer details",
                "editEmails": "Edit emails",
                "editItems": "Edit invoice line items",
                "editNotifications": "Edit notifications",
                "editProductTitle": "Edit product name",
                "editSettings": "Edit settings",
                "editUsers": "Edit users",
                "editVat": "Edit VAT %",
                "emails": "Emails",
                "emailsPage": "Emails page",
                "emailsTab": "Emails tab",
                "export": "Export",
                "exportCalculation": "Export calculation",
                "exportInvoices": "Export invoices",
                "exportTab": "Export tab",
                "feedTab": "Feed tab",
                "general": "General",
                "inviteUsers": "Add users",
                "invoiceRequests": "Requests",
                "invoiceRequestsPage": "Requests page",
                "invoiceSettings": "Invoice settings",
                "invoiceSettingsTab": "Invoice settings tab",
                "invoices": "Invoices",
                "layoutPage": "Layout page",
                "notificationsPage": "Notifications page",
                "ordersPage": "Orders page",
                "searchRankingsPage": "Search Rankings page",
                "productsPage": "Products page",
                "productsTab": "Products tab",
                "productsVat": "Products (VAT)",
                "productsVatTab": "Products (VAT) tab",
                "requestSettings": "Request settings",
                "returns": "Returns",
                "returnsPage": "Returns page",
                "reverseCharge": "Reverse charge VAT",
                "reviewAnalyticsPage": "Review Insights page",
                "salesDashboardPage": "Sales Dashboard page",
                "searchTermsPage": "Search Trends page",
                "send": "Send",
                "sendCreditInvoice": "Send credit invoice",
                "sendTestMail": "Send test email",
                "setInvoiceNumber": "Set invoice number",
                "setProductCosts": "Set product costs",
                "settingsPage": "Settings page",
                "settingsTab": "Settings tab",
                "setupApi": "Set up connection",
                "showInBol": "Show in Bol",
                "subscriptionTab": "Subscription tab",
                "syncBol": "Sync with Bol",
                "uploadInvoices": "Upload invoices",
                "users": "Users",
                "vatDeclarationPage": "VAT Return page",
                "viewDetails": "View details",
                "viewOrderStats": "View order statistics",
                "viewReviews": "View reviews",
                "viewStats": "View statistics"
            },
            "role": {
                "accountant": "Bookkeeper",
                "admin": "Administrator",
                "customerService": "Customer service",
                "employee": "Employee",
                "owner": "Owner"
            },
            "tab": {
                "emails": "Emails",
                "notifications": "Notifications",
                "orders": "Orders",
                "pageAccess": "Page access",
                "reviewAnalytics": "Review Insights",
                "salesDashboard": "Sales Dashboard",
                "settings": "Settings",
                "vatDeclaration": "VAT Return"
            }
        },
        "bolValidation": {
            "duplicateMail": "Another email is already being sent to these customers. Send a maximum of 1 email per order.",
            "duplicateMailGeneral": "Multiple emails are being sent to the same customers. According to Bol's policy, each customer may only receive one email. Bol may block these emails and you risk policy point deductions.",
            "invoiceAttachment": "This email does not contain the invoice as an attachment.",
            "invoiceAttachmentGeneral": "One or more emails do not contain the invoice as an attachment. According to Bol's policy, the invoice must be sent as an attachment. Bol may block these emails and you risk policy point deductions.",
            "overlap": "This email overlaps with email '{{step2}}'. Send a maximum of 1 email per order",
            "prefixedError": "{{step}}: {{error}}"
        },
        "component": {
            "validationErrors": "Validation errors"
        },
        "dashboard": {
            "cancelEmails": "Cancel emails",
            "connectedWithBol": "Connected to Bol",
            "copyId": "Copy ID",
            "credit": "Credit...",
            "creditInvoice": "Credit invoice",
            "creditInvoiceDetails": "Credit invoice details",
            "daysCount_one": "{{count}} day",
            "daysCount_other": "{{count}} days",
            "details": "Details",
            "download": "Download",
            "edit": "Edit...",
            "noBolConnection": "No connection to Bol",
            "preview": "Preview",
            "reverseCharge": "Reverse charge VAT...",
            "sendInvoice": "Send invoice...",
            "sendPeppol": "Send via Peppol",
            "setInvoiceNumber": "Set invoice number...",
            "statusCredited": "Credited",
            "statusDownloaded": "Downloaded",
            "statusEdited": "Edited",
            "statusInvoiceSent": "Invoice sent",
            "statusMailSendIn": "Email will be sent in {{days}}",
            "statusMailSendToday": "Email will be sent today",
            "statusNoInvoiceNumber": "Without invoice number",
            "statusOrderCanceled": "Order canceled",
            "statusOrderNotSent": "Order not yet shipped",
            "statusOrderSent": "Order shipped",
            "statusOpenReturn": "Open Return",
            "statusOpenReturnTooltip": "Return registered at bol. Changes like accepting will automatically be processed. In case of auto creating credit invoices (see Settings), a credit invoice will automatically be generated.",
            "statusReturned": "Returned",
            "statusReturnedTooltip": "This order has been accepted as return. In case of auto creating credit invoices (see Settings), the credit invoice can be found above in the list.",
            "statusReviewRequestSent": "Review request sent",
            "statusSent": "Sent",
            "statusVatReversed": "VAT reverse charged",
            "statusWillSend": "Sending",
            "uploadInvoice": "Upload invoice"
        },
        "emailStep": {
            "allCountries": "All countries",
            "allProducts": "All products",
            "attachmentCreditInvoice": "CreditInvoice.pdf",
            "attachmentInvoice": "Invoice.pdf",
            "attachmentsCount": "{{count}} attachments",
            "chooseProducts": "Choose product(s)",
            "chooseTemplate": "Choose template",
            "countriesCount": "{{count}} countries",
            "custom": "Custom",
            "customerAll": "All customers",
            "customerBusiness": "Business customers",
            "customerPrivate": "Private customers",
            "day": "day",
            "days": "days",
            "flow": {
                "invoice": {
                    "description": "An email with the VAT invoice as an attachment",
                    "title": "Invoice email"
                },
                "other": {
                    "description": "Compose a different type of email yourself.",
                    "title": "Other email"
                },
                "product": {
                    "description": "Send an email only when certain products are ordered. For example, a product manual email with attachment.",
                    "title": "Product-level email"
                },
                "review": {
                    "description": "Ask for a product review on Bol.",
                    "title": "Review email"
                },
                "reviewInvoice": {
                    "description": "Ask for a product review including link and add the invoice as an attachment.",
                    "title": "Review + Invoice email (recommended)"
                }
            },
            "logisticsAll": "All fulfillment",
            "logisticsLvb": "FBB",
            "logisticsOwn": "Own fulfillment",
            "nDaysAfterShipment": "{{amount}} {{days}} after shipment",
            "none": "None",
            "orderReceived": "Order received",
            "orderSent": "Order shipped",
            "productsCount_one": "{{count}} product",
            "productsCount_other": "{{count}} products",
            "remainingProducts": "Remaining products",
            "remainingProductsCount_one": "Remaining {{count}} product",
            "remainingProductsCount_other": "Remaining {{count}} products",
            "reviewInvoiceTooltip": "For best conversion, send your Review + Invoice email at least 7 days after shipment. By then, your customer has likely received the order and had a chance to try it.",
            "selectedProducts": "Selected products",
            "title": {
                "creditInvoice": "EMAIL WITH CREDIT INVOICE",
                "invoice": "INVOICE EMAIL",
                "other": "OTHER EMAIL",
                "product": "PRODUCT EMAIL",
                "review": "REVIEW EMAIL",
                "reviewInvoice": "REVIEW + INVOICE EMAIL"
            },
            "workDay": "business day",
            "workDays": "business days"
        },
        "pdf": {
            "noBolConnection": "no Bol connection",
            "notSet": "not set",
            "var": {
                "amountsExclVat": "Amounts excl. VAT",
                "deliveryAddress": "Delivery address",
                "deliveryCity": "Delivery city",
                "deliveryCountry": "Delivery country",
                "deliveryExtra": "Delivery address addition",
                "deliveryZip": "Delivery zip code",
                "firstName": "First name",
                "lastName": "Last name",
                "orderDate": "Order date",
                "orderId": "Order number"
            }
        },
        "return": {
            "credit": "Credit",
            "creditInvoice": "Credit invoice",
            "details": "Details",
            "originalInvoice": "Original invoice",
            "sendCreditInvoice": "Send credit invoice",
            "showInBol": "Show in Bol"
        },
        "salesDashboard": {
            "allCountries": "All countries",
            "col": {
                "avgCommission": "Average commission",
                "avgPrice": "Sale price bol",
                "avgPriceIncl": "Sale price bol incl. VAT",
                "commission": "Total commission",
                "commissionPercentage": "Commission %",
                "costs": "Product costs",
                "margin": "Margin %",
                "name": "Name",
                "numOrders": "Number of orders",
                "profit": "Profit",
                "profitPerProduct": "Profit per product",
                "quantity": "Units sold",
                "returnedQuantity": "Units returned",
                "revenue": "Revenue",
                "revenueIncl": "Revenue incl. VAT",
                "vatPercentage": "VAT percentage"
            },
            "group": {
                "costs": "Costs",
                "profit": "Profit",
                "returns": "Returns",
                "revenue": "Revenue"
            },
            "info": {
                "avgPrice": "Average price across all orders for this product",
                "avgPriceIncl": "Average price across all orders for this product, including VAT",
                "marginNeedsCost": "The profit margin can only be calculated once the cost price has been entered.",
                "profitNeedsCost": "Profit can only be calculated once the cost price has been entered."
            },
            "setVat": "Set VAT"
        },
        "subscription": {
            "somethingWentWrong": "Something went wrong",
            "status": {
                "active": "Active",
                "canceled": "Canceled",
                "free": "Free",
                "inactive": "Inactive",
                "trial": "Trial period",
                "unknown": "Unknown"
            }
        },
        "update": {
            "addUsersTitle": "Add users",
            "autoReturnsCreditsTitle": "Automatic returns and credit invoices",
            "bolApiUpgradeTitle": "Bol API upgrade",
            "bolPolicyPointsTitle": "Bol policy points",
            "bolSearchTrendsTitle": "Bol search trends",
            "buyBoxLossTitle": "Want an alert when you lose the buy box?",
            "combineSalesTitle": "Combine sales",
            "deleteSalesAccountTitle": "Delete sales account",
            "emailCountrySelectionTitle": "Email country selection",
            "emailProductSelectionTitle": "Email product selection",
            "emailStatsTitle": "Email statistics",
            "emailsRemainingProductsTitle": "Emails for remaining products",
            "financialDashboardTitle": "Financial Dashboard",
            "globalSearchVatImportTitle": "Global search & VAT import",
            "improvedEmailEditorTitle": "Improved email template editor",
            "lowStockTitle": "Want an alert when stock is low?",
            "multipleAccountsTitle": "Connect multiple accounts",
            "newOrdersLine1": "New: now receive an email when you have new orders.",
            "newOrdersLine2": "Our robots can now monitor your orders 24/7.",
            "newOrdersTitle": "Want an alert for new orders?",
            "oldOrderRequestsTitle": "Invoice requests for old orders",
            "optimizationsExpansionTitle": "Optimizations & feature expansion",
            "reviewAnalyticsRenewedTitle": "Review Insights - revamped!",
            "reviewNotificationsTitle": "Review Notifications!",
            "salesDashboardImprovementsTitle": "Sales Dashboard improvements",
            "searchVolumesRenewedTitle": "Search volumes revamped",
            "uploadRulesTitle": "Upload rules",
            "vatOptionsGeneralTitle": "VAT options & General improvements",
            "wantThis": "Want this too?",
            "yesAddNotification": "Yes, add notification"
        },
        "utils": {
            "subscriptionInactive": "Your subscription is not active. Activate your subscription to use this feature.",
            "tryAgainLater": "Please try again later, or contact us."
        }
    },
    "vat": {
        "custom": {
            "invalidPercentage": "Enter a valid percentage",
            "label": "Custom rate",
            "ok": "OK"
        },
        "split": {
            "addRate": "add rate",
            "amountPerUnitLabel": "VAT amount per unit",
            "apply": "Apply",
            "cancel": "Cancel",
            "choose": "Choose...",
            "disclaimer": "Use of split VAT is at your own risk.",
            "disclaimerInfo": "We do not receive information about VAT rates from Bol, so we cannot apply automatic calculations and changes to split VAT amounts. When prices change, the split VAT amounts must be updated manually.",
            "explanationPart1": "Split VAT is applied when 1 product consists of multiple items, where each item has a different VAT rate. There are of course rules for this; more information can be found at",
            "explanationPart2": "Because we do not receive information from Bol about the composition of products and VAT rates, we cannot automatically apply split VAT rates. It is therefore possible to manually set the VAT amounts (per unit), which are then used to determine the total VAT.",
            "explanationPart3": "Because this is not an automatic process, the VAT amounts must be updated manually when the price at Bol changes. The use of split VAT is therefore at your own risk.",
            "percentageLabel": "VAT percentage",
            "taxAuthority": "the Tax Authorities",
            "title": "Split VAT",
            "validateMinimum": "Choose at least 2 VAT rates to set up split VAT.",
            "whatIs": "What is split VAT?"
        },
        "type": {
            "margin": "Margin",
            "split": "Composite",
            "splitFull": "Composite",
            "reversed": "Reverse charged",
            "kor": "KOR",
            "default": "Default",
            "custom": "Custom..."
        }
    },
    "vatDeclaration": {
        "banner": {
            "body": "Calculate your VAT amounts on your bol sales in one click. Note: have it checked by your accountant.",
            "title": "VAT Return"
        },
        "bolInvoicesTitle": "Used invoices & specifications from Bol",
        "box": {
            "calculating": "Calculating...",
            "costsExcl": "Costs excl. VAT",
            "costsIncl": "Costs incl. VAT",
            "noData": "No available data found",
            "preTax": "Input VAT",
            "revenueExcl": "Revenue excl. VAT",
            "revenueIncl": "Revenue incl. VAT",
            "reversedIncl": "Revenue with reverse-charged VAT",
            "tax": "VAT payable"
        },
        "canLeaveWindow": "You can leave this window and come back later.",
        "choosePeriod": "Choose a period",
        "continueDefaultVat": "Continue with standard VAT rate",
        "crumb": "VAT return help",
        "downloadExcelTitle": "Download Excel specification",
        "downloadPdfTitle": "Download PDF invoice",
        "downloads": "Downloads",
        "error": {
            "calculateFailed": "Calculating the VAT return failed.",
            "calculateFailedTitle": "Calculation failed",
            "downloadFailedTitle": "Download failed",
            "downloadFileFailed": "Downloading the file failed.",
            "downloadInvoiceFailed": "Downloading the invoice failed.",
            "exportFailed": "Something went wrong while exporting the calculation.",
            "exportFailedTitle": "Export failed",
            "notificationFailed": "Setting up the notification failed.",
            "notificationFailedTitle": "Setup failed",
            "somethingWrong": "Something went wrong",
            "systemError": "Something went wrong in our system."
        },
        "export": {
            "action": "ACTION",
            "button": "Export calculation",
            "csv": "CSV file",
            "dialogMessage": "You can export the calculation to a csv file or an Excel file. Which file type would you like to use?",
            "dialogTitle": "Export calculation",
            "download": "Download",
            "error": "Error",
            "excel": "Excel file",
            "exporting": "Exporting...",
            "fileType": "FILE TYPE",
            "noneExported": "- no calculations exported yet -",
            "title": "Export VAT calculation"
        },
        "firstUse": {
            "attention": "Please note the following:",
            "bullet1": "- This tool is only intended as an aid.",
            "bullet2": "- We cannot provide any guarantees regarding completeness and correctness.",
            "bullet3": "- This tool is not a substitute for an accountant.",
            "bullet4": "- We are also unable to provide support with preparing tax returns.",
            "calc1": "We make this calculation by downloading and processing the Excel specifications of the sales invoices from your Bol account.",
            "calc2": "These specifications do not include the VAT percentage of your products, so we use the VAT percentages of your products as set in Bluemate.",
            "calc3": "So make sure the VAT percentages of products are set correctly in Bluemate.",
            "calc4": "If present, we also include any VAT manually reverse-charged on invoices via Bluemate.",
            "calc5": "We then add the amounts together into totals and display them per category.",
            "confirm": "Yes, I understand",
            "intro1": "The VAT return tool helps you calculate the VAT amounts on your Bol sales.",
            "intro2": "You can view these figures over a specific period (for example a quarter or a year), per country and per revenue group.",
            "intro3": "Useful as a help for your VAT returns!",
            "title": "Welcome to the VAT return help!"
        },
        "generalInfo": "We calculate these figures based on your monthly invoice specifications from Bol. We supplement these with the VAT percentages of your products as set in Bluemate and with any VAT reverse-charged via Bluemate. So make sure the VAT percentages of your products in Bluemate are set correctly.",
        "invalidatedWarning": "Since the last calculation of the VAT return, the {{type}} settings have changed. As a result, the calculation may need to be redone.",
        "invoiceHeader": {
            "info": "Download the original Bol invoices (PDF) or invoice specifications (Excel) here.",
            "invoiceNumber": "INVOICE NUMBER",
            "period": "PERIOD"
        },
        "lastOrderInfo": "For this calculation we use the same bol invoice specifications in Excel that you also receive. We supplement these with VAT data from Bluemate. The data we retrieved contains orders up to and including {{lastOrderString}}. This can mean two things:",
        "lastOrderOption1": "if this was the last order of the month.",
        "lastOrderOption1Bold": "Your calculation is now complete",
        "lastOrderOption2": "if there were more orders after {{lastOrderString}}. In that case a new Excel sheet will become available at bol around {{availableFromString}}. Run this calculation again from {{availableFromString}}.",
        "lastOrderOption2Bold": "Your calculation is not yet complete",
        "lastOrderTitle": "Data received from bol up to {{lastOrderString}} – Complete data likely available from {{availableFromString}}",
        "list": {
            "amountExcl": "Amount excl. VAT",
            "category": "Category",
            "costsAtBol": "Costs incurred at Bol",
            "revenueAtBol": "Revenue at Bol",
            "total": "Total",
            "vatAmount": "VAT amount"
        },
        "mailDisabled": "You will no longer receive an email when the calculation is complete",
        "mailEnabled": "You will receive an email when the calculation is complete",
        "mailNotify": "Send me an email when the calculation is complete",
        "newProductsBody": "During the calculation of the VAT return, our system found {{missingProducts}} new products that we have not seen before. These are likely products from that period that you no longer actively sell. We have added these products in Settings > Products (VAT).",
        "newProductsDefault": "For these products the standard VAT rate per country is currently used (Netherlands {{dutchVat}}%, Belgium {{beVat}}%).",
        "newProductsQuestion": "Would you like to set different VAT rates or continue with the standard VAT rate?",
        "newProductsRateUnknown": "We do not yet know the VAT rate for these products.",
        "newProductsTitle": "New products found!",
        "period": {
            "custom": "Custom...",
            "months": "Months",
            "quarters": "Quarters",
            "years": "Years"
        },
        "preTaxInfo": "Input VAT is the VAT you have paid yourself on the costs incurred at Bol. You receive this VAT back from the Tax Authorities via the VAT return.",
        "processingPeriod": "Processing period {{periodLabel}}",
        "recalculate": "Recalculate",
        "recalculateNow": "Recalculate now",
        "reverseDisclaimer": "For sales partners outside the Netherlands, the VAT on costs is reverse-charged by Bol. This is not clearly indicated in the Bol invoice specification, so we cannot accurately calculate the VAT amounts on costs (input VAT). We recommend consulting an accountant for filing your VAT return.",
        "reversedInfo": "If you receive orders from foreign business customers, you may have reverse-charged the VAT to the customer. During the VAT return you must report the revenue for which the VAT has been reverse-charged.",
        "setOtherVat": "Set a different VAT rate",
        "statusLabel": "Status:",
        "taxInfo": "VAT payable is the VAT you have received from your customers. You pay this VAT to the Tax Authorities via the VAT return.",
        "totals": "Totals",
        "until": "through",
        "vatLabel": "VAT",
        "vatReversed": "VAT reverse-charged"
    },
    "apiConnectionBanner": {
        "button": "Renew Bol connection now",
        "explanation": "After logging in to bol, connect us with both \"retailer\" and \"advertiser\" so we have all the data.",
        "title": "New API connection required"
    },
    "noData": "No data",
    "week": "Week",
    "month": "Month",
    "category": "Category",
    "categories": "Categories",
    "close": "Close",
    "graph": "Graph",
    "all": "All",
    "mobileApp": {
        "crumb": "Mobile app",
        "eyebrow": "Mobile app",
        "safariChip": "Safari only on iPhone or iPad",
        "stepWord": "Step",
        "title": "Bluemate as an app on your phone",
        "intro": "Install Bluemate as an app on your phone. As an installed app Bluemate launches faster and you receive push notifications about buy-box changes, low stock and new reviews. Pick your device below for the steps.",
        "alreadyInstalled": "You are using Bluemate as an installed app. The steps below are for reference only — for example to install Bluemate on another device.",
        "ios": {
            "title": "Install on iPhone or iPad",
            "step1": "In Safari, tap the share icon at the bottom of the screen (a square with an up arrow).",
            "step2": "Scroll down and choose 'Add to Home Screen'.",
            "step3": "Confirm with 'Add'. Bluemate will then appear as an app icon on your home screen.",
            "shotAlt": "Bluemate install step"
        },
        "platformApple": "iPhone / iPad",
        "platformAndroid": "Android",
        "android": {
            "title": "Install on Android",
            "browsersNote": "Chrome, Brave, Edge and other Chromium browsers",
            "step1": "Open Bluemate in a Chromium-based browser such as Chrome, Brave or Edge.",
            "step2": "In the 'Install Bluemate as an app' banner at the top, tap 'Install'. Bluemate then appears as an app on your home screen.",
            "step3": "Follow the banner below to install Bluemate:",
            "shotAlt": "Bluemate install step on Android",
            "shortcutWarningTitle": "Choose \"Install\", not \"Create shortcut\"",
            "shortcutWarning": "Does your browser offer a choice between installing and creating a shortcut? Always pick 'Install' (or 'Install app'). A shortcut is only a bookmark to the website: it gets the browser icon instead of the Bluemate icon, opens in a browser tab and cannot receive push notifications. The safest route is the 'Install' button in the banner above — that always installs the real app.",
            "shortcutFix": "Already created a shortcut by mistake? Remove it from your home screen and install again with the button above.",
            "optionWord": "Option",
            "bannerOptionTitle": "One tap, from the banner",
            "bannerOptionIntro": "The quickest route: your browser opens the install dialog straight away.",
            "bannerOptionFallback": "No banner in sight? Your browser does not always offer the button. Use option 2 below — that one always works.",
            "menuOptionTitle": "From your browser's menu",
            "menuOptionIntro": "Always available, even when the banner is missing. Do read the last step carefully.",
            "menuStep1": "Tap the three-dot menu (⋮) at the top right of Chrome.",
            "menuStep2": "Choose 'Install app'. Does yours say 'Install and create shortcut' or 'Add to Home screen'? Same entry point.",
            "menuStep3": "If you are offered a choice, pick 'Install' and confirm — not 'Create shortcut'. Bluemate appears on your home screen with its own icon."
        }
    },
    "pwa": {
        "install": "Install",
        "installBluemateTitle": "Install Bluemate as an app",
        "installBluemate": "Add Bluemate to your desktop or home screen. As an installed app Bluemate launches faster and can receive push notifications about buy-box changes, low stock and new reviews. Tap or click 'Install' to open your browser's installation dialog.",
        "openInSafari": "Open in Safari",
        "openInChrome": "Open in Chrome",
        "iosInstallTitle": "Install Bluemate on your iPhone or iPad",
        "iosInstallHint": "As an installed app Bluemate launches faster and can receive push notifications about buy-box changes, low stock and new reviews. See the installation guide for the steps.",
        "iosInstallGuide": "Installation guide",
        "iosNonSafariInstallHint": "On iOS, Bluemate can only be installed to your home screen from Safari. Tap the button below to open this page in Safari and start the installation.",
        "androidIncompatibleInstallTitle": "Install Bluemate on your Android device",
        "androidIncompatibleInstallHint": "Your current browser doesn't support one-click install of Bluemate as an app. Tap the button below to open Bluemate in Google Chrome — there you can install the app with one tap. Don't have Chrome yet? The Play Store will open so you can install it.",
        "macSafariInstallTitle": "Install Bluemate on your Mac",
        "macSafariInstallHint": "As an installed app Bluemate opens in its own window without an address bar. To install in Safari:\n1. Click the share icon in the address bar (square with an up arrow).\n2. Choose 'Add to Dock'.\n3. Bluemate will appear in your Dock — launch it from there like any other Mac app. Requires macOS Sonoma (14) or later.",
        "firefoxDesktopInstallTitle": "Install Bluemate in Firefox for desktop",
        "firefoxDesktopInstallHint": "Bluemate can be installed as an app — it launches faster and receives push notifications. However, desktop Firefox has no built-in install button for web apps. You have two options:\n1. Open this page in Chrome, Edge or Safari to install Bluemate with one click (recommended).\n2. Or create a manual shortcut to this page on your desktop via your operating system.",
        "unsupportedBrowserTitle": "Browser not fully supported",
        "unsupportedBrowserHint": "Your current browser does not support modern web-app features. As a result push notifications and installation as an app will not work. Open Bluemate in a recent version of Chrome, Edge, Safari or Firefox for the full experience — all of these browsers are free to use.",
        "offlineDismiss": "Continue anyway",
        "offlineMessage": "Please check your internet connection and try again.",
        "offlineReconnected": "Connection restored",
        "offlineRetry": "Try again",
        "offlineStillNoConnection": "Still no connection",
        "offlineTitle": "No connection",
        "updatedToast": "Bluemate has been updated to the latest version.",
        "connectionBlocked": "Connection blocked after a network change. Fully close the app and reopen it.",
        "actionError": "Something went wrong. Please try again.",
        "androidManualInstallTitle": "Install Bluemate on your Android device",
        "androidManualInstallHint": "As an installed app Bluemate starts faster and can send you push notifications about buy box changes, low stock and new reviews. Tap 'Install guide' below for the steps.",
        "androidInstallGuide": "Install guide"
    },
    "push": {
        "adminOnlyBadge": "Visible for admin only!",
        "cancel": "Cancel",
        "deniedHelp": {
            "gotIt": "Got it",
            "intro": "Notifications are blocked in your browser or system settings. Here's how to turn them back on:",
            "ios1": "Open the Settings app on your iPhone or iPad.",
            "ios2": "Go to 'Notifications' and find 'Bluemate' in the list.",
            "ios3": "Turn on 'Allow Notifications', come back and check this device again on a notification.",
            "android1": "Tap the lock icon (or ⋮ → Site information) next to the address bar at the top.",
            "android2": "Open 'Permissions' → 'Notifications'.",
            "android3": "Set it to 'Allow' (or 'Reset permissions'), come back and check this device again on a notification.",
            "androidPwa1": "Press and hold the Bluemate icon on your home screen → 'App info' (or open Android Settings → 'Apps' → 'Bluemate').",
            "androidPwa2": "Tap 'Notifications'.",
            "androidPwa3": "Turn notifications on, come back to the app and check this device again on a notification.",
            "desktop1": "Click the lock icon on the left of the address bar.",
            "desktop2": "Set 'Notifications' to 'Allow', refresh the page and check this device again on a notification.",
            "alreadyOnMobile": "Already switched on there? Turn notifications OFF and back ON once in your system settings, reopen the app and check this device again.",
            "alreadyOnDesktop": "Already set to 'Allow'? Turn notifications OFF and back ON once — in your browser settings and in your computer's system settings — then refresh the page."
        },
        "deviceAdded": "Added:",
        "deviceComputer": "Computer",
        "deviceLastSeen": "Last seen:",
        "devicePhone": "Mobile device",
        "deviceTablet": "Tablet",
        "devices": "Devices",
        "devicesNone": "No devices registered",
        "editName": "Rename device",
        "editNameHint": "Give this device a recognizable name",
        "emailReceivesCount_one": "Receives {{count}} notification",
        "emailReceivesCount_other": "Receives {{count}} notifications",
        "emailRecipients": "E-mail addresses",
        "emailRecipientsNone": "No e-mail addresses configured",
        "emailRedirected": "(Redirected)",
        "error": "Something went wrong, please try again",
        "errors": {
            "unsupported": "Your browser does not support push notifications.",
            "missing-vapid": "Push notifications are not configured on this environment. Please contact support.",
            "missing-keys": "Encryption keys are missing. Please try again or restart your browser.",
            "empty-subscription": "The browser returned an empty push subscription. Please try again or restart your browser.",
            "install-required": "Install the Bluemate app first to receive notifications.",
            "sw-not-ready": "The service worker is not ready yet. Please reload the page and try again.",
            "enable-failed": "Enabling notifications failed. Please try again.",
            "disable-failed": "Disabling notifications failed. Please try again.",
            "register-failed": "Registering this device with the server failed. Please try again.",
            "no-user": "You are not logged in or no sales account is selected.",
            "deviceLimit": "Device limit reached. Remove one first.",
            "unexpected": "Something went wrong with push notifications. Please try again later."
        },
        "firstRun": {
            "title": "Notifications on this phone",
            "body": "Do you want to receive push notifications on this phone?",
            "yes": "Yes",
            "settingsHint": "You can always enable push notifications later in your notification settings.",
            "later": "Maybe later"
        },
        "formFactorComputer": "Computer",
        "formFactorPhone": "Phone",
        "formFactorTablet": "Tablet",
        "healthWarn": "Notifications enabled, but a check failed — they may not arrive.",
        "insecureContext": "Push notifications only work over a secure (encrypted) https connection. Over a plain http connection Bluemate can't enable notifications correctly.",
        "installFirst": "Notifications are only available in the Bluemate app",
        "installedApp": "installed app",
        "loading": "Loading...",
        "logoutDevice": "Log out device",
        "logoutDeviceConfirm": "Are you sure you want to log out this device?",
        "logoutDeviceDone": "Device has been logged out",
        "mismatch": {
            "title": "Different user",
            "adminBody": "This push notification is intended for a different user. Switch?",
            "adminSwitchBtn": "Switch",
            "userBody": "This push notification is intended for a different account. Do you want to log out and sign in to the correct account?",
            "userLogoutBtn": "Log out",
            "switchFailed": "Switching to the other user failed."
        },
        "namePlaceholder": "E.g. MacBook work",
        "notGranted": "Notifications not enabled: permission was not granted.",
        "openSecure": "Open Bluemate over https in a new window",
        "refresh": "Refresh status and devices",
        "save": "Save",
        "suppressedHelp": {
            "title": "Enable notifications",
            "androidIntro": "Your browser won't show the notification prompt again after it was dismissed. Here's how to turn notifications on anyway:",
            "iosIntro": "The notification prompt won't be shown again after it was dismissed. Here's how to turn notifications on anyway:",
            "desktopIntro": "Your browser won't show the notification prompt again after it was dismissed. Here's how to turn notifications on anyway:"
        },
        "suppressedHint": "We won't show the notification prompt again. Tap here to see how to enable notifications.",
        "testErrors": {
            "rate_limit": "Too many requests. Try again later.",
            "no_devices": "No active web push devices registered for this user.",
            "all_failed": "All active devices failed. Re-enable push on this device.",
            "not_found": "This device is no longer registered.",
            "not_configured": "This address is not used by any notification.",
            "mail_failed": "Sending the test e-mail failed. Try again."
        },
        "testMailSent": "Test e-mail sent to this address",
        "testSendDevice": "Send a test notification to this device",
        "testSendMail": "Send a test e-mail to this address",
        "testSent": "Test notification has been sent",
        "testSentDevice": "Test notification sent to this device",
        "thisComputer": "This computer",
        "thisDevice": "(this device)",
        "thisPhone": "This phone",
        "thisTablet": "This tablet",
        "title": "Push notification subscriptions overview",
        "unknownDevice": "Unknown device",
        "unsupported": "Your browser does not support push notifications."
    },
    "overview": {
        "accounts": {
            "all": "All stores together",
            "count_one": "{{count}} store",
            "count_other": "{{count}} stores",
            "emptyBody": "Pick at least one store above to see your figures.",
            "emptyTitle": "No store selected",
            "none": "No store selected"
        },
        "adRevenue": {
            "badgeTooltip_one": "{{count}} sold via ads",
            "badgeTooltip_other": "{{count}} sold via ads",
            "costs": "Costs",
            "empty": "No ad sales in this period",
            "salesShare": "{{share}} of all sales",
            "stat": "Ad revenue"
        },
        "buyBox": {
            "anonymous": "Anonymous",
            "competitor": "Competitor",
            "empty": "No changes in this period",
            "lost": "Buy box lost",
            "won": "Buy box won",
            "yourPrice": "Your price"
        },
        "comparison": {
            "dayBefore": "Day before",
            "monthBefore": "Month before",
            "periodBefore": "Period before",
            "weekBefore": "Week before"
        },
        "kpi": {
            "adSpend": "Ad spend",
            "adsRevenue": "Revenue via ads",
            "error": "The statistics could not be loaded",
            "mailsSent": "Mails sent",
            "margin": "Profit margin",
            "orders": "Number of orders",
            "organicRevenue": "Organic revenue",
            "profit": "Profit",
            "returnRate": "Return %",
            "returns": "Returns",
            "revenue": "Revenue",
            "revenueExclVat": "Revenue (excl. VAT)",
            "reviewClicks": "Review clicks",
            "reviews": "New reviews",
            "shareOfTotal": "% of total revenue",
            "uploads": "Invoices uploaded"
        },
        "loadMore": "Load more",
        "lowStock": {
            "badge_one": "{{count}} item in stock",
            "badge_other": "{{count}} items in stock",
            "empty": "No products with low stock"
        },
        "period": {
            "month": "Month",
            "week": "Week",
            "yesterday": "Yesterday"
        },
        "returns": {
            "badgeTooltip": "Return",
            "empty": "No returns in this period",
            "quantity_one": "{{count}} item returned",
            "quantity_other": "{{count}} items returned"
        },
        "reviews": {
            "empty": "No new reviews in this period"
        },
        "sectionError": "This section could not be loaded",
        "sections": {
            "adRevenue": "Bought via ads",
            "buyBox": "Buy box changes",
            "lowStock": "Low stock",
            "returns": "Returns",
            "reviews": "Latest reviews",
            "topProducts": "Best selling products"
        },
        "stat": {
            "profit": "Profit",
            "revenue": "Revenue"
        },
        "topProducts": {
            "empty": "No sales in this period yet",
            "soldTooltip_one": "{{count}} sold",
            "soldTooltip_other": "{{count}} sold"
        },
        "welcome": "Welcome back! 👋",
        "welcomeNamed": "Welcome back, {{name}}! 👋",
        "welcomeSubtitle": "Here is the overview of your sales and performance"
    },
    "edit": "Edit",
    "exportError": "Something went wrong while exporting the data.",
    "profitInfo": "Profit is only calculated for products that have costs set up."
}
